// src/views/BOM/CreateBomPage.js
import React, { useEffect, useMemo, useRef, useState, useCallback, useContext } from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { useParams, useLocation, Link  } from 'react-router-dom';
import Spinner from 'components/Spinner';
import moment from 'moment';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import MaterialTable from 'material-table';
import CreatableSelect from 'react-select/creatable';
import jsPDF from 'jspdf';  
import AuthContext from 'context/AuthProvider';
import {
    ThemeProvider,
    createTheme,
    Paper,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip,
    IconButton,
    LinearProgress,
    Box,
    Typography,
    Chip,
    FormControlLabel,
    Checkbox,
    List,
    ListItem,
    ListItemIcon,
    ListSubheader,
    ListItemText,
    Divider,
    Grid,
    Switch,
    FormControl,
    RadioGroup,
    Radio,
    CircularProgress,
    } from '@mui/material';
import ShowToast from 'components/ShowToast';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL, BOM_STAGES, FONT_FAMILY} from 'assets/constants/Constants';
import {
    FactCheckIcon,
    SendIcon,
    EYE_ICON,
    VisibilityIcon,
    CheckCircleSharpIcon,
    AddBoxIcon,
    CloudUploadIcon,
    DeleteForeverIcon,
    CALENDER_ICON,
    FILE_ICON,
    DownloadIcon,
    CalendarMonthIcon,
    OnlinePredictionIcon,
    WarningAmberIcon,
    AdsClickRoundedIcon,
    ZoomInIcon,
    ZoomOutIcon,
    RestartAltIcon,
    HistoryIcon,
    CircleIcon,
    CancelIcon,
    FormatListNumberedIcon,
    ExpandMoreIcon,
    DescriptionIcon,
    LocalShippingIcon
} from 'assets/constants/Icons';
import { LOG_TEXT, MODULE_NAMES } from 'assets/constants/Constants';

import {
    getPartList,
    getStdProcessList,
    getBusinessVerticalList,
    getRegionList,
    getCustomerList,
    createBOM,
    getBomById,
    updateBOM,
    pauseBom,
    resumeBom,
    getUserDetails,
    updatestepfrombom,
    updateProcurementStatus,
    getS3PresignedUrl,
    uploadDocumentBucket,
    downloadDocumentBucket,
    getRawmaterialByOdandMaterial,
    createHistoryList,
    getUserByRole,
    createParts,
    splitBomItemToPlanning,
    searchPartsByDocNo,
    rejectBomItem,
    getBomHistoryLogs,
    downloadAllBomAttachments,
    getBomFormOptions,
    downloadDispatchAttachments,
    getPODetailsForBom,
} from 'lib/axiosUtils';
import ProcurementDetailPanel from './ProcurementDetailPanel'; // NEW: Import the refactored component

import InputMask from 'react-input-mask';
import { HTTP_HEADER_KEYS, HTTP_CONTENT_TYPES } from 'assets/constants/apiConstants';

import './bom.css';
import BomProgressBar from './BomProgressBar';
import { defaultFormatDate } from 'lib/utils';
import { hasPermission } from 'components/Permission';
import { DESIGN_ENGINEER, PROCUREMENT_ENGINEER, MANUFACTURING_ENGINEER, SUPER_ADMIN, SUPPLIER, PROCUREMENT_SOURCE, STEP_STATUS, LOGISTIC } from 'assets/constants/Constants';
import Case1Image from 'assets/images/case1.jpg';
import Case2Image from 'assets/images/case2.jpg'; 
import Case3Image from 'assets/images/case3.jpg'; 
import Case4Image from 'assets/images/case4.jpg'; 
import Case5Image from 'assets/images/case5.jpg'; 
import SupplierInvoicePanel from './components/SupplierInvoicePanel';
import CommercialInvoicePanel from './components/CommercialInvoicePanel';
import SourceSansProRegular from 'assets/fonts/SourceSansPro-Regular.ttf';
import { Description, LocationSearching, PlayCircleFilled, PauseCircleFilled } from '@mui/icons-material';
import { 
    Accordion, 
    AccordionSummary, 
    AccordionDetails 
} from '@mui/material';
import DeliverySchedule from 'components/DeliverySchedule';
import ValidationPanel from './components/ValidationPanel';
import { SALES } from 'assets/constants/Constants';
const idOf = (x) => (x?.$oid || x?._id || (typeof x === 'string' ? x : x?.toString?.()))?.trim();

/* -------------------------- small utility -------------------------- */
function useDebounced(fn, delay = 300) {
    const t = useRef();
    return useCallback(
        (...args) => {
            clearTimeout(t.current);
            return new Promise((resolve) => {
                t.current = setTimeout(async () => {
                    resolve(await fn(...args));
                }, delay);
            });
        },
        [fn, delay]
    );
}


const addDaysSkipSundays = (startDateStr, daysToAdd) => {
    if (!startDateStr || isNaN(new Date(startDateStr)) || !Number.isFinite(daysToAdd)) {
        return null;
    }
    
    let currentDate = new Date(startDateStr);

    if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
    }

    let daysAdded = 0;

    if (daysToAdd <= 0) {
        return currentDate;
    }

    while (daysAdded < daysToAdd) {
        currentDate.setDate(currentDate.getDate() + 1);
        if (currentDate.getDay() !== 0) {
            daysAdded++;
        }
    }
    return currentDate;
};

const CreateBomPage = (props) => {
    /* ---------------- 1) ROUTE PARAM + MOUNT GUARD ---------------- */
    const { id: routeBomId } = useParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedPoIdFromUrl = queryParams.get('poId');

    const mountedRef = useRef(true);
    const openPanelRef = useRef({ id: null, toggle: null });
    useEffect(
        () => () => {
            mountedRef.current = false;
        },
        []
    );

    const authcontect = useContext(AuthContext);
    /* ---------------- 2) STATE ---------------- */
    // user
    const initialUser =
        props?.auth?.user || JSON.parse(localStorage.getItem('userData') || 'null') || {};



    const [designEngineerName, setDesignEngineerName] = useState(
        `${initialUser.first_name || ''} ${initialUser.last_name || ''}`.trim() ||
            initialUser.name ||
            ''
    );
    const [designEngineerId] = useState(initialUser._id || initialUser.id || null);

    const[currentbomid, setCurrentBomId] = useState(""); 
    const [bomData, setBomData] = useState({});

    const [listsLoaded, setListsLoaded] = useState(false);

    const [bomLoaded, setBomLoaded] = useState(!routeBomId);
    const [labelsResolved, setLabelsResolved] = useState(!routeBomId);
    const [dispatchRemarks, setDispatchRemarks] = useState("");

    // form
    const [fixtureDocNo, setFixtureDocNo] = useState('');
    const [fixtureName, setFixtureName] = useState('');
    const [endClient, setEndClient] = useState('');
    const [mfgReleaseDate, setMfgReleaseDate] = useState(moment().format('YYYY-MM-DD'));
    const [customer, setCustomer] = useState(null);
    const [machine, setMachine] = useState('');
    const [drawingNumbers, setDrawingNumbers] = useState([]);
    const [poRef, setPoRef] = useState('');
    const [selectedPoId, setSelectedPoId] = useState(selectedPoIdFromUrl || '');
    const [poViewOpen, setPoViewOpen] = useState(false);
    const [selectedPoDetails, setSelectedPoDetails] = useState(null);
    const [enquiryIdForLink, setEnquiryIdForLink] = useState('');
    const [dapDate, setDapDate] = useState(moment().format('YYYY-MM-DD'));
    const [surfaceTreatmentType, setSurfaceTreatmentType] = useState('');
    const [businessVertical, setBusinessVertical] = useState(null);
    const [region, setRegion] = useState(null);
    const [allSalesUsers, setAllSalesUsers] = useState([]);
    const [selectedSalesUser, setSelectedSalesUser] = useState(null);
    const [assignedSupplier, setAssignedSupplier] = useState(null); // <--- ADD THIS

    // picklists
    const [parts, setParts] = useState([]);
    const [stdProcesses, setStdProcesses] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [businessVerticals, setBusinessVerticals] = useState([]);
    const [regions, setRegions] = useState([]);
    const [uploadingRow, setUploadingRow] = useState(null);
    const [uploadProgress, setUploadProgress] = useState({});
    const [isCommentDialogOpen, setIsCommentDialogOpen] = useState(false);
    const [approvalComment, setApprovalComment] = useState("");
    const [pendingNextStage, setPendingNextStage] = useState(null);
    // items
    const [items, setItems] = useState([]);

    //for the approval dialog
    const [isApprovalDialogOpen, setApprovalDialogOpen] = useState(false);
    // const [approvalChecks, setApprovalChecks] = useState({
    //     drawingsFinalized: false,
    //     specsVerified: false,
    //     quantitiesConfirmed: false,
    // });
const [approvalChecks, setApprovalChecks] = useState({
        q1: false,
        q2: false,
        q3: false,
        q4: {
            sub: [false, false, false, false, false]
        },
        q5: false,
        q6: {
            sub: [false, false, false, false]
        },
        q7: {
            sub: [false, false, false, false]
        },
        q8: false,
        q9: {
            isExport: false, // Default to false (No)
            sub: [false, false]
        }
    });

    const [originalInventory, setOriginalInventory] = useState([]);
    const [inventoryLoading, setInventoryLoading] = useState(false);
    const [inventoryError, setInventoryError] = useState(null);

    const [bomCode, setBomCode] = useState('');

    // ==== BOM-level Testing & Dispatch state ====
const [bomTestingDlgOpen, setBomTestingDlgOpen] = useState(false);

    const isGlobalReadOnly = useMemo(() => {
        return bomData.current_stage === BOM_STAGES.COMPLETED || bomData.current_stage === BOM_STAGES.VALIDATION;
    }, [bomData.current_stage]);

    const isReadOnly = useMemo(() => {
        const isSuperAdmin = initialUser.user_role === SUPER_ADMIN;
         if (isSuperAdmin) return false;
        return !hasPermission("bom", "edit_form") || isGlobalReadOnly;
    }, [initialUser, isGlobalReadOnly]);

    const canViewFormHeader = useMemo(() => {
        return hasPermission("bom", "view_form_header");
    }, [initialUser]);


    const canEditTestingAndDispatch = useMemo(() => {
        if (isGlobalReadOnly) return false;
        return initialUser.user_role === SUPER_ADMIN || initialUser.user_role === MANUFACTURING_ENGINEER;
    }, [initialUser.user_role, isGlobalReadOnly]);

    const canEditLogisticsChecklist = useMemo(() => {
        if (isGlobalReadOnly) return false;
        return initialUser.user_role === SUPER_ADMIN || initialUser.user_role === LOGISTIC;
    }, [initialUser.user_role, isGlobalReadOnly]);
const [bomTestingRemark, setBomTestingRemark] = useState('');
const [bomTestingFilesDraft, setBomTestingFilesDraft] = useState([]); // File[]
const [bomTestingAttachments, setBomTestingAttachments] = useState([]); // [{file_name,file_type,file_url,file_key}]
const [bomTestingDone, setBomTestingDone] = useState(false);
const [testReportApprovedDate, setTestReportApprovedDate] = useState(null);
const [testReportApprovedBy, setTestReportApprovedBy] = useState(null);
const [bomDispatchReady, setBomDispatchReady] = useState(false);

const [isDispatchChecklistOpen, setIsDispatchChecklistOpen] = useState(false);
const [isDispatchChecklistOpen2, setIsDispatchChecklistOpen2] = useState(false);

const [bomDispatchRemark, setBomDispatchRemark] = useState('');
const [dispatchChecks, setDispatchChecks] = useState({
    documents: [false, false, false],
    visuals: [false, false, false, false, false],
});

const [finalDispatchChecks, setFinalDispatchChecks] = useState({
    documents: {
        test_report: false,
        packing_list: false,
        approved_dap_layout: false,
        invoice: false,
        delivery_challan: false
    },
    visual_checks: {
        correct_box_selection: false,
        bubble_wrap: false,
        no_material_contact: false,
        no_loose_movement: false,
        packing_strip: false
    },
    dispatch_checklist_attachments: [] 
});


const [bomUploading, setBomUploading] = useState(false);
const [bomUploadPct, setBomUploadPct] = useState(0);

const [bomDispatchAttachments, setBomDispatchAttachments] = useState([]);
const [bomDispatchFilesDraft, setBomDispatchFilesDraft] = useState([]);
const [bomDispatchUploading, setBomDispatchUploading] = useState(false);
const [bomDispatchUploadPct, setBomDispatchUploadPct] = useState(0);

const [fixtureLocation, setFixtureLocation] = useState('');
const [isLocationDialogOpen, setIsLocationDialogOpen] = useState(false);
const [isCompleteDispatchDialogOpen, setIsCompleteDispatchDialogOpen] = useState(false);

const [bomTestingBufferDays, setBomTestingBufferDays] = useState(2);

const defaultTestReport = {
    selected_case: '',
    
    table_radial_runout: '',
    table_axial_runout: '',

    // --- Optional Inputs (Cases 3, 4, 5) ---
    adapter_height_piece_radial_runout: '',
    adapter_height_piece_axial_runout: '',
    tailstock_runout: '',
    tailstock_alignment: '',

    // --- Clamping Inputs ---
    clamping_pressure: '', // Cases 1, 2, 3, 4
    tailstock_clamping_force: '', // Cases 3, 4, 5

    // --- Case 1 Specific ---
    runout_control_arbor: { radial: '', axial: '' },

    // --- Case 2 Specific ---
    runout_control_ring: { radial: '', axial: '' },

    // --- Case 3 Specific ---
    control_ring_kl_master_radial: '',
    control_ring_kl_master_axial: '',

    // --- Case 4 Specific ---
    radial_bottom_center: '',

    // --- Case 5 Specific ---
    radial_friction_cone: '',

    // --- Shared Fields (Defined Once) ---
    radial_collet_location_taper: '', // (Cases 3, 4)
    control_arbor_kl_master_radial: '', // (Cases 4, 5)
    control_arbor_kl_master_axial: '', // (Cases 4, 5)

    // --- Common Fields (All Cases) ---
    remarks: '',
    attachments: [],
};

const [testReport, setTestReport] = useState(defaultTestReport);
const [testReportErrors, setTestReportErrors] = useState({});
const [imageZoom, setImageZoom] = useState(1); // <-- ADD THIS LINE



const [isSupplierDialogOpen, setSupplierDialogOpen] = useState(false);
const [selectedSupplier, setSelectedSupplier] = useState(null);
const [supplierUsers, setSupplierUsers] = useState([]);

const [projectedCompletionDate, setProjectedCompletionDate] = useState(null);
const [isSaving, setIsSaving] = useState(false);

const [dapAttachments, setDapAttachments] = useState([]);
const [dapUploading, setDapUploading] = useState(false);
const [dapUploadPct, setDapUploadPct] = useState(0);

const [historyLogs, setHistoryLogs] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false)

const openBomTesting = () => setBomTestingDlgOpen(true);
const closeBomTesting = () => {
    setBomTestingDlgOpen(false);
    setTestReportErrors({});
}
const [isZipDownloading, setIsZipDownloading] = useState(false);

//supplier invoice & logistics
const [supplierInvoiceDetails, setSupplierInvoiceDetails] = useState({
    invoice_number: '',
    invoice_value: 0,
    awb_number: '',
    courier_agency: '',
    invoice_file: []
});

//Commercial Details
const [commercialDetails, setCommercialDetails] = useState({
    klin_invoice_number: '',
    agreed_delivery_terms: '',
    dispatch_comments: '',
    kl_invoice_file: [],
    other_commercial_attachments: []
});


const handleSupplierUpdate = useCallback((newData) => {
    setSupplierInvoiceDetails(prev => ({ ...prev, ...newData }));
}, []);
const handleCommercialUpdate = useCallback((newData) => {
    setCommercialDetails(prev => ({ ...prev, ...newData }));
}, []);

//Test report
const handleTestReportChange = (path, value) => {
    if (path === 'selected_case') {
        const newCase = value;
        setTestReportErrors({});

        setTestReport((prev) => {
            const newReport = {
                ...defaultTestReport, 
                selected_case: newCase, 
                remarks: prev.remarks, 
                attachments: prev.attachments || [], 
            };
            return newReport;
        });

    } else {
        setTestReport((prev) => {
            const keys = path.split('.');
            if (keys.length === 1) {
                return { ...prev, [path]: value };
            }

            const newReport = JSON.parse(JSON.stringify(prev));
            let current = newReport;
            for (let i = 0; i < keys.length - 1; i++) {
                current[keys[i]] = current[keys[i]] || {};
                current = current[keys[i]];
            }
            current[keys[keys.length - 1]] = value;
            return newReport;
        });
    }
};

const validateTestReport = useCallback(() => {
    const { selected_case, ...report } = testReport;
    
    const newErrors = {};

    if (!selected_case) {
        ShowToast('Please select a test report case.', TYPE_FAIL, INTERVAL, null, "");
        return false; 
    }
    if (selected_case === 'Special Case') {
        setTestReportErrors({}); 
        return true; 
    }
    const setErr = (path, message) => {
        const keys = path.split('.');
        let current = newErrors;
        for (let i = 0; i < keys.length - 1; i++) {
            current[keys[i]] = current[keys[i]] || {};
            current = current[keys[i]];
        }
        current[keys[keys.length - 1]] = message;
    };

    const check = (field, label) => {
        const keys = field.split('.');
        let value = report;
        try {
            for (const key of keys) {
                value = value[key];
            }
        } catch (e) {
            value = undefined;
        }

        if (value === null || value === undefined || String(value).trim() === '') {
            setErr(field, `${label} is required.`);
        }
    };

    // --- Common fields ---
    // check('table_radial_runout', 'Table radial runout');
    // check('table_axial_runout', 'Table axial runout');

    // if (['Case 1', 'Case 2', 'Case 3', 'Case 4'].some(c => selected_case.startsWith(c))) {
    //     check('clamping_pressure', 'Clamping Pressure');
    // }
    // if (['Case 3', 'Case 4', 'Case 5'].some(c => selected_case.startsWith(c))) {
    //     check('tailstock_runout', 'Tailstock runout');
    //     check('tailstock_alignment', 'Tailstock alignment');
    //     check('tailstock_clamping_force', 'Tailstock Clamping Force');
    // }

    // --- Case-specific fields ---
    if (selected_case.startsWith('Case 1')) {
        check('runout_control_arbor.radial', 'Radial Runout');
        check('runout_control_arbor.axial', 'Axial Runout');
    } else if (selected_case.startsWith('Case 2')) {
        check('runout_control_ring.radial', 'Radial Runout');
        check('runout_control_ring.axial', 'Axial Runout');
    } else if (selected_case.startsWith('Case 3')) {
        // check('radial_collet_location_taper', 'Radial Runout on Collet Location Taper');
        check('control_ring_kl_master_radial', 'Radial Runout (Control Ring/KL Master)');
        check('control_ring_kl_master_axial', 'Axial Runout (Control Ring/KL Master)');
    } else if (selected_case.startsWith('Case 4')) {
        // check('radial_collet_location_taper', 'Radial Runout on Collet Location Taper');
        // check('radial_bottom_center', 'Radial Runout on Bottom Center');
        check('control_arbor_kl_master_radial', 'Radial Runout (Control Arbor/KL Master)');
        check('control_arbor_kl_master_axial', 'Axial Runout (Control Arbor/KL Master)');
    } 
    // else if (selected_case.startsWith('Case 5')) {
    //     // check('radial_friction_cone', 'Radial Runout on Friction Cone');
    //     // check('control_arbor_kl_master_radial', 'Radial Runout (Control Arbor/KL Master)');
    //     // check('control_arbor_kl_master_axial', 'Axial Runout (Control Arbor/KL Master)');
    // }

    setTestReportErrors(newErrors);
    
    if (Object.keys(newErrors).length > 0) {
        ShowToast('Please fill all mandatory fields.', TYPE_FAIL, INTERVAL, null, "");
        return false;
    }

    return true;
}, [testReport, setTestReportErrors]);

const getBase64ImageFromUrl = (url) => {
    return new Promise((resolve, reject) => {
        if (!url) { resolve(null); return; }
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
            const dataURL = canvas.toDataURL(`image/${ext === 'png' ? 'png' : 'jpeg'}`);
            resolve({
                dataUrl: dataURL,
                width: img.width,
                height: img.height
            });
        };
        img.onerror = (error) => {
            console.warn("Could not load logo:", url);
            resolve(null); 
        };
        img.src = url;
    });
}; 

const getFontBase64 = async (url) => {
    try {
        const response = await fetch(url);
        const buffer = await response.arrayBuffer();
        let binary = '';
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    } catch (error) {
        console.error("Error loading font:", error);
        return null;
    }
};

const handleDownloadTestReport = async (returnBlob = false, explicitApproverUser = null, isUpload = false) => {    
    if (!testReport.selected_case) {
        ShowToast('Please select a case first', TYPE_FAIL, INTERVAL, null, "");
        return;
    }



    const logoUrl = authcontect.BRAND_LOGO;
    const caseImgUrl = caseImageMap[testReport.selected_case];
    const [logoData, caseImageData, fontBase64] = await Promise.all([
        getBase64ImageFromUrl(logoUrl),
        caseImgUrl ? getBase64ImageFromUrl(caseImgUrl) : Promise.resolve(null),
        getFontBase64(SourceSansProRegular)
    ]);

    // --- 2. SETUP PDF ---
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 15;
    
    const colorPrimary = [45, 61, 66];
    const colorLightGray = [248, 248, 248];
    const colorBorder = [220, 220, 220];

    let yPos = 15;

    if (logoData && logoData.dataUrl) {
        const logoHeight = 24;      
        const marginBottom = 10;    
        const logoY = 5;           
        
        const aspectRatio = logoData.width / logoData.height;
        const logoWidth = logoHeight * aspectRatio;

        doc.addImage(logoData.dataUrl, 'JPEG', marginX, logoY, logoWidth, logoHeight);

        yPos = logoY + logoHeight + marginBottom;
    }



    if (fontBase64) {
        doc.addFileToVFS('SourceSansPro-Regular.ttf', fontBase64);
        doc.addFont('SourceSansPro-Regular.ttf', 'Source Sans Pro', 'normal');
        doc.setFont("Source Sans Pro");
    } else {
        doc.setFont("Source Sans Pro"); // Fallback if load fails (might still work if system has it, or fail)
    }

    doc.setFontSize(16);
    doc.setTextColor(...colorPrimary);
    doc.text("TEST REPORT", pageWidth - marginX, 18, { align: 'right' });

    doc.setFont("Source Sans Pro");
    doc.setFontSize(9);
    doc.setTextColor(100, 100, 100);
    const approvedDateStr = testReportApprovedDate ? moment(testReportApprovedDate).format('DD-MMM-YYYY') : 'Draft Report';
    doc.text(`Approved Date: ${approvedDateStr}`, pageWidth - marginX, 23, { align: 'right' });

    yPos = 30;
    doc.setDrawColor(...colorPrimary);
    doc.setLineWidth(0.5);
    doc.line(marginX, yPos, pageWidth - marginX, yPos);
    yPos += 8;

    const col1X = marginX;
    const col2X = pageWidth / 2 + 10;
    
    const printDetailRow = (label1, val1, label2, val2) => {
        doc.setFontSize(10);
        doc.setFont("Source Sans Pro");
        doc.setTextColor(...colorPrimary);
        doc.text(label1, col1X, yPos);
        doc.setFont("Source Sans Pro");
        doc.setTextColor(0, 0, 0);
        doc.text(val1 || '-', col1X + 35, yPos);

        if (label2) {
            doc.setFont("Source Sans Pro");
            doc.setTextColor(...colorPrimary);
            doc.text(label2, col2X, yPos);
            doc.setFont("Source Sans Pro");
            doc.setTextColor(0, 0, 0);
            doc.text(val2 || '-', col2X + 35, yPos);
        }
        yPos += 7;
    };

    let displayCase = testReport.selected_case;
    if (displayCase.includes(':')) displayCase = displayCase.substring(displayCase.indexOf(':') + 1).trim();

    printDetailRow("Fixture Name:", fixtureName, "Test Case:", displayCase);
    printDetailRow("Document No:", fixtureDocNo);
    
    yPos += 5; 

    

    const totalContentWidth = pageWidth - (marginX * 2);
    const tableWidth = totalContentWidth * 0.45;
    const imageWidth = totalContentWidth * 0.50;
    const columnGap = totalContentWidth * 0.05;
    const imageX = marginX + tableWidth + columnGap;
    
    const startSectionY = yPos; 

    
    let rowCount = 0;

    const printSectionHeader = (title) => {
        if (yPos > pageHeight - 30) { doc.addPage(); yPos = 20; }
        
        doc.setFillColor(...colorPrimary);
        doc.rect(marginX, yPos, tableWidth, 6, 'F'); 
        
        doc.setFont("Source Sans Pro");
        doc.setFontSize(10);
        doc.setTextColor(255, 255, 255);
        doc.text(title, marginX + 3, yPos + 4.5);
        
        yPos += 6;
        rowCount = 0;
    };

    const printTableRow = (label, value, unit = 'µm') => {
        if (yPos > pageHeight - 25) { doc.addPage(); yPos = 20; }
        
        if (rowCount % 2 !== 0) doc.setFillColor(...colorLightGray);
        else doc.setFillColor(255, 255, 255);
        doc.rect(marginX, yPos, tableWidth, 6, 'F');
        doc.setDrawColor(230);
        doc.setLineWidth(0.1);
        doc.rect(marginX, yPos, tableWidth, 6); 

        const valColX = marginX + (tableWidth * 0.65);
        const unitColX = marginX + (tableWidth * 0.75);

        doc.setFont("Source Sans Pro");
        doc.setFontSize(9);
        doc.setTextColor(50, 50, 50);
        doc.text(label, marginX + 3, yPos + 4.5);

        doc.setFont("Source Sans Pro");
        doc.setTextColor(0, 0, 0);
        const valStr = (value !== undefined && value !== null && value !== '') ? String(value) : '-';
        doc.text(valStr, valColX, yPos + 4.5);
        doc.setFont("Source Sans Pro");
        doc.setFontSize(8);
        doc.setTextColor(100, 100, 100);
        doc.text(unit || '', unitColX, yPos + 4.5);

        yPos += 6;
        rowCount++;
    };

    printSectionHeader("Input Conditions");
    printTableRow("Table radial runout", testReport.table_radial_runout);
    printTableRow("Table axial runout", testReport.table_axial_runout);

    if (['Case 3', 'Case 4', 'Case 5'].some(c => testReport.selected_case.startsWith(c))) {
        if(testReport.adapter_height_piece_radial_runout) 
            printTableRow("Adapter/Height Piece rad.", testReport.adapter_height_piece_radial_runout);
        if(testReport.adapter_height_piece_axial_runout) 
            printTableRow("Adapter/Height Piece ax.", testReport.adapter_height_piece_axial_runout);
        
        printTableRow("Tailstock runout", testReport.tailstock_runout);
        printTableRow("Tailstock alignment", testReport.tailstock_alignment);
    }

    if (['Case 1', 'Case 2', 'Case 3', 'Case 4'].some(c => testReport.selected_case.startsWith(c))) {
        printTableRow("Clamping Pressure", testReport.clamping_pressure, 'bar');
    }
    if (['Case 3', 'Case 4', 'Case 5'].some(c => testReport.selected_case.startsWith(c))) {
        printTableRow("Tailstock Clamping Force", testReport.tailstock_clamping_force, 'kN');
    }

    yPos += 4; 

    if (testReport.selected_case.startsWith('Case 1')) {
        printSectionHeader("Runout on Control Arbor");
        printTableRow("Radial Runout", testReport.runout_control_arbor?.radial);
        printTableRow("Axial Runout", testReport.runout_control_arbor?.axial);
    } 
    else if (testReport.selected_case.startsWith('Case 2')) {
        printSectionHeader("Runout on Control Ring");
        printTableRow("Radial Runout", testReport.runout_control_ring?.radial);
        printTableRow("Axial Runout", testReport.runout_control_ring?.axial);
    }
    else if (testReport.selected_case.startsWith('Case 3')) {
        printSectionHeader("Runout on Fixture");
        printTableRow("Radial (Collet Loc Taper)", testReport.radial_collet_location_taper);
        
        yPos += 2;
        printSectionHeader("Runout Control Ring/Master");
        printTableRow("Radial Runout", testReport.control_ring_kl_master_radial);
        printTableRow("Axial Runout", testReport.control_ring_kl_master_axial);
    }
    else if (testReport.selected_case.startsWith('Case 4')) {
        printSectionHeader("Runout on Fixture");
        printTableRow("Radial (Collet Loc Taper)", testReport.radial_collet_location_taper);
        printTableRow("Radial (Bottom Center)", testReport.radial_bottom_center);

        yPos += 2;
        printSectionHeader("Runout Control Arbor/Master");
        printTableRow("Radial Runout", testReport.control_arbor_kl_master_radial);
        printTableRow("Axial Runout", testReport.control_arbor_kl_master_axial);
    }
    else if (testReport.selected_case.startsWith('Case 5')) {
        printSectionHeader("Runout on Fixture");
        printTableRow("Radial (Friction Cone)", testReport.radial_friction_cone);

        yPos += 2;
        printSectionHeader("Runout Control Arbor/Master");
        printTableRow("Radial Runout", testReport.control_arbor_kl_master_radial);
        printTableRow("Axial Runout", testReport.control_arbor_kl_master_axial);
    }

    const finalTableY = yPos; 

    let finalImageY = startSectionY;

    if (caseImageData && caseImageData.dataUrl) {
        let imgBoxHeight = Math.max(60, finalTableY - startSectionY); 
        if (imgBoxHeight > 100) imgBoxHeight = 100; 

        doc.setDrawColor(200);
        doc.rect(imageX, startSectionY, imageWidth, imgBoxHeight); 
        
        const ratio = Math.min(imageWidth / caseImageData.width, imgBoxHeight / caseImageData.height);
        const finalW = caseImageData.width * ratio;
        const finalH = caseImageData.height * ratio;
        const xCent = imageX + (imageWidth - finalW) / 2;
        const yCent = startSectionY + (imgBoxHeight - finalH) / 2;

        doc.addImage(caseImageData.dataUrl, 'JPEG', xCent, yCent, finalW, finalH);
        
        doc.setFontSize(8);
        doc.setTextColor(150);
        doc.text("Reference Image", imageX + 2, startSectionY + imgBoxHeight - 2);

        finalImageY = startSectionY + imgBoxHeight;
    }

    yPos = Math.max(finalTableY, finalImageY) + 10;
    const contentMaxWidth = pageWidth - (marginX * 2);

    if (testReport.remarks) {
        if (yPos > pageHeight - 50) { doc.addPage(); yPos = 20; }

        doc.setFont("Source Sans Pro");
        doc.setFontSize(10);
        doc.setTextColor(...colorPrimary);
        doc.text("Remarks / Comments:", marginX, yPos);
        yPos += 4;

        doc.setFont("Source Sans Pro");
        doc.setFontSize(9);
        doc.setTextColor(0, 0, 0);
        
        const splitRemarks = doc.splitTextToSize(testReport.remarks, contentMaxWidth - 4);
        const dims = doc.getTextDimensions(splitRemarks);
        const boxHeight = Math.max(15, dims.h + 10);

        doc.setDrawColor(220);
        doc.setFillColor(252, 252, 252);
        doc.rect(marginX, yPos, contentMaxWidth, boxHeight, 'FD');

        doc.text(splitRemarks, marginX + 2, yPos + 5);
        
    }

    const footerY = pageHeight - 20;

    let approvedByName = '—';
    if (explicitApproverUser) {
        const first = explicitApproverUser.first_name || explicitApproverUser.firstName || '';
        const last = explicitApproverUser.last_name || explicitApproverUser.lastName || '';
        approvedByName = `${first} ${last}`.trim();
    } else {
            let approvedUserId = bomData?.test_report?.approved_by?.user_id;
            if (approvedUserId) {
                 console.log("Approved User ID:", approvedUserId);
                try {
                    const res = await getUserDetails({}, {}, approvedUserId);
                    const user = res?.data?.result;
                    if (user) {
                        const first = user.first_name || '';
                        const last = user.last_name || '';
                        approvedByName = `${first} ${last}`.trim() || "Authorized Signatory";
                    } else {
                        approvedByName = "Authorized Signatory"; 
                    }
                } catch(e){}
            }
    }

    doc.setDrawColor(...colorBorder);
    doc.line(marginX, footerY, pageWidth - marginX, footerY);

    doc.setFontSize(10);
    doc.setFont("Source Sans Pro");
    doc.setTextColor(...colorPrimary);
    doc.text("Approved by:", marginX, footerY - 6);

    doc.setFont("Source Sans Pro");
    doc.setTextColor(0, 0, 0);
    doc.text(approvedByName, marginX + 25, footerY - 6);

    const bottomMetaY = pageHeight - 10;
    doc.setFontSize(8);
    doc.setTextColor(120);
    doc.text(fixtureDocNo || 'Draft', marginX, bottomMetaY);
    const currentUser = JSON.parse(localStorage.getItem('userData'));
    const downloadedByName = currentUser ? `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim() : 'User';
    const dateLabel = isUpload ? "Created on" : "Downloaded on";
    const dateValue = moment().format('DD-MMM-YYYY HH:mm:ss');
    doc.text(`${dateLabel}: ${dateValue} | ${downloadedByName}`, pageWidth / 2, bottomMetaY, { align: 'center' });

    const rightText = `${bomCode || ''}  |  Page 1 of 1`;
    doc.text(rightText, pageWidth - marginX, bottomMetaY, { align: 'right' });

    const fileName = `Test_Report_${fixtureDocNo || 'Draft'}.pdf`;

    if (returnBlob) {
        return {
            blob: doc.output('blob'),
            fileName: fileName
        };
    } else {
        doc.save(fileName);
    }
};
const handleZoomIn = () => setImageZoom(prev => Math.min(prev * 1.2, 5)); 
const handleZoomOut = () => setImageZoom(prev => Math.max(prev / 1.2, 0.5)); 
const handleZoomReset = () => setImageZoom(1);


// Upload selected draft files -> push to BOM-level attachments
const uploadBomTestingFiles = useCallback(async (files) => {
  if (!files?.length) return;
  setBomUploading(true);
  try {
    const uploaded = [];
    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      const pres = await getS3PresignedUrl({}, { // uses your existing helper
        fileName: f.name,
        fileType: f.type || 'application/octet-stream',
      }); // :contentReference[oaicite:1]{index=1}
      const putUrl = pres?.data?.url;
      const publicUrl = pres?.data?.fileUrl;
      if (!putUrl || !publicUrl) throw new Error('Failed to get upload URL');

      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', putUrl, true);
        xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, f.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
        xhr.upload.onprogress = (e) => {
          if (e.lengthComputable) setBomUploadPct(Math.round((e.loaded / e.total) * 100));
        };
        xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
        xhr.onerror = () => reject(new Error('Network error during upload'));
        xhr.send(f);
      });

      let file_key = '';
      try {
        const u = new URL(putUrl);
        const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
        const at = path.indexOf('uploads/');
        file_key = at >= 0 ? path.substring(at) : path;
      } catch {}

      uploaded.push({
        file_name: f.name,
        file_type: f.type || '',
        file_url: publicUrl,
        file_key,
      });
    }
    setTestReport(prev => ({
    ...prev,
    attachments: [...(prev.attachments || []), ...uploaded]
}));
    setBomTestingDone(true);
  } catch (e) {
    console.error(e);
    ShowToast('Upload failed', TYPE_FAIL, INTERVAL, null, "");
  } finally {
    setBomUploading(false);
    setBomUploadPct(0);
  }
}, []);

const removeBomTestingAttachment = useCallback((idx) => {
    setTestReport(prev => {
        const currentAttachments = prev.attachments || [];
        const newAttachments = currentAttachments.filter((_, i) => i !== idx);
        return {
            ...prev,
            attachments: newAttachments
        };
    });
}, []);

const uploadSingleFile = async (file, onProgress) => { // Added onProgress parameter
    // Get Presigned URL
    const pres = await getS3PresignedUrl({}, { 
        fileName: file.name, 
        fileType: file.type || 'application/octet-stream' 
    });
    
    const putUrl = pres?.data?.url;
    const publicUrl = pres?.data?.fileUrl;

    if (!putUrl || !publicUrl) throw new Error(`Failed to get upload URL for ${file.name}`);

    // Perform Upload
    await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', putUrl, true);
        xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, file.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
        
        // --- FIX START: Add progress listener ---
        if (onProgress) {
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    onProgress(e.loaded);
                }
            };
        }
        // --- FIX END ---
        
        xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error('Upload failed')));
        xhr.onerror = () => reject(new Error('Network error'));
        xhr.send(file);
    });

    // Extract File Key
    let file_key = '';
    try {
        const u = new URL(putUrl);
        const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
        const at = path.indexOf('uploads/');
        file_key = at >= 0 ? path.substring(at) : path;
    } catch (e) { console.error(e); }

    return {
        file_name: file.name,
        file_type: file.type || '',
        file_url: publicUrl,
        file_key,
        uploaded_at: new Date()
    };
};
const handleSaveTestingApproval = useCallback(async (isApproved) => {
    if (isApproved) {
        const isValid = validateTestReport();
        if (!isValid) return;
        setTestReportErrors({});
    }

    setBomUploading(true);

    try {
        const loggedInUser = JSON.parse(localStorage.getItem('userData'));
        let finalAttachments = [...(testReport.attachments || [])];

        const totalSize = bomTestingFilesDraft.reduce((acc, f) => acc + f.size, 0);
        const loadedBytesTracker = new Array(bomTestingFilesDraft.length).fill(0);

        const updateAggregateProgress = (index, loaded) => {
            if (totalSize === 0) return;
            loadedBytesTracker[index] = loaded;
            const totalLoaded = loadedBytesTracker.reduce((acc, val) => acc + val, 0);
            const percent = Math.round((totalLoaded / totalSize) * 100);
            setBomUploadPct(percent);
        };

        const attachmentUploadPromises = bomTestingFilesDraft.map((file, index) => 
            uploadSingleFile(file, (loaded) => updateAggregateProgress(index, loaded))
        );

        const pdfUploadPromise = (async () => {
            if (!isApproved) return null; 

            try {
                const pdfData = await handleDownloadTestReport(true, loggedInUser, true);                
                if (pdfData && pdfData.blob) {
                    const pdfFile = new File([pdfData.blob], pdfData.fileName, { type: 'application/pdf' });
                    return await uploadSingleFile(pdfFile);
                }
            } catch (err) {
                console.error("Error generating/uploading PDF", err);
                throw new Error("Failed to generate/upload Test Report PDF");
            }
            return null;
        })();

        const [uploadedNewAttachments, generatedReportData] = await Promise.all([
            Promise.all(attachmentUploadPromises),
            pdfUploadPromise
        ]);
        finalAttachments = [...finalAttachments, ...uploadedNewAttachments];
        setBomTestingFilesDraft([]); 

        const approvedUser = isApproved ? { user_id: loggedInUser._id || loggedInUser.id } : null;
        const approvalDate = isApproved ? new Date() : null;

        const updatedTestReport = {
            ...testReport,
            approved_by: approvedUser || undefined,
            generated_report: generatedReportData || testReport.generated_report, 
            attachments: finalAttachments 
        };

        const payload = {
            testing_done: isApproved,
            test_report_approved_date: approvalDate,
            test_report: updatedTestReport,
            fixture_document_number: fixtureDocNo.trim(),
            current_stage: bomData.current_stage 
        };

        const res = await updateBOM({}, payload, routeBomId);

        if (res?.data?.result) {
            setBomData(res.data.result);
        }
        
        setTestReport(updatedTestReport);
        setTestReportApprovedBy(approvedUser);
        setTestReportApprovedDate(approvalDate);
        setBomTestingDone(isApproved);

        const message = isApproved ? 'Testing Approved & Report Generated Successfully' : 'Testing marked Not Approved';
        ShowToast(message, TYPE_SUCCESS, INTERVAL);
        
        closeBomTesting();

    } catch (err) {
        console.error("Save/Upload failed", err);
        ShowToast("Failed to save testing data or upload files.", TYPE_FAIL, INTERVAL);
    } finally {
        setBomUploading(false);
        setBomUploadPct(0);
    }

}, [testReport, bomTestingFilesDraft, validateTestReport, handleDownloadTestReport, fixtureDocNo, bomData, routeBomId, setBomUploading, closeBomTesting]);
// Download existing BOM-level testing attachment
const handleBomAttachmentDownload = async (url) => {
  try {
    const m = String(url || '').match(/^https:\/\/[^/]+\.s3\.amazonaws\.com\/(.+)$/);
    const fileKey = m?.[1] || url;
    const resp = await downloadDocumentBucket({}, { fileKey }); // :contentReference[oaicite:2]{index=2}
    window.open(resp?.data?.downloadUrl || url, '_blank');
  } catch (e) {
    console.error(e);
    ShowToast('Could not open file', TYPE_FAIL, INTERVAL, null, "");
  }
};

const uploadBomDispatchFiles = useCallback(async (files) => {
    if (!files?.length) return;
    setBomDispatchUploading(true); // <-- Changed
    try {
        const uploaded = [];
        for (let i = 0; i < files.length; i++) {
            const f = files[i];
            const pres = await getS3PresignedUrl({}, {
                fileName: f.name,
                fileType: f.type || 'application/octet-stream',
            });
            const putUrl = pres?.data?.url;
            const publicUrl = pres?.data?.fileUrl;
            if (!putUrl || !publicUrl) throw new Error('Failed to get upload URL');

            await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.open('PUT', putUrl, true);
                xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, f.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
                xhr.upload.onprogress = (e) => {
                    if (e.lengthComputable) setBomDispatchUploadPct(Math.round((e.loaded / e.total) * 100)); // <-- Changed
                };
                xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
                xhr.onerror = () => reject(new Error('Network error during upload'));
                xhr.send(f);
            });

            let file_key = '';
            try {
                const u = new URL(putUrl);
                const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
                const at = path.indexOf('uploads/');
                file_key = at >= 0 ? path.substring(at) : path;
            } catch {}

            uploaded.push({
                file_name: f.name,
                file_type: f.type || '',
                file_url: publicUrl,
                file_key,
            });
        }
        setBomDispatchAttachments(prev => [...prev, ...uploaded]); // <-- Changed
    } catch (e) {
        console.error(e);
        ShowToast('Upload failed', TYPE_FAIL, INTERVAL, null, "");
    } finally {
        setBomDispatchUploading(false); // <-- Changed
        setBomDispatchUploadPct(0); // <-- Changed
    }
}, []);

const removeBomDispatchAttachment = useCallback((idx) => {
    setBomDispatchAttachments(prev => prev.filter((_, i) => i !== idx)); // <-- Changed
}, []);

const handleDispatchAttachmentDownload = async (url) => {
    try {
        const m = String(url || '').match(/^https:\/\/[^/]+\.s3\.amazonaws\.com\/(.+)$/);
        const fileKey = m?.[1] || url;
        const resp = await downloadDocumentBucket({}, { fileKey });
        window.open(resp?.data?.downloadUrl || url, '_blank');
    } catch (e) {
        console.error(e);
        ShowToast('Could not open file', TYPE_FAIL, INTERVAL, null, "");
    }
};
const handleDownloadDispatchChecklist = async (
    returnBlob = false,
    explicitApproverUser = null,
    isUpload = false
  ) => {
  
    const logoUrl = authcontect.BRAND_LOGO;
    const logoData = await getBase64ImageFromUrl(logoUrl);
  
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 15;
    let yPos = 20;
  
    /* -------------------------------------------------
       HEADER
    ------------------------------------------------- */
  
    if (logoData?.dataUrl) {
      const h = 14;
      const w = (logoData.width / logoData.height) * h;
      doc.addImage(logoData.dataUrl, 'JPEG', marginX, 10, w, h);
    }
  
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.text(
      'Pre-Dispatch Inspection Checklist',
      pageWidth - marginX,
      20,
      { align: 'right' }
    );
  
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(
      `Date: ${moment().format('DD-MMM-YYYY')}`,
      pageWidth - marginX,
      26,
      { align: 'right' }
    );
  
    yPos = 35;
  
    /* -------------------------------------------------
       FIXTURE INFO
    ------------------------------------------------- */
  
    doc.setFillColor(240, 240, 240);
    doc.rect(marginX, yPos, pageWidth - marginX * 2, 16, 'F');
  
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text(`Fixture Name: ${fixtureName}`, marginX + 5, yPos + 6);
    doc.text(`Document No: ${fixtureDocNo}`, marginX + 5, yPos + 13);
  
    yPos += 24;
  
    /* -------------------------------------------------
       HELPERS
    ------------------------------------------------- */
  
    const drawCheckbox = (x, y, checked) => {
      const size = 4;
      doc.rect(x, y - size + 1, size, size);
  
      if (checked) {
        doc.line(x + 0.8, y - 1.5, x + 1.8, y - 0.5);
        doc.line(x + 1.8, y - 0.5, x + 3.2, y - 2.8);
      }
    };
  
    const printSection = (title, items) => {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text(title, marginX, yPos);
      yPos += 8;
  
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
  
      items.forEach(item => {
        drawCheckbox(marginX + 2, yPos, item.checked);
        doc.text(item.label, marginX + 10, yPos);
        yPos += 7;
      });
  
      yPos += 4;
    };
  
    /* -------------------------------------------------
       CHECKLIST SECTIONS
    ------------------------------------------------- */
  
    printSection(
      '1. Documents included in packaging box',
      [
        { label: 'Test Report', checked: dispatchChecks.documents[0] },
        { label: 'Packing list', checked: dispatchChecks.documents[1] },
        { label: 'Approved DAP layout', checked: dispatchChecks.documents[2] },
      ]
    );
  
    printSection(
      '2. Visual Checks',
      [
        { label: 'Dent free', checked: dispatchChecks.visuals[0] },
        { label: 'No leakages', checked: dispatchChecks.visuals[1] },
        { label: 'Rust preventive protection', checked: dispatchChecks.visuals[2] },
        { label: 'Parts packed as per packing list', checked: dispatchChecks.visuals[3] },
        { label: 'Packets in designated boxes', checked: dispatchChecks.visuals[4] },
      ]
    );
  
    /* -------------------------------------------------
       REMARKS
    ------------------------------------------------- */
  
    if (bomDispatchRemark) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.text('3. Remarks / Comments', marginX, yPos);
      yPos += 6;
  
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(11);
  
      const text = doc.splitTextToSize(
        bomDispatchRemark,
        pageWidth - marginX * 2
      );
  
      doc.text(text, marginX, yPos);
      yPos += text.length * 5;
    }
  
    /* -------------------------------------------------
       FOOTER
    ------------------------------------------------- */
  
    const user =
      explicitApproverUser ||
      JSON.parse(localStorage.getItem('userData'));
  
    const approvedBy = user
      ? `${user.first_name || ''} ${user.last_name || ''}`.trim()
      : '-';
  
    doc.setFontSize(9);
    doc.setDrawColor(200);
    doc.line(
      marginX,
      pageHeight - 18,
      pageWidth - marginX,
      pageHeight - 18
    );
  
    doc.text(
      `Approved by: ${approvedBy}`,
      marginX,
      pageHeight - 12
    );
  
    doc.text(
      `${isUpload ? 'Created on' : 'Downloaded on'}: ${moment().format('DD-MMM-YYYY HH:mm')}`,
      pageWidth - marginX,
      pageHeight - 12,
      { align: 'right' }
    );
  
    /* -------------------------------------------------
       SAVE / RETURN BLOB
    ------------------------------------------------- */
  
    const fileName = `Dispatch_Checklist_${fixtureDocNo}.pdf`;
  
    if (returnBlob) {
      return {
        blob: doc.output('blob'),
        fileName
      };
    }
  
    doc.save(fileName);
  };
  
  const handleSaveDispatchChecklist = useCallback(async (isApproved) => {   
    try {
      setBomDispatchUploading(true);

      const loggedInUser = JSON.parse(localStorage.getItem('userData'));
      if (bomDispatchFilesDraft.length > 0) {
        await uploadBomDispatchFiles(bomDispatchFilesDraft);
        setBomDispatchFilesDraft([]);
      }
      let generatedDispatchPdf = null;
  
      if (isApproved) {
        const pdfData = await handleDownloadDispatchChecklist(
          true,
          loggedInUser,
          true
        );

        if (pdfData?.blob) {
          const pdfFile = new File(
            [pdfData.blob],
            pdfData.fileName,
            { type: 'application/pdf' }
          );

          generatedDispatchPdf = await uploadSingleFile(pdfFile);
        }
      }

      /* Save BOM */
      const payload = {

        dispatch_checklist_pdir_report: {
          documents: dispatchChecks.documents,
          visuals: dispatchChecks.visuals,
          dispatch_ready_pdir: isApproved,
          dispatch_approved_date_pdir: isApproved ? new Date() : null,
          // PDF
          generated_report: generatedDispatchPdf
        }
      };
      const response = await updateBOM({}, payload, routeBomId);
      if (response?.data?.result) {
          const updatedBom = response.data.result;
          setBomData(updatedBom);
          if (updatedBom.dispatch_checklist_pdir_report) {
              setDispatchChecks({
                  documents: updatedBom.dispatch_checklist_pdir_report.documents || [false, false, false],
                  visuals: updatedBom.dispatch_checklist_pdir_report.visuals || [false, false, false, false, false],
              });
          }
      }
      
    // Set the dispatch status
    setBomDispatchReady(isApproved);
    // Show a toast message
    const message = isApproved ? 'Dispatch Approved' : 'Dispatch marked as Not Approved';
    const type = isApproved ? TYPE_SUCCESS : 'info';
    ShowToast(message, type, INTERVAL, null, "");
    setIsDispatchChecklistOpen(false);
    } catch (err) {
      console.error(err);
      ShowToast('Failed to save dispatch checklist', TYPE_FAIL, INTERVAL);
    } finally {
      setBomDispatchUploading(false);
    }
  }, [
    bomDispatchFilesDraft,
    dispatchChecks,
    bomDispatchRemark,
    routeBomId,
    uploadBomDispatchFiles
  ]);
    const uploadDispatchChecklistFiles = useCallback(async (files) => {
        if (!files?.length) return;
        setBomDispatchUploading(true);

        try {
            const uploaded = [];
            for (let i = 0; i < files.length; i++) {
                const f = files[i];
                
                const pres = await getS3PresignedUrl({}, {
                    fileName: f.name,
                    fileType: f.type || 'application/octet-stream',
                });
                const putUrl = pres?.data?.url;
                const publicUrl = pres?.data?.fileUrl;

                if (!putUrl || !publicUrl) throw new Error('Failed to get upload URL');

                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', putUrl, true);
                    xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, f.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
                    xhr.upload.onprogress = (e) => {
                        if (e.lengthComputable) {
                            const percentComplete = Math.round((e.loaded / e.total) * 100);
                            setBomDispatchUploadPct(percentComplete);
                        }
                    };
                    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
                    xhr.onerror = () => reject(new Error('Network error during upload'));
                    xhr.send(f);
                });

                let file_key = '';
                try {
                    const u = new URL(putUrl);
                    const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
                    const at = path.indexOf('uploads/');
                    file_key = at >= 0 ? path.substring(at) : path;
                } catch {}

                uploaded.push({
                    file_name: f.name,
                    file_type: f.type || '',
                    file_url: publicUrl,
                    file_key,
                    uploaded_at: new Date()
                });
            }

            setFinalDispatchChecks(prev => ({
                ...prev,
                dispatch_checklist_attachments: [
                    ...(prev.dispatch_checklist_attachments || []),
                    ...uploaded
                ]
            }));

            setBomDispatchFilesDraft([]); 
            ShowToast('Attachments uploaded successfully', TYPE_SUCCESS, INTERVAL);

        } catch (e) {
            console.error(e);
            ShowToast('Upload failed', TYPE_FAIL, INTERVAL, null, "");
        } finally {
            setBomDispatchUploading(false);
            setBomDispatchUploadPct(0);
        }
    }, []);

    const removeDispatchChecklistAttachment = useCallback((idx) => {
        setFinalDispatchChecks(prev => ({
            ...prev,
            dispatch_checklist_attachments: prev.dispatch_checklist_attachments.filter((_, i) => i !== idx)
        }));
    }, []);

    const uploadDapFiles = useCallback(async (files) => {
        if (!files?.length) return;
        setDapUploading(true);
        try {
            const uploaded = [];
            for (let i = 0; i < files.length; i++) {
                const f = files[i];
                const pres = await getS3PresignedUrl({}, {
                    fileName: f.name,
                    fileType: f.type || 'application/octet-stream',
                });
                const putUrl = pres?.data?.url;
                const publicUrl = pres?.data?.fileUrl;
                if (!putUrl || !publicUrl) throw new Error('Failed to get upload URL');

                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', putUrl, true);
                    xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, f.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
                    xhr.upload.onprogress = (e) => {
                        if (e.lengthComputable) setDapUploadPct(Math.round(((i + (e.loaded / e.total)) / files.length) * 100));
                    };
                    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
                    xhr.onerror = () => reject(new Error('Network error during upload'));
                    xhr.send(f);
                });

                let file_key = '';
                try {
                    const u = new URL(putUrl);
                    const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
                    const at = path.indexOf('uploads/');
                    file_key = at >= 0 ? path.substring(at) : path;
                } catch {}

                uploaded.push({
                    file_name: f.name,
                    file_type: f.type || '',
                    file_url: publicUrl,
                    file_key,
                });
            }
            setDapAttachments(prev => [...prev, ...uploaded]);
        } catch (e) {
            console.error(e);
            ShowToast('DAP Upload failed', TYPE_FAIL, INTERVAL, null, "");
        } finally {
            setDapUploading(false);
            setDapUploadPct(0);
        }
    }, []);

    const removeDapAttachment = useCallback((idx) => {
        setDapAttachments(prev => prev.filter((_, i) => i !== idx));
    }, []);

    const handleDapAttachmentDownload = async (url) => {
        try {
            const m = String(url || '').match(/^https:\/\/[^/]+\.s3\.amazonaws\.com\/(.+)$/);
            const fileKey = m?.[1] || url;
            const resp = await downloadDocumentBucket({}, { fileKey });
            window.open(resp?.data?.downloadUrl || url, '_blank');
        } catch (e) {
            console.error(e);
            ShowToast('Could not open file', TYPE_FAIL, INTERVAL, null, "");
        }
    };

    //Suplier invoice and logistics view permissions
const showSupplierInvoicePanel = useMemo(() => {
    if (!bomData || !bomData.current_stage) return false;
    
    const visibleStages = [
        BOM_STAGES.MANUFACTURING_EXECUTION,
        BOM_STAGES.TESTING,
        BOM_STAGES.DISPATCH,
        BOM_STAGES.HANDOVER_TO_DISPATCH,
        BOM_STAGES.COMMERCIAL_CLEARANCE,
        BOM_STAGES.COMPLETED
    ];
    
    return visibleStages.includes(bomData.current_stage);
}, [bomData]);

// 2. Read-Only Logic: 
const supplierPanelReadOnly = useMemo(() => {
    if (isGlobalReadOnly) return true;
    if (initialUser.user_role === SUPER_ADMIN ) {
        return false;
    }

    if (initialUser.user_role === SUPPLIER && bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) {
        return false;
    }

    return true; 
}, [initialUser.user_role, bomData.current_stage, isGlobalReadOnly]);

const showCommercialPanel = useMemo(() => {
        if (!bomData || !bomData.current_stage) return false;

        // 1. Define allowed stages
        const visibleStages = [
            
            BOM_STAGES.COMMERCIAL_CLEARANCE,
            BOM_STAGES.HANDOVER_TO_DISPATCH,
            BOM_STAGES.COMPLETED
        ];

        // 2. Define allowed roles
        const hasRole = initialUser.user_role === PROCUREMENT_ENGINEER || initialUser.user_role === SUPER_ADMIN || initialUser.user_role === LOGISTIC;
        
        // 3. Must match BOTH conditions
        return hasRole && visibleStages.includes(bomData.current_stage);
    }, [bomData, initialUser.user_role]);
    // 2. Commercial Panel Read-Only: 
    // Editable ONLY by Procurement Engineer (at ANY stage)
    const commercialPanelReadOnly = useMemo(() => {
    if (isGlobalReadOnly) return true;
    if (initialUser.user_role === SUPER_ADMIN && bomData.current_stage === BOM_STAGES.COMPLETED) {
        return false;
    }
    if((initialUser.user_role === PROCUREMENT_ENGINEER || initialUser.user_role === SUPER_ADMIN) && (bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE || bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH)) return false;

    return true;
}, [initialUser.user_role, bomData.current_stage, isGlobalReadOnly]);

    const testingCompletionDate = useMemo(() => {
        const mfgDate = bomData?.mfg_delivery_date;
        const buffer = Number(bomTestingBufferDays) || 0;

        if (!mfgDate) return null;

        const resultDate = addDaysSkipSundays(mfgDate, buffer);
        
        return resultDate ? moment(resultDate).format('DD-MMM-YYYY') : 'N/A';

    }, [bomData?.mfg_delivery_date, bomTestingBufferDays]);

function formatBytes(bytes) {
  if (!bytes && bytes !== 0) return '';
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = bytes === 0 ? 0 : Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
}


const handleSelectedOdChange = useCallback((itemIndex, newOd) => {
    setItems(prevItems => {
        const newItems = [...prevItems];
        if (newItems[itemIndex]) {
            newItems[itemIndex] = {
                ...newItems[itemIndex],
                ui_selected_od: newOd
            };
        }
        return newItems;
    });
}, []);

//dynamicaly calculate predegined dates

    const recalculateStepDates = (steps, startDate) => {
        if (!Array.isArray(steps) || !steps.length || !(startDate instanceof Date) || isNaN(startDate)) {
            return steps;
        }

        let cursor = new Date(startDate);

        const sortedSteps = [...steps].sort((a, b) => (a.position || 0) - (b.position || 0));

        const newSteps = sortedSteps.map(step => {
            const predefinedDays = Number(step.predefined_duration_days || 0);
            const bufferDays = Number(step.buffer_days || 0);
            const daysToAdd = predefinedDays + bufferDays;

            let addedDays = 0;
            if (daysToAdd > 0) {
                while (addedDays < daysToAdd) {
                    cursor.setDate(cursor.getDate() + 1);
                    
                    if (cursor.getDay() !== 0) {
                        addedDays++;
                    }
                }
            }

            return {
                ...step,
                defined_completion_date: new Date(cursor).toISOString(),
            };
        });

        return newSteps;
    };
    /* ---------------- 3) THEME ---------------- */
    const theme = useMemo(() => createTheme({ typography: { fontSize: 16 } }), []);
    const caseImageMap = {
        'Case 1: Pinion Collet Fixture': Case1Image,
        'Case 2: Crown Wheel Fixture': Case2Image,
        'Case 3: Collet Fixture – Ring Type': Case3Image,
        'Case 4: Collet Fixture – Shaft Type': Case4Image,
        'Case 5: Friction cone Fixture – Shaft Type': Case5Image,
    };

    const fixtureDocMask = useMemo(() => {
        const verticalName = businessVertical?.label || '';

            if (verticalName.includes('BGWH')) {
                return 'WH999999A';
            }
            if (verticalName.includes('CGWH')) {
                return '699-9999-999-99';
            }
            if (verticalName.includes('ESM')) {
                return '1000.9999';
            }
            if (verticalName.includes('Internal')) {
                return '';
            }

        return null;
    }, [businessVertical]);

    const testReportCaseOptions = useMemo(() => [
        { value: 'Special Case', label: 'Special Case' },
        { value: 'Case 1: Pinion Collet Fixture', label: 'Case 1: Pinion Collet Fixture' },
        { value: 'Case 2: Crown Wheel Fixture', label: 'Case 2: Crown Wheel Fixture' },
        { value: 'Case 3: Collet Fixture – Ring Type', label: 'Case 3: Collet Fixture – Ring Type' },
        { value: 'Case 4: Collet Fixture – Shaft Type', label: 'Case 4: Collet Fixture – Shaft Type' },
        { value: 'Case 5: Friction cone Fixture – Shaft Type', label: 'Case 5: Friction cone Fixture – Shaft Type' },
    ], [])
    /* ---------------- 4) LOAD DROPDOWNS ---------------- */


    useEffect(() => {
        const baseStartDate = bomData.manufacturing_start_date
            ? new Date(bomData.manufacturing_start_date)
            : (bomData.manufacturing_release_date ? new Date(bomData.manufacturing_release_date) : null);

        if (!baseStartDate || !items || items.length === 0) {
            setProjectedCompletionDate(null);
            return;
        }

        const addBusinessDays = (startDate, days) => {
            let currentDate = new Date(startDate);
            let addedDays = 0;
            if (days <= 0) return currentDate;

            while (addedDays < days) {
                currentDate.setDate(currentDate.getDate() + 1);
                if (currentDate.getDay() !== 0) { // 0 is Sunday
                    addedDays++;
                }
            }
            return currentDate;
        };

        const allItemFinalDates = [];

        items.forEach(item => {
            const steps = item.manufacturing_steps;
            if (!Array.isArray(steps) || steps.length === 0) {
                return;
            }

            const sortedSteps = [...steps].sort((a, b) => (a.position || 0) - (b.position || 0));
            
    
            let previousStepEndDate = new Date(baseStartDate);

            sortedSteps.forEach(step => {

                if (step.status === 'Completed' && step.actual_completion_date) {
                    previousStepEndDate = new Date(step.actual_completion_date);
                } else {
                    const duration = (Number(step.predefined_duration_days) || 0) + (Number(step.buffer_days) || 0);
                    const projectedEndDate = addBusinessDays(previousStepEndDate, duration);
                    previousStepEndDate = projectedEndDate;
                }
            });

            allItemFinalDates.push(previousStepEndDate);
        });

        if (allItemFinalDates.length > 0) {
            const latestDate = new Date(Math.max.apply(null, allItemFinalDates));
            setProjectedCompletionDate(latestDate);
        } else {
            setProjectedCompletionDate(null);
        }

    }, [items, bomData.manufacturing_start_date, bomData.manufacturing_release_date, bomTestingBufferDays]);

    // useEffect(() => {
    //     (async () => {
    //         try {
    //             const [partRes, procRes, custRes, bvRes, regRes, supplierRes] = await Promise.all([
    //                 getPartList({}, {}),
    //                 getStdProcessList({}, {}),
    //                 getCustomerList({}, {}),
    //                 getBusinessVerticalList({}, {}),
    //                 getRegionList({}, {}),
    //                 getUserByRole({}, {role: SUPPLIER}),
    //             ]);
    //             if (!mountedRef.current) return;
    //             setParts(partRes?.data?.result || []);
    //             setStdProcesses(procRes?.data?.result || []);
    //             setCustomers(custRes?.data?.result || []);
    //             setBusinessVerticals(bvRes?.data?.result || []);
    //             setRegions(regRes?.data?.result || []);
    //             setSupplierUsers(supplierRes?.data?.result || []);

    //         } catch {
    //             if (mountedRef.current) {
    //                 ShowToast('Failed to load dropdowns', TYPE_FAIL, INTERVAL, props, '');
    //             }
    //         } finally {
    //             if (mountedRef.current) setListsLoaded(true);
    //         }
    //     })();
    // }, [props]);
    useEffect(() => {
    (async () => {
        try {
            const res = await getBomFormOptions({}, {}); 
            
            if (!mountedRef.current) return;

            const data = res?.data?.result || {};

            setParts(data.parts || []);
            setStdProcesses(data.processes || []);
            setCustomers(data.customers || []);
            setBusinessVerticals(data.verticals || []);
                setRegions(data.regions || []);
                setSupplierUsers(data.suppliers || []);
                setAllSalesUsers(data.salesUsers || []);

        } catch (err) {
                console.error(err);
                if (mountedRef.current) {
                    ShowToast('Failed to load dropdowns', TYPE_FAIL, INTERVAL, props, '');
                }
            } finally {
                if (mountedRef.current) setListsLoaded(true);
            }
        })();
    }, [props]);    
    /*useEffect(() => {
        const fetchEnquiryIdForLink = async () => {
            const poId = selectedPoIdFromUrl || bomData?.po_id;
            if (!poId) return;
            try {
                const response = await getPODetailsForBom({}, {}, poId);
                const po = response?.data?.result || response?.result || response?.data?.data?.result;
                if (po && po.enquiry_id) {
                    const eq = po.enquiry_id;
                    setEnquiryIdForLink(typeof eq === 'object' ? eq._id : eq);
                }
            } catch (err) {
                console.error('Failed to fetch PO for link:', err);
            }
        };
        fetchEnquiryIdForLink();
    }, [selectedPoIdFromUrl, bomData?.po_id]);*/

    useEffect(() => {
    const fetchPODetailsForBom = async () => {
        if (!selectedPoIdFromUrl || routeBomId) return;

        try {
            console.log('selectedPoIdFromUrl:', selectedPoIdFromUrl);

            const response = await getPODetailsForBom({}, {}, selectedPoIdFromUrl);

            console.log('FULL PO API RESPONSE:', response);

            const po =
                response?.data?.result ||
                response?.result ||
                response?.data?.data?.result;

            console.log('PO FOR BOM:', po);

            if (!po) {
                ShowToast('PO details not found', TYPE_FAIL);
                return;
            }

            setSelectedPoId(po._id);
            setPoRef(po.po_number || '');

            const enquiry = po.enquiry_id;

            console.log('ENQUIRY FOR BOM:', enquiry);

            if (!enquiry || typeof enquiry === 'string') {
                ShowToast('PO loaded but enquiry details are not populated', TYPE_FAIL);
                return;
            }

            setFixtureName(enquiry.fixtureName || enquiry.fixture_name || '');
            setMachine(`${enquiry.machineManufacturer || ''} ${enquiry.machineModel || ''}`.trim());
            setEndClient(enquiry.endClient || enquiry.end_client || '');

            const drawingList =
                enquiry.component_drawing_numbers ||
                enquiry.componentDrawingNumbers ||
                enquiry.drawing_numbers ||
                enquiry.drawingNumbers ||
                enquiry.component_drawing_number ||
                enquiry.componentDrawingNumber ||
            [];

            if (Array.isArray(drawingList)) {
                setDrawingNumbers(
                    drawingList.map((number) => ({
                        value: number,
                        label: number,
                    }))
                );
            } else if (drawingList) {
                setDrawingNumbers([
                {
                    value: drawingList,
                    label: drawingList,
                },
            ]);
        }
        const enquiryRegion =
            enquiry.region_id ||
            enquiry.region ||
            enquiry.regionId ||
            enquiry.regionName ||
            enquiry.region_name;
        const regionId =
            enquiryRegion?._id ||
            enquiryRegion?.value ||
            enquiryRegion;
        const regionName =
            enquiryRegion?.name ||
            enquiryRegion?.region_name ||
            enquiryRegion?.label ||
            enquiry.regionName ||
            enquiry.region_name;

        let matchedRegion = null;

        if (regionId && regions.length > 0) {
            matchedRegion = regions.find((r) => r._id === regionId);
        }

        if (!matchedRegion && regionName && regions.length > 0) {
            matchedRegion = regions.find(
                (r) =>
                    String(r.name || '').toLowerCase() === String(regionName || '').toLowerCase()
            );
        }

        if (matchedRegion) {
            setRegion({
                value: matchedRegion._id,
                label: matchedRegion.name,
            });
        }


            const enquiryCustomer = enquiry.customer || enquiry.customer_id;
            const customerId = enquiryCustomer?._id || enquiryCustomer;

            if (customerId && customers.length > 0) {
                const matchedCustomer = customers.find((c) => c._id === customerId);

                if (matchedCustomer) {
                    setCustomer({
                        value: matchedCustomer._id,
                        label: matchedCustomer.customer_name || matchedCustomer.name || 'Unnamed',
                    });
                }
            }
        } catch (error) {
            console.log('PO DETAILS ERROR:', error);
            ShowToast('Failed to fetch PO details', TYPE_FAIL);
        }
    };

    fetchPODetailsForBom();
}, [
    selectedPoIdFromUrl,
    routeBomId,
    customers,
    regions
]);



    /* ---------------- 5) HELPERS ---------------- */

    const unitsAllocatedOf = (row) => {
  const lenPerUnit = Number(row?.raw_material_length_mm || 0);
  const totalAllocated = (row?.procurement_details || []).reduce((s, d) => s + (Number(d.length_allocated)||0), 0);
  return lenPerUnit > 0 ? Math.floor(totalAllocated / lenPerUnit) : 0;
};
    const getId = (v) => (v && typeof v === 'object' ? v.$oid || v.oid || v.id : v);
    const labelFrom = (list, _id, key) => list.find((x) => x._id === _id)?.[key] || 'Selected';

        //for the revert procurement
    const handleRevertItemProcurement = useCallback(async (itemIndex, partIdToRevert) => {
        const itemToUpdate = items[itemIndex];
        if (!itemToUpdate?._id) {
            ShowToast('Cannot revert an unsaved item.', TYPE_FAIL, INTERVAL, props, '');
            return;
        }

        if (!window.confirm('Are you sure you want to revert this specific material allocation?')) {
            return;
        }

        const newProcurementDetails = itemToUpdate.procurement_details.filter(
            detail => detail.raw_material_id !== partIdToRevert
        );

        const totalAllocatedLength = newProcurementDetails.reduce((sum, d) => sum + d.length_allocated, 0);
        const requiredLengthPerUnit = itemToUpdate.raw_material_length_mm || 0;
        const totalRequired = requiredLengthPerUnit * itemToUpdate.quantity;
        const newIsProcured = totalRequired > 0 && totalAllocatedLength >= totalRequired;

        const updatedItems = items.map((item, index) => {
            if (index === itemIndex) {
                return { ...item, procurement_details: newProcurementDetails, procurement_done: newIsProcured };
            }
            return item;
        });

        const payload = { items: updatedItems };
        

        try {
            const response = await updateBOM({}, payload, routeBomId);
            if (response?.data?.result) {
                prefillFromBom(response.data.result);
            }
            ShowToast('Allocation reverted successfully.', TYPE_SUCCESS, INTERVAL, props, '');
        } catch (err) {
            const msg = err?.response?.data?.error || 'Failed to revert allocation.';
            ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
        }
    }, [items, routeBomId , props]);

    const handleRevertAllProcurement = useCallback(async (itemIndex) => {
        const itemToUpdate = items[itemIndex];
        if (!itemToUpdate?._id) {
            ShowToast('Cannot revert an unsaved item.', TYPE_FAIL, INTERVAL, props, '');
            return;
        }

        if (!window.confirm('Are you sure you want to revert ALL allocations for this item? All materials will be returned to inventory.')) {
            return;
        }

        const updatedItems = items.map((item, index) => {
            if (index === itemIndex) {
                return {
                    ...item,
                    procurement_details: [],
                    procurement_done: false,   
                };
            }
            return item;
        });

        const payload = { items: updatedItems };

        try {
            const response = await updateBOM({}, payload, routeBomId);
            if (response?.data?.result) {
                prefillFromBom(response.data.result);
            }
            ShowToast('All allocations for this item have been reverted.', TYPE_SUCCESS, INTERVAL, props, '');
            window.location.reload();
        } catch (err) {
            const msg = err?.response?.data?.error || 'Failed to revert allocations.';
            ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
        }
    }, [items, routeBomId , props]);



    const updateProcuredOnServer = useCallback(async(rowIndex, itemId, currval) =>{
        const row = items[rowIndex];
        const bomId = idOf(routeBomId);        
        const nextVal = !currval;

        setItems(prev =>
            prev.map((it, i) => (i === rowIndex ? { ...it, procurement_done: nextVal } : it))
        );

        if(!bomId || !itemId){
            ShowToast('Save the BOM first, then toggle Procured.', TYPE_FAIL, INTERVAL, props, '');
            return;
        }

        try{
            await updateProcurementStatus({}, bomId, itemId, {procurement_done : nextVal});
            ShowToast(nextVal ? 'Marked as Procured' : 'Marked as Not Procured', TYPE_SUCCESS, INTERVAL, props, '');

        }catch(err){
            setItems(prev =>
                prev.map((it, i) => (i === rowIndex ? { ...it, procurement_done: !nextVal } : it))
            )
            const msg = err?.response?.data?.error || err?.message || 'Failed to update procurement status';
            ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
            console.error('[toggleProcuredOnServer] error:', err);
        }
    })

    const extractId = useCallback((v) => {
        if (!v) return null;
        if (typeof v === 'string') return v;
        if (typeof v === 'object') return v.$oid || v._id || v.id || null;
        return null;
    }, []);

    const userDisplayName = useCallback((u) => {
        if (!u || typeof u !== 'object') return '';
        const first = u.first_name || u.firstName || '';
        const last  = u.last_name  || u.lastName  || '';
        const full = `${first} ${last}`.trim();
        if (full) return full;
        return '';
    }, []);

    const fetchAndSetDENameById = useCallback(async (userId) => {
        if (!userId) return;
        try {
        const res = await getUserDetails({}, {}, userId);
        const user = res?.data?.result || res?.data;
        const name = userDisplayName(user);
        if (mountedRef.current && name) setDesignEngineerName(name);
        } catch (e) {
            console.log(e);
        }
    }, [userDisplayName]);



    ////////////////////////////////
        const findProcessDetailLocally = useCallback(
        (pid) => stdProcesses.find((p) => p._id === pid),
        [stdProcesses]
        );

        const fetchProcessDetailRemotely = useCallback(async (pid) => {
        try {
            const res = await getStdProcessList({ id: pid, _id: pid }, {});
            const arr = res?.data?.result || res?.data || [];
            return Array.isArray(arr) ? arr.find((x) => x._id === pid) || arr[0] : null;
        } catch {
            return null;
        }
        }, []);

        const buildManufacturingStepsFromProcess = useCallback((proc) => {
        const steps = proc?.process_steps || [];
        return steps.map((ps, i) => ({
            step_ref: getId(ps.step),
            step_title_snapshot: ps.step_title_snapshot || ps.title || 'Step',
            position: typeof ps.position === 'number' ? ps.position : i,
            status: 'Pending',
            predefined_duration_days:
            typeof ps.expected_duration_days === 'number'
                ? ps.expected_duration_days
                : (typeof ps.recommended_duration_days === 'number' ? ps.recommended_duration_days : 0),
            extended_duration_days: 0,
            delay_reason: '',
            actual_start_date: null,
            // actual_end_date: null,
            actual_completion_date: null,
            updated_by: null,
            attachments: []
        }));
        }, []);

        const ensureStepsForItem = useCallback(async (itemIndex) => {
        const item = items[itemIndex];
        if (!item?.process_type_id) {
            ShowToast('Select a Std Process first', TYPE_FAIL, INTERVAL, props, '');
            return false;
        }
        if (Array.isArray(item.manufacturing_steps) && item.manufacturing_steps.length) {
            return true;
        }
        let proc = findProcessDetailLocally(item.process_type_id);
        if (!proc || !Array.isArray(proc.process_steps)) {
            proc = await fetchProcessDetailRemotely(item.process_type_id);
        }
        if (!proc || !Array.isArray(proc.process_steps)) {
            ShowToast('Could not load process steps', TYPE_FAIL, INTERVAL, props, '');
            return false;
        }
        const steps = buildManufacturingStepsFromProcess(proc);
        setItems((prev) => {
            const copy = [...prev];
            copy[itemIndex] = { ...copy[itemIndex], manufacturing_steps: steps };
            return copy;
        });
        return true;
        }, [items, findProcessDetailLocally, fetchProcessDetailRemotely, buildManufacturingStepsFromProcess, props]);


        const setStepField = useCallback((itemIndex, stepIndex, key, value) => {
            setItems((prev) => {
                const newItems = [...prev];
                const itemToUpdate = { ...newItems[itemIndex] };
                
                let manufacturingSteps = Array.isArray(itemToUpdate.manufacturing_steps) 
                    ? [...itemToUpdate.manufacturing_steps] 
                    : [];

                if (manufacturingSteps[stepIndex]) {
                    const step = { ...manufacturingSteps[stepIndex], [key]: value };

                    if (key === 'actual_completion_date') {
                        const actualDate = value ? new Date(value) : null;
                        const definedDate = step.defined_completion_date ? new Date(step.defined_completion_date) : null;

                        if (actualDate && definedDate) {
                            const actualNorm = new Date(actualDate);
                            const definedNorm = new Date(definedDate);
                            actualNorm.setHours(0, 0, 0, 0);
                            definedNorm.setHours(0, 0, 0, 0);

                            const diffTime = actualNorm.getTime() - definedNorm.getTime();
                            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                            if (diffDays <= 1) {
                                step.current_status = STEP_STATUS.ON_TIME;
                            } else if (diffDays <= 3) {
                                step.current_status = STEP_STATUS.WARNING;
                            } else {
                                step.current_status = STEP_STATUS.DELAYED;
                            }
                        } else {
                            step.current_status = '-';
                        }
                    }
                    manufacturingSteps[stepIndex] = step;
                }

                if (key === 'buffer_days' || key === 'predefined_duration_days') {
                    const startDate = bomData.manufacturing_start_date 
                        ? new Date(bomData.manufacturing_start_date) 
                        : new Date(bomData.manufacturing_release_date || Date.now());

                    manufacturingSteps = recalculateStepDates(manufacturingSteps, startDate);
                }

                newItems[itemIndex] = { ...itemToUpdate, manufacturing_steps: manufacturingSteps };
                
                return newItems;
            });
        }, [bomData]);


        const handleStepStatusChange = useCallback( (parentItemIndex, stepIndex, newStatus) => {
            const stepToUpdate = items[parentItemIndex]?.manufacturing_steps?.[stepIndex];
            if (!stepToUpdate) return;

            setItems(prev => {
                const newItems = [...prev];
                const item = { ...newItems[parentItemIndex] };
                const steps = [...item.manufacturing_steps];
                const step = { ...steps[stepIndex] };

                step.status = newStatus;

            if (newStatus === 'Completed') {
                const completionDate = new Date().toISOString();
                step.actual_completion_date = completionDate;
                step.updated_by = initialUser?._id || initialUser?.id || null;
                    
                    const actual = new Date(completionDate);
                    const defined = step.defined_completion_date ? new Date(step.defined_completion_date) : null;
                    
                    if (defined) {
                        const actualNorm = new Date(actual);
                        const definedNorm = new Date(defined);
                        actualNorm.setHours(0, 0, 0, 0);
                        definedNorm.setHours(0, 0, 0, 0);

                        const diffTime = actualNorm.getTime() - definedNorm.getTime();
                        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                        
                        if (diffDays <= 1) {
                            step.current_status = STEP_STATUS.ON_TIME;
                        } else if (diffDays <= 3) {
                            step.current_status = STEP_STATUS.WARNING;
                        } else {
                            step.current_status = STEP_STATUS.DELAYED;
                        }
                    } else {
                        step.current_status = STEP_STATUS.ON_TIME;
                    }
                } else {
                    step.actual_completion_date = null;
                    step.current_status = '-';
                    step.updated_by = null;
                }

                steps[stepIndex] = step;
                item.manufacturing_steps = steps;
                newItems[parentItemIndex] = item;
                
                return newItems;
            });
        }, [items, initialUser?._id, initialUser?.id]);
          const [downloadingRow, setDownloadingRow] = useState(null);
          const handleDownload = async (rowIndex, url) => {
            try {
              setDownloadingRow(rowIndex);
            const m = String(url || '').match(/^https:\/\/[^/]+\.s3\.amazonaws\.com\/(.+)$/);
            const fileKey = m?.[1] || url;
            const resp = await downloadDocumentBucket({}, { fileKey });
            window.open(resp?.data?.downloadUrl || url, '_blank');
        } catch (e) {
            console.error(e);
            ShowToast('Could not open file', TYPE_FAIL, INTERVAL, null, "");
        } finally {
            setDownloadingRow(null);

        }
        };

        const clearAttachment = (rowIndex) => {
        setItems(prev => {
            const copy = [...prev];
            const item = { ...copy[rowIndex] };
            item.attachments = [];
            copy[rowIndex] = item;
            return copy;    
        });
        };

        const keyForStep = (rowData, step) => {
            const itemId = idOf(rowData?._id);
            const stepId = idOf(step?.step_ref) ?? String(step?.position ?? '');
            return `${itemId}::${stepId}`;
        };


        const MAX_FILE_SIZE = 2 * 1024 * 1024; 

const uploadAttachmentForRow = async (rowIndex, files) => {
    if (!files || files.length === 0) return;

            setUploadingRow(rowIndex);
            setUploadProgress((p) => ({ ...p, [rowIndex]: 0 }));

    try {
        const uploadedFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const pres = await getS3PresignedUrl({}, {
                fileName: file.name,
                fileType: file.type || 'application/octet-stream',
            });
            const putUrl = pres?.data?.url;
            const publicUrl = pres?.data?.fileUrl;
            if (!putUrl || !publicUrl) throw new Error(`Failed to get upload URL for ${file.name}`);

            await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', putUrl, true);
            xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, file.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                const pct = Math.round(((i + (e.loaded / e.total)) / files.length) * 100);
                setUploadProgress((p) => ({ ...p, [rowIndex]: pct }));
                }
            };
            xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
            xhr.onerror = () => reject(new Error('Network error during upload'));
            xhr.send(file);
            });

            let file_key = '';
            try {
            const u = new URL(putUrl);
            const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
            const at = path.indexOf('uploads/');
            file_key = at >= 0 ? path.substring(at) : path;
            } catch {}

            uploadedFiles.push({
                file_name: file.name,
                file_type: file.type || '',
                file_url: publicUrl,
                file_key,
            });
        }

        setItems((prev) => {
            const copy = [...prev];
            const item = { ...copy[rowIndex] };
            item.attachments = [...(item.attachments || []), ...uploadedFiles];
            copy[rowIndex] = item;
            return copy;
        });

    } catch (err) {
        console.error('Upload failed:', err);
        ShowToast('Upload failed', TYPE_FAIL);
    } finally {
        setUploadingRow(null);
        // Optional: Remove the progress bar after completion
        setUploadProgress((p) => {
            const { [rowIndex]: _, ...rest } = p;
            return rest;
        });
    }
};

    const removeAttachmentForRow = (rowIndex, attachmentIndex) => {
        setItems(prev => {
            const copy = [...prev];
            const item = { ...copy[rowIndex] };
            if (item.attachments) {
                item.attachments = item.attachments.filter((_, i) => i !== attachmentIndex);
            }
            copy[rowIndex] = item;
            return copy;
        });
    };

    const clearAttachmentForStep = useCallback((itemIndex, stepIndex, attachmentIndex) => {
        setItems(prev => {
            const copy = [...prev];
            const item = { ...copy[itemIndex] };
            const steps = [...item.manufacturing_steps];
            const step = { ...steps[stepIndex] };
            if (step.attachments) {
                step.attachments = step.attachments.filter((_, i) => i !== attachmentIndex);
            }
            steps[stepIndex] = step;
            item.manufacturing_steps = steps;
            copy[itemIndex] = item;
            return copy;
        });
      },[]);

    const handleDownloadForStep = useCallback( async (url) =>{
        try{
            const m = String(url || '').match(/^https:\/\/[^/]+\.s3\.amazonaws\.com\/(.+)$/);
            const fileKey = m?.[1] || url;
            const resp = await downloadDocumentBucket({}, { fileKey });
            window.open(resp?.data?.downloadUrl || url, '_blank');
        } catch (e) {
            console.error(e);
            ShowToast('Could not open file', TYPE_FAIL, INTERVAL, null, "");

        }
    }, []);

const uploadAttachmentForStep = useCallback(async (itemIndex, stepIndex, files) => {
    if (!files || files.length === 0) return;

    if (itemIndex === -1 || stepIndex === -1) {
        console.error('Invalid indices for step upload', itemIndex, stepIndex);
        return;
    }

    setItems(prev => {
        const newItems = [...prev];
        const newItem = { ...newItems[itemIndex] };       
        const newSteps = Array.isArray(newItem.manufacturing_steps) 
            ? [...newItem.manufacturing_steps] 
            : [];

        if (!newSteps[stepIndex]) {
            console.error(`Step index ${stepIndex} out of bounds for item ${itemIndex}`);
            return prev;
        }
        newSteps[stepIndex] = { ...newSteps[stepIndex], is_uploading: true, upload_progress: 0 };
        newItem.manufacturing_steps = newSteps;
        newItems[itemIndex] = newItem;
        return newItems;
    });

    try {
        const uploadedFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const pres = await getS3PresignedUrl({}, { fileName: file.name, fileType: file.type || 'application/octet-stream' });
            const { url: putUrl, fileUrl: publicUrl } = pres.data;
            if (!putUrl || !publicUrl) throw new Error('Failed to get upload URL');

        await new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('PUT', putUrl, true);
            xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, file.type || HTTP_CONTENT_TYPES.OCTET_STREAM);               
            xhr.upload.onprogress = (e) => {
                if (e.lengthComputable) {
                    const pct = Math.round(((i + (e.loaded / e.total)) / files.length) * 100);
                    
                    setItems(currentItems => {
                        const newItems = [...currentItems];
                        if (!newItems[itemIndex] || !newItems[itemIndex].manufacturing_steps[stepIndex]) return currentItems; 
                        const newItem = { ...newItems[itemIndex] };
                        const newSteps = [...newItem.manufacturing_steps];
                        newSteps[stepIndex] = { ...newSteps[stepIndex], upload_progress: pct };
                        newItem.manufacturing_steps = newSteps;
                        newItems[itemIndex] = newItem;
                        return newItems;
                    });
                }
            };
            xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed (${xhr.status})`)));
            xhr.onerror = () => reject(new Error('Network error during upload'));
            xhr.send(file);
            });

            let file_key = '';
            try {
                const u = new URL(putUrl);
                const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
                const at = path.indexOf('uploads/');
                file_key = at >= 0 ? path.substring(at) : path;
            } catch {}

            uploadedFiles.push({ file_name: file.name, file_type: file.type || '', file_url: publicUrl, file_key });
        }

        setItems(prev => {
            const newItems = [...prev];
            if (!newItems[itemIndex] || !newItems[itemIndex].manufacturing_steps[stepIndex]) return prev;
            const newItem = { ...newItems[itemIndex] };
            const newSteps = [...newItem.manufacturing_steps];
            const step = { ...newSteps[stepIndex] };
            step.attachments = [...(step.attachments || []), ...uploadedFiles];
            newSteps[stepIndex] = step;
            newItem.manufacturing_steps = newSteps;
            newItems[itemIndex] = newItem;
            return newItems;
        });

    } catch (err) {
        console.error('Step attachment upload failed:', err);
        ShowToast('Upload failed', TYPE_FAIL, INTERVAL, null, "");
    } finally {
        setItems(prev => {
            const newItems = [...prev];
            if (newItems[itemIndex] && newItems[itemIndex].manufacturing_steps[stepIndex]) {
                const newItem = { ...newItems[itemIndex] };
                const newSteps = [...newItem.manufacturing_steps];
                const { is_uploading, upload_progress, ...restOfStep } = newSteps[stepIndex];
                newSteps[stepIndex] = restOfStep;
                newItem.manufacturing_steps = newSteps;
                newItems[itemIndex] = newItem;
            }
            return newItems;
        });
    }
},[]);
    /* ---------------- 6) PREFILL FROM BOM (AFTER STATE) ---------------- */
    const prefillFromBom = useCallback((bom) => {
         const deField = bom.design_engineer_id;
         if (deField && typeof deField === 'object' && (deField.first_name)) {
           const n = userDisplayName(deField);
           if (n) setDesignEngineerName(n);
         } else {
           const id = extractId(deField);
           if (id) fetchAndSetDENameById(id);
         }

       setCurrentBomId(getId(bom._id));
       setFixtureDocNo(bom.fixture_document_number || '');
       setBomCode(bom.bom_code || '');
       setFixtureName(bom.fixture_name || '');
       setEndClient(bom?.end_client || '');
       setMfgReleaseDate(
        bom.manufacturing_release_date
            ? moment(bom.manufacturing_release_date).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD')
       ); 
        setMachine(bom.machine || '');
        setPoRef(bom.po_reference || '');
        setSurfaceTreatmentType(bom.surface_treatment_type || '');
        setDapDate(bom.dap_date ? moment(bom.dap_date).format('YYYY-MM-DD') : '');
        setDapAttachments(bom.dap_attachments || []);
        setDrawingNumbers( (bom.component_drawing_numbers || []).map((dn) => ({ value: dn, label: dn, })));

        // seed selects (labels fixed after lists load)
        const cid = getId(bom.customer_id);
        const bid = getId(bom.business_vertical_id);
        const rid = getId(bom.region_id);

        const salesId = getId(bom.sales_coordinator_id);
        const supId = getId(bom.supplier_id);
        setAssignedSupplier(supId ? { value: supId, label: 'Loading...' } : null);
        setCustomer(cid ? { value: cid, label: 'Loading…' } : null);
        setBusinessVertical(bid ? { value: bid, label: 'Loading…' } : null);
        setRegion(rid ? { value: rid, label: 'Loading…' } : null);
        setBomTestingDone(bom.testing_done);
        setTestReportApprovedDate(bom.test_report_approved_date || null);
        setTestReportApprovedBy(bom.test_report?.approved_by || null);
        // setBomTestingRemark(bom.testing_remark);
        setBomTestingBufferDays(bom.testing_buffer_days ?? 2);
        setSelectedSalesUser(salesId ? { value: salesId, label: 'Loading...' } : null); 
        // setBomTestingAttachments(bom.testing_attachments);
        const loadedTestReport = bom.test_report || {};
        if (loadedTestReport.selected_case === 'N/A') {
            loadedTestReport.selected_case = '';
        }
        setTestReport({ ...defaultTestReport, ...loadedTestReport });
        setBomDispatchReady(bom.fixture_ready_to_dispatch);
        setBomDispatchRemark(bom.dispatch_remark || '');
        setBomDispatchAttachments(bom.dispatch_attachments || []);
        setFixtureLocation(bom.fixture_location || '');

        if (bom.supplier_invoice_details) {
            setSupplierInvoiceDetails({
            ...bom.supplier_invoice_details,
            invoice_files: Array.isArray(bom.supplier_invoice_details.invoice_files) 
                ? bom.supplier_invoice_details.invoice_files 
                : [] 
        });
        } else {
            setSupplierInvoiceDetails({
                invoice_number: '',
                invoice_value: 0,
                awb_number: '',
                courier_agency: '',
                invoice_files: []
            });
        }
        const loadedDispatch = bom.dispatch_details || {};

        if (bom.commercial_details || loadedDispatch) {
        setCommercialDetails({
            klin_invoice_number: bom.commercial_details.klin_invoice_number || '',
            agreed_delivery_terms: bom.commercial_details.agreed_delivery_terms || '',
            dispatch_comments: bom.commercial_details.dispatch_comments || '',
            kl_invoice_file: bom.commercial_details.kl_invoice_file || [],
            other_commercial_attachments: bom.commercial_details.other_commercial_attachments || [],
            payment_status: bom.commercial_details.payment_status || '',
            dispatch_via: loadedDispatch.dispatch_via || '',
            awb_number: loadedDispatch.awb_number || '',
            mode_of_dispatch: loadedDispatch.mode_of_dispatch || '',
            dispatch_date: loadedDispatch.dispatch_date 
                    ? moment(loadedDispatch.dispatch_date).format('YYYY-MM-DD') 
                    : moment().format('YYYY-MM-DD')
        });
        } else {
            setCommercialDetails({
                klin_invoice_number: '',
                agreed_delivery_terms: '',
                dispatch_comments: '',
                kl_invoice_file: [],
                other_commercial_attachments: []
            });
        }
        if (bom.dispatch_checklist) {
            setFinalDispatchChecks({
                documents: {
                    test_report: bom.dispatch_checklist.documents?.test_report || false,
                    packing_list: bom.dispatch_checklist.documents?.packing_list || false,
                    approved_dap_layout: bom.dispatch_checklist.documents?.approved_dap_layout || false,
                    invoice: bom.dispatch_checklist.documents?.invoice || false,
                    delivery_challan: bom.dispatch_checklist.documents?.delivery_challan || false
                },
                visual_checks: {
                    correct_box_selection: bom.dispatch_checklist.visual_checks?.correct_box_selection || false,
                    bubble_wrap: bom.dispatch_checklist.visual_checks?.bubble_wrap || false,
                    no_material_contact: bom.dispatch_checklist.visual_checks?.no_material_contact || false,
                    no_loose_movement: bom.dispatch_checklist.visual_checks?.no_loose_movement || false,
                    packing_strip: bom.dispatch_checklist.visual_checks?.packing_strip || false
                },
                dispatch_checklist_attachments: bom.dispatch_checklist.dispatch_checklist_attachments || []
            });
        }
        if (bom.dispatch_checklist_pdir_report) {
            setDispatchChecks({
                documents: Array.isArray(bom.dispatch_checklist_pdir_report.documents) &&
                           bom.dispatch_checklist_pdir_report.documents.length === 3
                    ? bom.dispatch_checklist_pdir_report.documents
                    : [false, false, false],
        
                visuals: Array.isArray(bom.dispatch_checklist_pdir_report.visuals) &&
                         bom.dispatch_checklist_pdir_report.visuals.length === 5
                    ? bom.dispatch_checklist_pdir_report.visuals
                    : [false, false, false, false, false],
            });
        }
              
        setItems(
            (bom.items || []).map((it) => ({
                _id: getId((it._id)),
                part_ref: getId(it.part_ref) ?? getId(it.part_id),
                process_type_id: getId(it.process_type_id) ?? getId(it.process_id),
                steel_material_description: it.steel_material_description || '',
                finished_material_od_mm: it.finished_material_od_mm ?? '',
                finished_material_length_mm: it.finished_material_length_mm ?? '',
                raw_material_od_mm: it.raw_material_od_mm?? '',
                raw_material_length_mm: it.raw_material_length_mm ?? '',
                quantity: it.quantity ?? 1,
                document_number: it.document_number || '',
                procurement_done: !!it.procurement_done,
                is_rejected: it.is_rejected,
                rejection_reason: it.rejection_reason,
                rejection_date: it.rejection_date,
                procurement_source: it.procurement_source || 'Klingelnberg',
                manufacturing_steps: Array.isArray(it.manufacturing_steps)
                ? it.manufacturing_steps.map((s) => ({ ...s, attachments: s.attachments || [] }))
                : [],
                attachments: Array.isArray(it.attachments) ? it.attachments : [],
                selected_raw_material_ids: it.selected_raw_material_ids || [], // Add this line
                procurement_details: Array.isArray(it.procurement_details)
                ? it.procurement_details.map((detail) => ({
                    raw_material_id: getId(detail.raw_material_id), // Extract ID
                    length_allocated: detail.length_allocated ?? 0, // Keep value
                    _id: getId(detail._id), // Keep detail ID if available
                }))
                : [],
                ui_selected_od: it.raw_material_od_mm ?? '', 


            }))
        );
    }, [extractId, fetchAndSetDENameById, userDisplayName]);

    /* ---------------- 7) FETCH BOM BY :id ---------------- */
    useEffect(() => {
        if (!routeBomId) return;
        (async () => {
            try {
                const res = await getBomById({}, {}, routeBomId);
                const bom = res?.data?.result || res?.data;
                if (!bom) return ShowToast('BOM not found', TYPE_FAIL, INTERVAL, props, '');
                setBomData(bom);
                prefillFromBom(bom);
                setBomLoaded(true);
                if (bom.matched_inventory && Array.isArray(bom.matched_inventory)) {
                    setOriginalInventory(bom.matched_inventory);
                }

            } catch (e) {
                console.error('[CreateBomPage] getBomById failed:', e);
                ShowToast('Failed to load BOM', TYPE_FAIL, INTERVAL, props, '');
                setBomLoaded(true);
            }
        })();
    }, [routeBomId, prefillFromBom]);

const handleRejectItem = useCallback(async (rowData) => {
        const rejectionReason = window.prompt("Enter the reason for rejection* :");
        
        if (rejectionReason === null) return; 

        if (!rejectionReason.trim()) {
            ShowToast('Rejection reason is mandatory.', TYPE_FAIL, 1500, props, '');
            return;
        }

        const bomId = idOf(routeBomId);
        const itemId = idOf(rowData._id);

        try {
            const res = await rejectBomItem({}, bomId, itemId, { rejection_reason: rejectionReason });
            
            if (res?.data?.result) {
                const updatedBom = res.data.result;
                setBomData(updatedBom);
                prefillFromBom(updatedBom); 
                
                try {
                    const userData = JSON.parse(localStorage.getItem('userData'));
                    const auditData = {
                        logText: `Item (${rowData.partName || rowData.document_number}) Rejected. Reason: ${rejectionReason}`,
                        userID: userData?._id,
                        moduleName: 'Reject Item',
                        doc_id: bomId
                    };
                    await createHistoryList({}, auditData);
                } catch (logErr) {
                    console.error('Failed to create audit log for rejection:', logErr);
                }

                ShowToast('Item rejected and schedule has been reset.', TYPE_SUCCESS, 1500, props, '');
            }
        } catch (err) {
            console.error(err);
            ShowToast('Failed to reject item.', TYPE_FAIL, 1500, props, '');
        }
        finally{
            window.location.reload();
        }
    }, [routeBomId, props, prefillFromBom]);

    /* ---------------- 8) FIX SELECT LABELS AFTER LISTS ARRIVE ---------------- */
    useEffect(() => {
        if (!listsLoaded || !bomLoaded || !routeBomId) return; // create mode skips

        let changed = false;

        if (customer?.value && customers.length) {
            const n =
                labelFrom(customers, customer.value, 'customer_name') ||
                labelFrom(customers, customer.value, 'name');
            if (n && n !== customer.label) {
                setCustomer({ value: customer.value, label: n });
                changed = true;
            }
        }

        if (businessVertical?.value && businessVerticals.length) {
            const n = labelFrom(businessVerticals, businessVertical.value, 'name');
            if (n && n !== businessVertical.label) {
                setBusinessVertical({ value: businessVertical.value, label: n });
                changed = true;
            }
        }

        if (region?.value && regions.length) {
            const n = labelFrom(regions, region.value, 'name');
            if (n && n !== region.label) {
                setRegion({ value: region.value, label: n });
                changed = true;
            }
        }

        if (selectedSalesUser?.value && allSalesUsers.length) {
        const userObj = allSalesUsers.find(u => u._id === selectedSalesUser.value);
        if (userObj) {
            const label = `${userObj.first_name || ''} ${userObj.last_name || ''}`.trim() || userObj.username;
            if (label !== selectedSalesUser.label) {
                setSelectedSalesUser({ value: selectedSalesUser.value, label: label });
                changed = true;
            }
        }
    }

    if (assignedSupplier?.value && supplierUsers.length) {
        const u = supplierUsers.find(x => x._id === assignedSupplier.value);
        if (u) {
            const label = `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.company_name || u.username;
            if (label !== assignedSupplier.label) {
                setAssignedSupplier({ value: assignedSupplier.value, label });
                changed = true;
            }
        }
    }

        // If nothing changed in this pass, labels are resolved.
        if (!changed) setLabelsResolved(true);
    }, [
        routeBomId,
        listsLoaded,
        bomLoaded,
        customers,
        businessVerticals,
        allSalesUsers,
        regions,
        customer,
        businessVertical,
        region,
        selectedSalesUser
    ]);

    /* ---------------- 9) LOOKUP MAPPERS + ASYNC LOADERS ---------------- */

    const isDapReadOnly = useMemo(() => {
        if (isGlobalReadOnly) return true;
        if (initialUser.user_role === SUPER_ADMIN) {
            return false;
        }
        return bomData.current_stage && bomData.current_stage !== BOM_STAGES.DESIGN;
    }, [bomData.current_stage, isGlobalReadOnly, initialUser.user_role]);

    const mapPartToDocOption = useCallback(
        (p) => ({
            value: p._id,
            label: p.document_number || `(No Doc#) ${p.part_name}`, 
            part_name: p.part_name || 'Unnamed',
            _id: p._id,
            required_standerd_processes: p.required_standerd_processes, 
            required_steel_material: p.required_steel_material,
            od_mm: p.od_mm,
            length_mm: p.length_mm
        }),
        []
    );
    const mapPartToOption = useCallback(
        (p) => ({ value: p._id, label: p.part_name || 'Unnamed' }),
        []
    );

    //BOM HIstory
        useEffect(() => {
        if (!routeBomId) return;
        const fetchHistory = async () => {
            setHistoryLoading(true);
            try {
                const res = await getBomHistoryLogs({}, {}, routeBomId);
                console.log("History Log::", res?.data?.result);
                if (res?.data?.result) setHistoryLogs(res.data.result);
            } catch (error) {
                console.error("Failed to load history:", error);
            } finally {
                setHistoryLoading(false);
            }
        };
        fetchHistory();
    }, [routeBomId]);
    const rawFetchPartsByDocNo = useCallback(
        async (inputValue) => {
            const q = (inputValue || '').trim().toLowerCase();
            try {
                const res = await searchPartsByDocNo({ q, search: q }, {});
                const list = res?.data?.result || [];
                return list.map(mapPartToDocOption);
            } catch {
                const list = parts || [];
                const filtered = q
                    ? list.filter((p) => 
                            p.part_type === 'Standard' &&
                            (p.document_number || '').toLowerCase().includes(q)
                      )
                    : list.filter(p => p.part_type === 'Standard');
                return filtered.map(mapPartToDocOption);
            }
        },
        [parts, mapPartToDocOption]
    );
    const filteredParts = parts.filter(p => p.part_type !== 'Raw Material');
    const mapProcessToOption = useCallback(
        (p) => ({ value: p._id, label: p.process_title || 'Untitled' }),
        []
    );

    const rawFetchParts = useCallback(
        async (inputValue) => {
            const q = (inputValue || '').trim().toLowerCase();
            try {
                const res = await getPartList({ q, search: q, name: q }, {});
                const list = res?.data?.result || [];
                const filtered = q
                    ? list.filter(p => (p.part_name || '').toLowerCase().includes(q))
                    : list;
                return filtered.map(mapPartToOption);
            } catch {
                const list = parts || [];
                const filtered = q
                    ? list.filter(p => (p.part_name || '').toLowerCase().includes(q))
                    : list;
                return filtered.map(mapPartToOption);
            }
        },
  [parts, mapPartToOption]
);

    const rawFetchProcesses = useCallback(
        async (inputValue) => {
            const q = (inputValue || '').trim().toLowerCase();
            try {
                const res = await getStdProcessList({ q, search: q, title: q }, {});
                const list = res?.data?.result || [];
                const filtered = q
                    ? list.filter(p => (p.process_title || '').toLowerCase().includes(q))
                    : list;
                return filtered.map(mapProcessToOption);
            } catch {
                const list = stdProcesses || [];
                const filtered = q
                    ? list.filter(p => (p.process_title || '').toLowerCase().includes(q))
                    : list;
                return filtered.map(mapProcessToOption);
            }
        },
        [stdProcesses, mapProcessToOption]
    );
     
    const loadDocOptions = useDebounced(rawFetchPartsByDocNo, 300);
    const loadPartOptions = useDebounced(rawFetchParts, 300);
    const loadProcessOptions = useDebounced(rawFetchProcesses, 300);
    const steelMaterialOptions = useMemo(() => {
        if (!parts || parts.length === 0) return [];

        const allMaterials = parts
            .map((p) => p.steel_material_description)
            .filter((material) => typeof material === 'string' && material.trim() !== '');

        const uniqueMaterials = [...new Set(allMaterials)];
        uniqueMaterials.sort();

        return uniqueMaterials.map((material) => ({ value: material, label: material }));
    }, [parts]);

    const defaultPartDocOptions = useMemo(() => {
        const standardParts = parts.filter(p => p.part_type === 'Standard');
        
        const withDocNo = standardParts
            .filter((p) => p.document_number)
            .map(mapPartToDocOption);
            
        const withoutDocNo = standardParts
            .filter((p) => !p.document_number)
            .map(mapPartToDocOption);
        return [...withDocNo, ...withoutDocNo];
    }, [parts, mapPartToDocOption]);

    const partMap = useMemo(
        () => Object.fromEntries(parts.map((p) => [p._id, p.part_name])),
        [parts]
    );
    const processMap = useMemo(
        () => Object.fromEntries(stdProcesses.map((p) => [p._id, p.process_title])),
        [stdProcesses]
    );

    // Filter Sales Users based on selected Region
    const filteredSalesOptions = useMemo(() => {
        if (!region || !region.value) return [];

        return allSalesUsers
            .filter(user => {
                return Array.isArray(user.region_id) && user.region_id.includes(region.value);
            })
            .map(user => ({
                value: user._id,
                label: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.username
            }));
    }, [allSalesUsers, region]);


    /* ---------------- 10) VALIDATION + SUBMIT ---------------- */
    const validateForm = useCallback(() => {
        const errs = [];
        if (!fixtureDocNo.trim()) errs.push('Fixture Document Number is required');
        if (!fixtureName.trim()) errs.push('Fixture Name is required');
        if (!mfgReleaseDate) errs.push('Manufacturing Release Date is required');
        if (!customer?.value) errs.push('Customer is required');
        if (!machine.trim()) errs.push('Machine is required');
        if (drawingNumbers.length === 0) errs.push('Component Drawing Number(s) are required');
        // if (!dapDate) errs.push('DAP Date is required');
        if (!surfaceTreatmentType.trim()) errs.push('Surface Treatment Type is required');
        if (!businessVertical?.value) errs.push('Business Vertical is required');
        if (!region?.value) errs.push('Region is required');
        if (items.length === 0) errs.push('Add at least one BOM item');

        items.forEach((it, idx) => {
            if (!it.part_ref) errs.push(`Row ${idx + 1}: Part is required`);
            if (!it.process_type_id) errs.push(`Row ${idx + 1}: Std Process is required`);
            if (!(Number(it.finished_material_od_mm) >= 0)) errs.push(`Row ${idx + 1}: OD must be ≥ 0`);
            if (!(Number(it.finished_material_length_mm) >= 0))
                errs.push(`Row ${idx + 1}: Length must be ≥ 0`);
            if (!(Number(it.quantity) >= 1)) errs.push(`Row ${idx + 1}: Qty must be ≥ 1`);
        });

        if (errs.length) {
            ShowToast(errs[0], TYPE_FAIL);
            return false;
        }
        return true;
    }, [
        fixtureDocNo,
        fixtureName,
        mfgReleaseDate,
        customer,
        endClient,
        machine,
        drawingNumbers,
        dapDate,
        surfaceTreatmentType,
        businessVertical,
        region,
        items,
        props,
    ]);

    const onUpdate = useCallback(
        async (e, validationDetailsOverride = null) => {
            e?.preventDefault?.();

            if (isSaving) return;
            if (!validateForm()) {
                return;
            } else {
                setIsSaving(true);
                const drawings = drawingNumbers.map((opt) => opt.value);
                const finalTestReport = {
                    ...testReport,
                    approved_by: testReportApprovedBy || undefined,
                };

                const finalValidationDetails = await processValidationAttachments(validationDetailsOverride || bomData.validation_details);
                let payload; 
                if(bomData.current_stage === BOM_STAGES.DESIGN){
                    payload = {
                        design_engineer_id: designEngineerId || undefined,
                        fixture_document_number: fixtureDocNo.trim(),
                        fixture_name: fixtureName.trim(),
                        manufacturing_release_date: mfgReleaseDate ? new Date(mfgReleaseDate) : undefined,
                        customer_id: customer?.value || undefined,
                        end_client: endClient || undefined,
                        machine: machine.trim(),
                        component_drawing_numbers: drawings,
                        po_id: selectedPoId || selectedPoIdFromUrl || undefined,
                        po_reference: poRef.trim() || undefined,
                        dap_date: dapDate ? new Date(dapDate) : undefined,
                        dap_attachments: dapAttachments,
                        surface_treatment_type: surfaceTreatmentType.trim(),
                        business_vertical_id: businessVertical?.value || undefined,
                        region_id: region?.value || undefined,
                        
                        sales_coordinator_id: selectedSalesUser?.value || undefined,

                        items: items.map((it) => ({
                            _id: idOf(it._id),
                            part_ref: it.part_ref,
                            process_type_id: it.process_type_id,
                            steel_material_description: it.steel_material_description || undefined,
                            finished_material_od_mm: Number(it.finished_material_od_mm),
                            finished_material_length_mm: Number(it.finished_material_length_mm),
                            quantity: Number(it.quantity),
                            document_number: it.document_number,
                            procurement_done: Boolean(it.procurement_done),
                            is_rejected: it.is_rejected, 
                            rejection_reason: it.rejection_reason,
                            rejection_date: it.rejection_date,
                            attachments: Array.isArray(it.attachments) ? it.attachments : []

                        })),
                    };
                }else {
                    payload = {
                    // design_engineer_id: designEngineerId || undefined,
                    fixture_document_number: fixtureDocNo.trim(),
                    fixture_name: fixtureName.trim(),
                    manufacturing_release_date: mfgReleaseDate
                        ? new Date(mfgReleaseDate)
                        : undefined,
                    customer_id: customer?.value || undefined,
                    end_client: endClient || undefined,
                    machine: machine.trim(),
                    component_drawing_numbers: drawings,
                    po_id: selectedPoId || bomData.po_id || undefined,
                    po_reference: poRef.trim() || undefined,
                    dap_date: dapDate ? new Date(dapDate) : undefined,
                    dap_attachments: dapAttachments,
                    surface_treatment_type: surfaceTreatmentType.trim(),
                    business_vertical_id: businessVertical?.value || undefined,
                    region_id: region?.value || undefined,
                    testing_done: Boolean(bomTestingDone),
                    test_report_approved_date: testReportApprovedDate,
                    // testing_remark: bomTestingRemark || undefined,
                    testing_buffer_days: Number(bomTestingBufferDays) || 0,
                    test_report: finalTestReport,
                    // testing_attachments: Array.isArray(bomTestingAttachments) ? bomTestingAttachments : [],
                    fixture_ready_to_dispatch: Boolean(bomDispatchReady),
                    dispatch_remark: bomDispatchRemark || undefined,
                    dispatch_attachments: Array.isArray(bomDispatchAttachments) ? bomDispatchAttachments : [],
                    projected_completion_date: projectedCompletionDate || undefined,
                    dispatch_checklist: finalDispatchChecks,
                    supplier_invoice_details: supplierInvoiceDetails,
                    supplier_id: assignedSupplier?.value || undefined,
                    sales_coordinator_id: selectedSalesUser?.value || undefined,
                    validation_details: finalValidationDetails,
                    commercial_details: {
                        klin_invoice_number: commercialDetails.klin_invoice_number,
                        agreed_delivery_terms: commercialDetails.agreed_delivery_terms,
                        dispatch_comments: commercialDetails.dispatch_comments,
                        payment_status: commercialDetails.payment_status,
                        kl_invoice_file: commercialDetails.kl_invoice_file,
                        other_commercial_attachments: commercialDetails.other_commercial_attachments
                    },
                
                    dispatch_details: {
                        dispatch_via: commercialDetails.dispatch_via,
                        awb_number: commercialDetails.awb_number,
                        mode_of_dispatch: commercialDetails.mode_of_dispatch,
                        dispatch_date: commercialDetails.dispatch_date 
                            ? new Date(commercialDetails.dispatch_date) 
                            : new Date()
                    },
                        items: items.map((it) => ({
                        part_ref: it.part_ref,
                        process_type_id: it.process_type_id,
                        steel_material_description: it.steel_material_description || undefined,
                        finished_material_od_mm: Number(it.finished_material_od_mm),
                        finished_material_length_mm: Number(it.finished_material_length_mm),
                        raw_material_od_mm: Number(it.raw_material_od_mm) || undefined,
                        raw_material_length_mm: Number(it.raw_material_length_mm) || undefined,
                        quantity: Number(it.quantity),
                        document_number: it.document_number,
                        procurement_source: it.procurement_source,
                        procurement_done: Boolean(it.procurement_done),
                        is_rejected: it.is_rejected, 
                        rejection_reason: it.rejection_reason,
                        rejection_date: it.rejection_date,
                        attachments: Array.isArray(it.attachments) ? it.attachments : [],
                        manufacturing_steps: Array.isArray(it.manufacturing_steps) ? it.manufacturing_steps : [],
                        procurement_details: it.procurement_details || []
                    })),
                };
            }
            
                try {
                   await updateBOM({}, payload, routeBomId);
                    ShowToast(
                        'BOM updated successfully',
                        TYPE_SUCCESS,
                        INTERVAL,
                        props,
                        // '/bom-list'
                    );
                } catch (err) {
                    const msg =
                        err?.response?.data?.error || err?.message || 'Failed to update BOM';
                    ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
                } finally {
                    setIsSaving(false);
                }    
            }
        },
        [
            validateForm,
            drawingNumbers,
            designEngineerId,
            fixtureDocNo,
            fixtureName,
            mfgReleaseDate,
            customer,
            machine,
            poRef,
            dapDate,
            dapAttachments,
            surfaceTreatmentType,
            businessVertical,
            region,
            items,
            props,
            routeBomId,
            bomData,
            bomTestingDone,
            bomTestingRemark,
            bomTestingBufferDays,
            bomTestingAttachments,
            bomDispatchReady,
            bomDispatchRemark,
            bomDispatchAttachments,
            bomData.current_stage,
            projectedCompletionDate,
            supplierInvoiceDetails,
            commercialDetails,
            isSaving,
            selectedSalesUser,
            testReport,
            testReportApprovedBy,
            testReportApprovedDate,
            assignedSupplier
        ]
    );

    const onSubmit = useCallback(
        async (e) => {
            e?.preventDefault?.();
            if (isSaving) return;
            if (!validateForm()) return;

            setIsSaving(true);

            const drawings = drawingNumbers.map((opt) => opt.value);
            const payload = {
                design_engineer_id: designEngineerId || undefined,
                fixture_document_number: fixtureDocNo.trim(),
                fixture_name: fixtureName.trim(),
                manufacturing_release_date: mfgReleaseDate ? new Date(mfgReleaseDate) : undefined,
                customer_id: customer?.value || undefined,
                end_client: endClient || undefined,
                machine: machine.trim(),
                component_drawing_numbers: drawings,
                po_id: selectedPoId || selectedPoIdFromUrl || undefined,
                po_reference: poRef.trim() || undefined,
                dap_date: dapDate ? new Date(dapDate) : undefined,
                dap_attachments: dapAttachments,
                surface_treatment_type: surfaceTreatmentType.trim(),
                business_vertical_id: businessVertical?.value || undefined,
                region_id: region?.value || undefined,
                sales_coordinator_id: selectedSalesUser?.value || undefined,

                items: items.map((it) => ({
                    part_ref: it.part_ref,
                    process_type_id: it.process_type_id,
                    steel_material_description: it.steel_material_description || undefined,
                    finished_material_od_mm: Number(it.finished_material_od_mm),
                    finished_material_length_mm: Number(it.finished_material_length_mm),
                    quantity: Number(it.quantity),
                    document_number: it.document_number,
                    procurement_done: Boolean(it.procurement_done),
                    attachments: Array.isArray(it.attachments) ? it.attachments : []

                })),
            };
            let auditresponse = null;
            let userData = JSON.parse(localStorage.getItem('userData'));
            let userID = userData._id;
            let logText = LOG_TEXT.BOM_ADDED;
            let moduleName = MODULE_NAMES.CREATE_BOM;
            try {
                const res_bom = await createBOM({}, payload);
                const bomData = res_bom.data.result;
                const auditData = {
                    logText,
                    userID,
                    moduleName,
                    doc_id: bomData._id
                };
                auditresponse = await createHistoryList({}, auditData);
                ShowToast(
                    'BOM created successfully',
                    TYPE_SUCCESS,
                    INTERVAL,
                    props,
                    '/bom-list'
                );
            } catch (err) {
                const msg = err?.response?.data?.error || err?.message || 'Failed to create BOM';
                ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
            } finally {
                setIsSaving(false);
            }
        },
        [
            isSaving,
            validateForm,
            drawingNumbers,
            designEngineerId,
            fixtureDocNo,
            fixtureName,
            mfgReleaseDate,
            customer,
            endClient,
            machine,
            poRef,
            selectedPoId,
            selectedPoIdFromUrl,
            dapDate,
            dapAttachments,
            surfaceTreatmentType,
            businessVertical,
            region,
            items,
            props,
            selectedSalesUser
        ]
    );

    const updateBomCall = async () => {
        try {
            await onUpdate();
        } catch (updateError) {
            console.error("Update failed before approval:", updateError);
            ShowToast("Update failed. Please try again before approving.", TYPE_FAIL, INTERVAL, props, '');
            return;
        }
    }

const handleFinalApproval = useCallback(async (comment = "", locationOverride = null) => {        
        const currentStage = bomData.current_stage || BOM_STAGES.DESIGN;
        let nextStage = '';

        if (currentStage === BOM_STAGES.DESIGN) {
            nextStage = BOM_STAGES.PROCUREMENT;
        } else if (currentStage === BOM_STAGES.PROCUREMENT) {
            nextStage = BOM_STAGES.MANUFACTURING_PLANNING;
        } else if (currentStage === BOM_STAGES.MANUFACTURING_PLANNING) {
            nextStage = BOM_STAGES.MANUFACTURING_EXECUTION;
        } else if (currentStage === BOM_STAGES.MANUFACTURING_EXECUTION) {
            nextStage = BOM_STAGES.TESTING;
        } else if (currentStage === BOM_STAGES.TESTING) {
            nextStage = BOM_STAGES.DISPATCH;
        } else if (currentStage === BOM_STAGES.DISPATCH) {
            nextStage = BOM_STAGES.COMMERCIAL_CLEARANCE;
        } 
        else if (currentStage === BOM_STAGES.COMMERCIAL_CLEARANCE) {
            nextStage = BOM_STAGES.HANDOVER_TO_DISPATCH;
        } else if (currentStage === BOM_STAGES.HANDOVER_TO_DISPATCH) {
            nextStage = BOM_STAGES.COMPLETED;
        } 
        else if (currentStage === BOM_STAGES.COMPLETED) {
            nextStage = BOM_STAGES.VALIDATION;
        }
        else {
            ShowToast(`Approval not yet defined for stage: ${currentStage}`, TYPE_FAIL, INTERVAL, props, '');
            return;
        }

        if (!nextStage) return;

        if (window.confirm(`Are you sure you want to approve the BOM and move it to ${nextStage}?`)) {
            // updateBomCall()

            if (currentStage === BOM_STAGES.PROCUREMENT) {
                const partials = [];
                const fully = [];
                const zero = [];
                items.forEach(it => {
                    const ua = unitsAllocatedOf(it);
                    const q = Number(it.quantity || 0);
                    if (ua > 0 && ua < q) partials.push(it);
                    else if (ua >= q || it.procurement_done) fully.push(it);
                    else zero.push(it);
                });
                if (partials.length) {
                    const ok = window.confirm(
                    `Partial procurement detected for ${partials.length} item(s).\n` +
                    `Press OK to split and move allocated quantities to Manufacturing-Planning.`
                    );
                    if (!ok) return;
                    for (const it of partials) {
                    const resp = await splitBomItemToPlanning({}, routeBomId, idOf(it._id));
                    if (resp?.status !== 'SUCCESS') {
                        ShowToast(resp?.message || 'Split failed', TYPE_FAIL, INTERVAL, props, '');
                        return;
                    }
                    }
                    try {
                    const refreshed = await getBomById({}, {}, routeBomId);
                    const bom = refreshed?.data?.result || refreshed?.data;
                    if (bom) {
                        setBomData(bom);
                        prefillFromBom(bom);
                        ShowToast('Moved allocated quantities to Manufacturing-Planning', TYPE_SUCCESS, INTERVAL, props, '');
                    }
                    } catch {}
                    return;
                }
                const allProcured = items.every(item => {
                    const ua = unitsAllocatedOf(item);
                    const q = Number(item.quantity || 0);
                    return ua >= q || item.procurement_done;
                });
                //    if (!allProcured) {
                //      ShowToast('Some items are still not procured.', TYPE_FAIL, INTERVAL, props, '');
                //      return;
                //    }
            }

            let finalReleaseDate = mfgReleaseDate ? new Date(mfgReleaseDate) : undefined;
        
            if (currentStage === BOM_STAGES.DESIGN && nextStage === BOM_STAGES.PROCUREMENT) {
               finalReleaseDate = new Date(); // Force "Now" on Release click
            }

            setIsSaving(true);


            const drawings = drawingNumbers.map((opt) => opt.value);

            const finalTestReport = {
                ...testReport,
                approved_by: testReportApprovedBy || undefined,
            };
            const payload = {
                fixture_document_number: fixtureDocNo.trim(),
                fixture_name: fixtureName.trim(),
                supplier_id: selectedSupplier?.value || undefined,
                manufacturing_release_date: finalReleaseDate,
                customer_id: customer?.value || undefined,
                end_client: endClient || undefined,
                machine: machine.trim(),
                component_drawing_numbers: drawings,
                po_reference: poRef.trim() || undefined,
                dap_date: dapDate ? new Date(dapDate) : undefined,
                dap_attachments: dapAttachments,
                surface_treatment_type: surfaceTreatmentType.trim(),
                business_vertical_id: businessVertical?.value || undefined,
                region_id: region?.value || undefined,

                // --- Stage & Status Fields ---
                stage_at_comment: currentStage,
                current_stage: nextStage, // The key change
                
                testing_done: Boolean(bomTestingDone),
                test_report_approved_date: testReportApprovedDate,
                testing_buffer_days: Number(bomTestingBufferDays) || 0,
                test_report: finalTestReport,
                
                fixture_ready_to_dispatch: Boolean(bomDispatchReady),
                dispatch_remark: bomDispatchRemark || undefined,
                dispatch_attachments: Array.isArray(bomDispatchAttachments) ? bomDispatchAttachments : [],
                dispatch_checklist: finalDispatchChecks,
                current_stage: nextStage,
                approval_comment: comment,
                action_by_user_id: initialUser._id || initialUser.id,
                action_by_user_name: `${initialUser.first_name} ${initialUser.last_name}`,
                fixture_location: locationOverride !== null ? locationOverride : fixtureLocation,

                items: items.map((it) => ({
                    _id: idOf(it._id),
                    part_ref: it.part_ref,
                    process_type_id: it.process_type_id,
                    steel_material_description: it.steel_material_description || undefined,
                    finished_material_od_mm: Number(it.finished_material_od_mm),
                    finished_material_length_mm: Number(it.finished_material_length_mm),
                    
                    raw_material_od_mm: Number(it.raw_material_od_mm) || undefined, 
                    raw_material_length_mm: Number(it.raw_material_length_mm) || undefined,
                    
                    procurement_source: it.procurement_source,
                    quantity: Number(it.quantity),
                    document_number: it.document_number,
                    procurement_done: Boolean(it.procurement_done),
                    is_rejected: it.is_rejected, 
                    rejection_reason: it.rejection_reason,
                    rejection_date: it.rejection_date,
                    attachments: Array.isArray(it.attachments) ? it.attachments : [],
                    manufacturing_steps: Array.isArray(it.manufacturing_steps) ? it.manufacturing_steps : [],
                    procurement_details: it.procurement_details || []
                })),
            };
            let auditresponse = null;
            let userData = JSON.parse(localStorage.getItem('userData'));
            let userID = userData._id;
            let logText = `${LOG_TEXT.BOM_APPROVED} ${nextStage}`;
            if (comment && comment.trim()) {
                logText += `. Comment: "${comment}"`;
            }
            let moduleName = MODULE_NAMES.APPROVE_BOM;
            try {
                const res_bom = await updateBOM({ 'Content-Type': 'application/json' }, payload, routeBomId);
                const bomData = res_bom.data.result;
                const auditData = {
                    logText,
                    userID,
                    moduleName,
                    doc_id: bomData._id
                };
                auditresponse = await createHistoryList({}, auditData);
                ShowToast(`BOM approved and moved to ${nextStage}`, TYPE_SUCCESS, INTERVAL, props, '/bom-list');
            } catch (err) {
                const msg = err?.response?.data?.error || err?.message || 'Failed to approve BOM';
                ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
                setIsSaving(false);
            } 
            // finally {
            //     setIsSaving(false);
            // }
        }
    }, [
        /* Keep all the original dependencies from onApprove */
        routeBomId, validateForm, drawingNumbers, designEngineerId, fixtureDocNo,
        fixtureName, mfgReleaseDate, customer, machine, poRef, dapDate, dapAttachments,
        surfaceTreatmentType, businessVertical, region, items, props, bomData.current_stage,
        bomTestingDone, bomTestingBufferDays, bomTestingRemark, bomTestingAttachments, bomDispatchReady, bomDispatchRemark, bomDispatchAttachments,
        isSaving, selectedSupplier, fixtureLocation, approvalComment,
        testReport,
        testReportApprovedBy,
        testReportApprovedDate
    ]
    );

    // const onApproveClick = async (e) => {
    //     e?.preventDefault?.();

    //     if (!routeBomId) {
    //         ShowToast('Save the BOM before approving it.', TYPE_FAIL, INTERVAL, props, '');
    //         return;
    //     }
    //     if (!validateForm()) return;
    //     if (bomData.current_stage === BOM_STAGES.PROCUREMENT) {
    //         const allProcured = items.every(item => item.procurement_done);

    //         const anyItemProcured = items.some(item => item.procurement_done);
    //         if (items.length > 0 && !anyItemProcured) {
    //              ShowToast(
    //                 'Cannot approve. At least one item must be marked as "Procured".', 
    //                 TYPE_FAIL, 
    //                 2000,
    //                 props, 
    //                 ''
    //              );
    //              return;
    //         }
    //         // if (allProcured) {
    //             handleFinalApproval(); 
    //             return;
    //         // } else {
    //         //     ShowToast('Not all items are procured. Complete procurement before approving for Manufacturing.', TYPE_FAIL, INTERVAL, props, '');
    //         //     return;
    //         // }
    //     }

    //     if (bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) {
    //         const allStepsCompleted = items.every(item =>
    //             Array.isArray(item.manufacturing_steps) && item.manufacturing_steps.length > 0 &&
    //             item.manufacturing_steps.every(step => step.status === 'Completed')
    //         );

    //         if (!allStepsCompleted) {
    //             ShowToast(
    //                 'You cannot approve yet. Not all manufacturing steps are marked as "Completed".',
    //                 TYPE_FAIL,
    //                 1500,
    //                 props,
    //                 ''
    //             );
    //             return;
    //         }
    //         handleFinalApproval();
    //         return;
    //     }

    //     if (bomData.current_stage === BOM_STAGES.TESTING){
    //         if (!bomTestingDone) {
    //             ShowToast(
    //                 'You cannot approve yet. Testing must be completed before dispatch.',
    //                 TYPE_FAIL,
    //                 2000,
    //                 props,
    //                 ''
    //             );
    //             return;
    //         }
    //         handleFinalApproval();
    //         return;


    //     }
    //     if (bomData.current_stage === BOM_STAGES.DISPATCH) {

    //                 if (!bomDispatchReady || !bomTestingDone) {
    //                     ShowToast(
    //                         'Cannot approve: Both Testing must be completed and Fixture must be marked "Ready for Dispatch".',
    //                         TYPE_FAIL,
    //                         2500,
    //                         props,
    //                         ''
    //                     );
    //                     updateBomCall(); 
    //                     return;
    //                 }
    //                 handleFinalApproval();
    //                 return;
    //             }    
    //             setApprovalDialogOpen(true);

    //             // Set pending stage and open dialog
    //             setPendingNextStage(nextStage);
    //             setApprovalComment(""); // Reset comment
    //             setIsCommentDialogOpen(true);


    // }

    const onApproveClick = async (e) => {
        e?.preventDefault?.();

        // 1. Basic Checks
        if (!routeBomId) {
            ShowToast('Save the BOM before approving it.', TYPE_FAIL, INTERVAL, props, '');
            return;
        }
        if (!validateForm()) return;

        // 2. Determine Next Stage (Required for the Dialog state)
        const currentStage = bomData.current_stage || BOM_STAGES.DESIGN;
        let nextStage = '';

        if (currentStage === BOM_STAGES.DESIGN) {
            nextStage = BOM_STAGES.PROCUREMENT;
        } else if (currentStage === BOM_STAGES.PROCUREMENT) {
            nextStage = BOM_STAGES.MANUFACTURING_PLANNING;
        } else if (currentStage === BOM_STAGES.MANUFACTURING_PLANNING) {
            nextStage = BOM_STAGES.MANUFACTURING_EXECUTION;
        } else if (currentStage === BOM_STAGES.MANUFACTURING_EXECUTION) {
            nextStage = BOM_STAGES.TESTING;
        } else if (currentStage === BOM_STAGES.TESTING) {
            nextStage = BOM_STAGES.DISPATCH;
        } else if (currentStage === BOM_STAGES.DISPATCH) {
            nextStage = BOM_STAGES.HANDOVER_TO_DISPATCH;
        } else if (currentStage === BOM_STAGES.COMPLETED) {
            nextStage = BOM_STAGES.VALIDATION;
        }

        // 3. Stage-Specific Validation Guards

        // --- PROCUREMENT CHECK ---
        if (currentStage === BOM_STAGES.PROCUREMENT) {
            const anyItemProcured = items.some(item => item.procurement_done);
            if (items.length > 0 && !anyItemProcured) {
                ShowToast(
                    'Cannot approve. At least one item must be marked as "Procured".', 
                    TYPE_FAIL, 
                    2000,
                    props, 
                    ''
                );
                return;
            }
        }

        // --- MANUFACTURING EXECUTION CHECK ---
        if (currentStage === BOM_STAGES.MANUFACTURING_EXECUTION) {
            const allStepsCompleted = items.every(item =>
                Array.isArray(item.manufacturing_steps) && item.manufacturing_steps.length > 0 &&
                item.manufacturing_steps.every(step => step.status === 'Completed')
            );

            if (!allStepsCompleted) {
                ShowToast(
                    'You cannot approve yet. Not all manufacturing steps are marked as "Completed".',
                    TYPE_FAIL,
                    1500,
                    props,
                    ''
                );
                updateBomCall();
                return;
            }
            const isInvoiceDetailsFilled = supplierInvoiceDetails.invoice_number && supplierInvoiceDetails.invoice_value;
            
            if (!isInvoiceDetailsFilled) {
                const confirmProceed = window.confirm(
                    "Supplier invoice details are not filled. Do you want to proceed anyway?"
                );
                
                if (!confirmProceed) {
                    return; 
                }
            }
            updateBomCall();
        }

        // --- TESTING CHECK ---
        if (currentStage === BOM_STAGES.TESTING) {
            if (!bomTestingDone) {
                ShowToast(
                    'You cannot approve yet. Testing must be completed before dispatch.',
                    TYPE_FAIL,
                    2000,
                    props,
                    ''
                );
                return;
            }
        }

        // --- DISPATCH CHECK ---
        if (currentStage === BOM_STAGES.DISPATCH) {
            if (!bomDispatchReady || !bomTestingDone) {
                ShowToast(
                    'Cannot approve: Both Testing must be completed and Fixture must be marked "Ready for Dispatch".',
                    TYPE_FAIL,
                    2500,
                    props,
                    ''
                );
                updateBomCall(); // Save current state so checkboxes persist
                return;
            }
            setIsLocationDialogOpen(true);
            return;
        }

        if (currentStage === BOM_STAGES.COMMERCIAL_CLEARANCE) {
            if (!commercialDetails.klin_invoice_number) {
                ShowToast('Please enter the Invoice Number before clearing.', TYPE_FAIL, 2000);
                updateBomCall();
                return;
            }
            updateBomCall();       
            handleFinalApproval(""); 
            return;
            
        }

        if (currentStage === BOM_STAGES.HANDOVER_TO_DISPATCH) {
            if (!isChecklistComplete) {
                ShowToast(
                    'Please complete the Final Dispatch Inspection Checksheet before completing dispatch.',
                    TYPE_FAIL,
                    3000,
                    props,
                    ''
                );
                setIsDispatchChecklistOpen2(true);
                return;
            }

            setIsCompleteDispatchDialogOpen(true);
            return;
        }


        if (currentStage === BOM_STAGES.DESIGN) {
            setApprovalDialogOpen(true);
            return;
        }

        if (currentStage === BOM_STAGES.TESTING || currentStage === BOM_STAGES.DISPATCH) {
             handleFinalApproval(""); 
             return;
        }

        // All Other Stages: Open the Comment/Instruction Dialog
        if (nextStage) {
            setPendingNextStage(nextStage);
            setApprovalComment(""); // Reset comment field
            setIsCommentDialogOpen(true); // Open the new dialog
        } else {
            ShowToast('Error: Could not determine next stage.', TYPE_FAIL, INTERVAL, props, '');
        }
    }

    const areAllChecksComplete = () => {
        return Object.keys(approvalChecks).every(key => {
            const check = approvalChecks[key];

            if (typeof check === 'boolean') {
                return check;
            }

            if (typeof check === 'object' && check.hasOwnProperty('isExport')) {
                if (check.isExport === false) { 
                    return true; 
                }
                return check.sub.every(Boolean); 
            }

            if (typeof check === 'object' && check.sub) {
                return check.sub.every(Boolean); 
            }
            
            return false;
        });
    };
    const handleCloseApprovalDialog = () => {
        setApprovalDialogOpen(false);
        // Reset checks when dialog is closed
        setApprovalChecks({
            q1: false,
            q2: false,
            q3: false,
            q4: {
                sub: [false, false, false, false, false]
            },
            q5: false,
            q6: {
                sub: [false, false, false, false]
            },
            q7: {
                sub: [false, false, false, false]
            },
            q8: false,
          q9: {
                isExport: false,
                sub: [false, false]
            }
        });
    };

    const handleDialogApprove = () => {
        handleCloseApprovalDialog();
        
        const nextStage = BOM_STAGES.PROCUREMENT;
        
        setPendingNextStage(nextStage);
        setApprovalComment(""); 
        setIsCommentDialogOpen(true); 
    };


    const onCancel = () => {
        window.location.href = '/bom-list';
    };
//     const handleApproveWithSupplier = useCallback(async () => {
//     if (!selectedSupplier?.value) {
//         ShowToast('Please select a supplier.', TYPE_FAIL, INTERVAL, props, '');
//         return;
//     }
//     if (!validateForm()) return;
//     setSupplierDialogOpen(false);

//     // 3. Set up the next stage (Manufacturing Execution)
//     setPendingNextStage(BOM_STAGES.MANUFACTURING_EXECUTION);
//     setApprovalComment(""); // Reset comment field

//     // 4. Open the Comment/Instruction Dialog
//     setIsCommentDialogOpen(true)

//     const drawings = drawingNumbers.map((opt) => opt.value);

//     const payload = {
//         supplier_id : selectedSupplier.value,
//         current_stage : BOM_STAGES.MANUFACTURING_EXECUTION,
//         testing_buffer_days: Number(bomTestingBufferDays) || 0,
//         items: items.map((it) => ({
//             _id: idOf(it._id),
//             part_ref: it.part_ref,
//             process_type_id: it.process_type_id,
//             steel_material_description: it.steel_material_description || undefined,
//             finished_material_od_mm: Number(it.finished_material_od_mm),
//             finished_material_length_mm: Number(it.finished_material_length_mm),
//             raw_material_od_mm: it.raw_material_od_mm,
//             raw_material_length_mm: it.raw_material_length_mm,
//             quantity: Number(it.quantity),
//             document_number: it.document_number,
//             procurement_source: it.procurement_source,
//             procurement_done: Boolean(it.procurement_done),
//             attachments: Array.isArray(it.attachments) ? it.attachments : [],
//             manufacturing_steps: Array.isArray(it.manufacturing_steps) ? it.manufacturing_steps : [],
//             procurement_details: it.procurement_details || []
//         })),
//         }
    
//     try {
//         await updateBOM({}, payload, routeBomId);
//         ShowToast(`BOM approved and moved to Manufacturing stage 2`, TYPE_SUCCESS, INTERVAL, props, '/bom-list');
//         setSupplierDialogOpen(false);
//     } catch (err) {
//         const msg = err?.response?.data?.error || 'Failed to approve BOM with supplier';
//         ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
//     }
// }, [
//     selectedSupplier, routeBomId, validateForm, drawingNumbers, designEngineerId, fixtureDocNo,
//     fixtureName, mfgReleaseDate, customer, machine, poRef, dapDate, surfaceTreatmentType,
//     businessVertical, region, items, props, bomTestingDone, bomTestingRemark,
//     bomTestingAttachments, bomDispatchReady, 
// ]);

const handleApproveWithSupplier = useCallback(() => {
    // 1. Validation
    if (!selectedSupplier?.value) {
        ShowToast('Please select a supplier.', TYPE_FAIL, INTERVAL, props, '');
        return;
    }
    if (!validateForm()) return;

    // 2. Close the Supplier Dialog
    setSupplierDialogOpen(false);

    // 3. Set up the next stage
    setPendingNextStage(BOM_STAGES.MANUFACTURING_EXECUTION);
    setApprovalComment(""); // Reset comment field

    // 4. Open the Comment/Instruction Dialog
    // STOP HERE: Do not run updateBOM(). The Comment Dialog will handle that.
    setIsCommentDialogOpen(true);

}, [selectedSupplier, validateForm, props]);

const handleAddCustomStep = useCallback((itemIndex, afterStepIndex) => {
            setItems(prevItems => {
                const newItems = [...prevItems];
                const itemToUpdate = { ...newItems[itemIndex] };
                
                let manufacturingSteps = Array.isArray(itemToUpdate.manufacturing_steps)
                    ? [...itemToUpdate.manufacturing_steps]
                    : [];

                const newCustomStep = {
                    step_ref: null,
                    step_title_snapshot: 'New Custom Step (Click to edit)',
                    position: 0, 
                    status: 'Pending',
                    predefined_duration_days: 0,
                    buffer_days: 0,
                    extended_duration_days: 0,
                    delay_reason: '',
                    actual_start_date: null,
                    actual_completion_date: null,
                    updated_by: null,
                    attachments: [],
                    current_status: '-',
                    is_custom: true, 
                };

                manufacturingSteps.splice(afterStepIndex + 1, 0, newCustomStep);

                let reIndexedSteps = manufacturingSteps.map((step, index) => ({
                    ...step,
                    position: index,
                }));

                const startDate = bomData.manufacturing_start_date
                    ? new Date(bomData.manufacturing_start_date)
                    : new Date(bomData.manufacturing_release_date || Date.now());
                
                reIndexedSteps = recalculateStepDates(reIndexedSteps, startDate); // Use existing function

                newItems[itemIndex] = { ...itemToUpdate, manufacturing_steps: reIndexedSteps };
                
                return newItems;
            });
        }, [bomData.manufacturing_start_date, bomData.manufacturing_release_date, recalculateStepDates]);

        // Handler to update local state when ValidationPanel changes
const handleValidationUpdate = useCallback((newData) => {
    setBomData(prev => ({
        ...prev,
        validation_details: newData
    }));
}, []);

const handleCompleteValidationSave = useCallback(async (completedDetails) => {
    setBomData(prev => ({
        ...prev,
        validation_details: completedDetails
    }));
    await onUpdate(null, completedDetails);
}, [onUpdate]);

const handleReopenValidation = useCallback(async () => {
    if (!window.confirm("Are you sure you want to reopen the validation? This will reset the completed status.")) {
        return;
    }
    const reopenedDetails = {
        ...bomData.validation_details,
        validation_completed: false,
        validation_status: 'Pending'
    };
    setBomData(prev => ({
        ...prev,
        validation_details: reopenedDetails
    }));
    await onUpdate(null, reopenedDetails);
}, [bomData.validation_details, onUpdate]);

    const getMissingFields = useCallback(() => {
        const data = bomData.validation_details || {};
        const missing = [];
        
        // 1. Fit and Function
        if (!data.scope_received) {
            missing.push("Complete scope received as per order");
        } else if (data.scope_received === 'No' && !data.scope_received_comment?.trim()) {
            missing.push("Scope received comment");
        }

        if (!data.items_condition_ok) {
            missing.push("All fixture items received in good condition");
        } else if (data.items_condition_ok === 'No' && !data.items_condition_comment?.trim()) {
            missing.push("Items condition comment");
        }

        // Pre-requisites - Machine Side
        if (data.table_face_runout === undefined || data.table_face_runout === null || String(data.table_face_runout).trim() === '') {
            missing.push("Table Face Runout");
        }
        if (data.table_radial_runout === undefined || data.table_radial_runout === null || String(data.table_radial_runout).trim() === '') {
            missing.push("Table Radial Runout");
        }
        if (data.tailstock_runout === undefined || data.tailstock_runout === null || String(data.tailstock_runout).trim() === '') {
            missing.push("Tailstock Runout");
        }
        if (data.tailstock_alignment === undefined || data.tailstock_alignment === null || String(data.tailstock_alignment).trim() === '') {
            missing.push("Tailstock Alignment");
        }

        // Fixture mounted correctly
        if (!data.fixture_mounted_correctly) {
            missing.push("Fixture is mounted correctly");
        } else if (data.fixture_mounted_correctly === 'No' && !data.fixture_mounted_comment?.trim()) {
            missing.push("Fixture mounted comment");
        }

        // Clamp/declamp
        if (!data.clamp_declamp_ok) {
            missing.push("Clamp / Declamp is OK");
        } else if (data.clamp_declamp_ok === 'No' && !data.clamp_declamp_comment?.trim()) {
            missing.push("Clamp/declamp comment");
        }

        // Runout of Master/Control Arbor
        if (data.control_radial_runout === undefined || data.control_radial_runout === null || String(data.control_radial_runout).trim() === '') {
            missing.push("Control Radial Runout");
        }
        if (data.control_axial_runout === undefined || data.control_axial_runout === null || String(data.control_axial_runout).trim() === '') {
            missing.push("Control Axial Runout");
        }

        // Fit & function OK
        if (!data.fit_function_ok) {
            missing.push("Fit and Function OK");
        } else if (data.fit_function_ok === 'No' && !data.fit_function_comment?.trim()) {
            missing.push("Fit and function comment");
        }

        // 3. Completion Section
        if (!data.completion_date) {
            missing.push("Completion Date");
        }
        if (!data.kl_representative?.trim()) {
            missing.push("KL Representative");
        }
        if (!data.customer_representative?.trim()) {
            missing.push("Customer Representative");
        }

        return missing;
    }, [bomData.validation_details]);

    const handleCompleteValidationClick = useCallback(async () => {
        const missing = getMissingFields();
        if (missing.length > 0) {
            ShowToast(`Please fill in all required fields:\n- ${missing.join('\n- ')}`, TYPE_FAIL, 5000);
            return;
        }
        
        if (window.confirm("Are you sure you want to complete the validation? This will lock all fields.")) {
            await handleCompleteValidationSave({
                ...bomData.validation_details,
                validation_completed: true
            });
        }
    }, [getMissingFields, handleCompleteValidationSave, bomData.validation_details]);


// Helper to upload validation attachments
const processValidationAttachments = async (validationData) => {
    if (!validationData) return {};
    
    // List of attachment keys in the Validation Schema
    const attachmentKeys = [
        'scope_received_attachments',
        'items_condition_attachments',
        'fixture_mounted_attachments',
        'clamp_declamp_attachments',
        'fit_function_fail_attachments', // Check this key matches your schema/panel exactly
        'remarks_attachments',
        'completion_attachments',
        'payment_attachments'
    ];

    const processedData = { ...validationData };

    for (const key of attachmentKeys) {
        if (Array.isArray(processedData[key])) {
            const processedFiles = [];
            for (const file of processedData[key]) {
                // If it has originFileObj, it's a new file that needs uploading
                if (file.originFileObj) {
                    try {
                        const uploaded = await uploadSingleFile(file.originFileObj); // Reuse your existing uploadSingleFile function
                        processedFiles.push(uploaded);
                    } catch (err) {
                        console.error(`Failed to upload file for ${key}:`, err);
                        // Optional: Throw error or skip
                    }
                } else {
                    // Existing file, keep as is
                    processedFiles.push(file);
                }
            }
            processedData[key] = processedFiles;
        }
    }
    
    // Also handle Order Requirements Log (Nested Array)
    if (Array.isArray(processedData.order_requirements)) {
        const processedLogs = [];
        for (const log of processedData.order_requirements) {
            const newLog = { ...log };
            if (Array.isArray(newLog.attachments)) {
                const processedLogFiles = [];
                for (const file of newLog.attachments) {
                     if (file.originFileObj) {
                        const uploaded = await uploadSingleFile(file.originFileObj);
                        processedLogFiles.push(uploaded);
                    } else {
                        processedLogFiles.push(file);
                    }
                }
                newLog.attachments = processedLogFiles;
            }
            processedLogs.push(newLog);
        }
        processedData.order_requirements = processedLogs;
    }

    return processedData;
};
const validationDocs = [
    {
      key: 'dap',
      label: 'DAP Drawing',
      file: bomData?.dap_attachments?.[0], 
    },
    {
      key: 'test_report',
      label: 'Final Test Report',
      file: bomData?.test_report?.generated_report,
    },
    {
      key: 'pdir',
      label: 'Pre-Dispatch Inspection Report (PDIR)',
      file: bomData?.dispatch_checklist_pdir_report?.generated_report,
    },
    {
      key: 'invoice',
      label: 'Klingelnberg Invoice',
      file: bomData?.commercial_details?.kl_invoice_file?.[0],
    },
];
const handleDeleteStep = useCallback((itemIndex, stepIndexToDelete) => { 
    setItems(prevItems => {
        const newItems = [...prevItems];
        const itemToUpdate = { ...newItems[itemIndex] };
        
        let manufacturingSteps = Array.isArray(itemToUpdate.manufacturing_steps)
            ? [...itemToUpdate.manufacturing_steps]
            : [];

    
        // if (!manufacturingSteps[stepIndexToDelete] || !manufacturingSteps[stepIndexToDelete].is_custom) {
        //     ShowToast('You can only delete custom steps.', TYPE_FAIL, INTERVAL, props, '');
        //     return prevItems; // Return original state
        // }

    
        if (!manufacturingSteps[stepIndexToDelete]) {
            ShowToast('Cannot find step to delete.', TYPE_FAIL, INTERVAL, props, '');
            return prevItems; // Return original state
        }

        manufacturingSteps.splice(stepIndexToDelete, 1);

        let reIndexedSteps = manufacturingSteps.map((step, index) => ({
            ...step,
            position: index,
        }));


        const startDate = bomData.manufacturing_start_date
            ? new Date(bomData.manufacturing_start_date)
            : new Date(bomData.manufacturing_release_date || Date.now());
        
        reIndexedSteps = recalculateStepDates(reIndexedSteps, startDate); 

       
        newItems[itemIndex] = { ...itemToUpdate, manufacturing_steps: reIndexedSteps };
        
        return newItems;
    });
}, [bomData.manufacturing_start_date, bomData.manufacturing_release_date, recalculateStepDates, props]);

const handleExportToExcel = useCallback(async () => { 
    if (!bomData || !items.length) {
        ShowToast('No data available to export.', TYPE_FAIL, INTERVAL, props, '');
        return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('BOM Supplier View');

    const headerStyle = {
        font: { bold: true, color: { argb: 'FFFFFFFF' } },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF4F81BD' } },
        alignment: { vertical: 'middle', horizontal: 'center' }
    };
    const partHeaderStyle = {
        font: { bold: true },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFDDEBF7' } },
         alignment: { vertical: 'middle', horizontal: 'center' }

    };
    const titleStyle = {
        font: { bold: true, size: 16 },
        alignment: { vertical: 'middle', horizontal: 'center' }

    };

    const stepstyle = {
        alignment: { vertical: 'middle', horizontal: 'center' }
    }

    worksheet.addRow(['BOM Details']).getCell(1).font = titleStyle.font;
    worksheet.mergeCells('A1:D1');
    worksheet.addRow([]);

    const headerData = [
        ['Fixture Document #:', fixtureDocNo],
        ['Fixture Name:', fixtureName],
        ['Design Engineer',designEngineerName ],
        ['Surface Treatment Type', surfaceTreatmentType],
        // ['Customer:', customer?.label || ''],
        // ['Machine:', machine],
        // ['PO Reference:', poRef],
        ['Mfg. Release Date:', mfgReleaseDate ? moment(mfgReleaseDate).format('DD-MMM-YYYY') : ''],
    ];

    headerData.forEach(row => {
        const addedRow = worksheet.addRow(row);
        addedRow.getCell(1).font = { bold: true };
    });
    worksheet.addRow([]);

    const tableHeader = [
        'Part Name', 'Document Number', 'Step No.', 'Step Title', 'Status',
        'Defined Completion', 'Actual Completion', 'Current Status'
    ];
    
    const headerRow = worksheet.addRow(tableHeader);
    headerRow.eachCell(cell => {
        cell.style = headerStyle;
    });


    items.forEach(item => {
        if (item.manufacturing_steps && item.manufacturing_steps.length > 0) {
            

            const partAttachment = item.attachments?.[0];
            const partAttachmentCell = (partAttachment && partAttachment.file_url)
                ? { text: partAttachment.file_name || 'View File', hyperlink: partAttachment.file_url }
                : '';


            const partRow = worksheet.addRow([
                partMap[item.part_ref] || 'N/A',
                item.document_number || '',
                '',
                '',
                '',
                '',
                '',
                '',
                partAttachmentCell
            ]);
            partRow.eachCell(cell => cell.style = partHeaderStyle);
            partRow.outlineLevel = 0;

            item.manufacturing_steps.forEach(step => {
                const attachment = step.attachments?.[0];
                // const attachmentCell = (attachment && attachment.file_url)
                //     ? { text: attachment.file_name || 'View File', hyperlink: attachment.file_url }
                //     : '';

                
                const stepRow = worksheet.addRow([
                    '', '',
                    typeof step.position === 'number' ? step.position + 1 : '-',
                    step.step_title_snapshot || 'N/A',
                    step.status || 'Pending',
                    step.defined_completion_date ? moment(step.defined_completion_date).format('DD-MMM-YYYY') : '',
                    step.actual_completion_date ? moment(step.actual_completion_date).format('DD-MMM-YYYY') : '',
                    step.current_status || '-',
                ]);
               
                stepRow.outlineLevel = 1;
            });
        }
    });

    worksheet.eachRow((row) => {
        row.eachCell((cell) => {
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
        });
    });

    worksheet.columns = [
        { key: 'partName', width: 30 },
        { key: 'docNum', width: 25 },
        { key: 'stepNo', width: 10 },
        { key: 'stepTitle', width: 40 },
        { key: 'status', width: 15 },
        { key: 'definedDate', width: 20 },
        { key: 'actualDate', width: 20 },
        { key: 'currentStatus', width: 15 },
    ];
    
    worksheet.getRow(1).height = 25;

    workbook.xlsx.writeBuffer().then(buffer => {
        const now = new Date();
        const formattedDate = now.toISOString().split('T')[0];  
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        // saveAs(blob, `BOM_Supplier_${fixtureDocNo || bomData._id}.xlsx`);
        saveAs(blob, `BOM_Supplier_${fixtureDocNo || bomData._id}_${formattedDate}.xlsx`);

    }).catch(err => {
        console.error("Error writing excel export", err);
        ShowToast('Failed to generate Excel file.', TYPE_FAIL, INTERVAL, props, '');
    });

}, [bomData, items, fixtureDocNo, fixtureName, customer, machine, poRef, mfgReleaseDate, partMap, props]);

//Zip all attachments

const handleZipDownload = useCallback(async () => {

    if (!routeBomId) {
        console.error("ERROR: routeBomId is missing, stopping.");
        ShowToast("Error: BOM ID is missing", "error", 3000);
        return;
    }
    try {
        setIsZipDownloading(true);
        ShowToast('Preparing ZIP download...', 'info', 3000);
        
        const response = await downloadAllBomAttachments(routeBomId);
        

        if (response.data.type === 'application/json') {
            const errorText = await response.data.text(); 
            console.error("Server Error Response:", errorText);
            
            let errorMessage = "Download failed";
            try {
                const errorJson = JSON.parse(errorText);
                errorMessage = errorJson.error || errorJson.message || errorMessage;
            } catch (e) {}
            
            ShowToast(`Error: ${errorMessage}`, TYPE_FAIL, INTERVAL);
            return; 
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        const contentDisposition = response.headers['content-disposition'];
        let fileName = `BOM_${fixtureDocNo || 'Attachments'}.zip`;
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
        }
        
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        ShowToast('Download started successfully', TYPE_SUCCESS, INTERVAL);

    } catch (err) {
        console.error('Download Handle Error:', err);
        ShowToast('Failed to initiate download', TYPE_FAIL, INTERVAL);
    } finally {
        setIsZipDownloading(false);
    }
}, [routeBomId, fixtureDocNo]);

const handleZipDocDownload = useCallback(async () => {

    if (!routeBomId) {
        console.error("ERROR: routeBomId is missing, stopping.");
        ShowToast("Error: BOM ID is missing", "error", 3000);
        return;
    }
    try {
        setIsZipDownloading(true);
        ShowToast('Preparing ZIP download...', 'info', 3000);
        
        const response = await downloadDispatchAttachments(routeBomId);


        if (response.data.type === 'application/json') {
            const errorText = await response.data.text(); 
            console.error("Server Error Response:", errorText);
            
            let errorMessage = "Download failed";
            try {
                const errorJson = JSON.parse(errorText);
                errorMessage = errorJson.error || errorJson.message || errorMessage;
            } catch (e) {}
            
            ShowToast(`Error: ${errorMessage}`, TYPE_FAIL, INTERVAL);
            return; 
        }

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        const contentDisposition = response.headers['content-disposition'];
        const BomCode = bomData?.bom_code || bomCode || '';
        let fileName = `BOM_${fixtureDocNo || 'Attachments'}_${BomCode}.zip`;
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch.length === 2) fileName = fileNameMatch[1];
        }
        
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        ShowToast('Download started successfully', TYPE_SUCCESS, INTERVAL);

    } catch (err) {
        console.error('Download Handle Error:', err);
        ShowToast('Failed to initiate download', TYPE_FAIL, INTERVAL);
    } finally {
        setIsZipDownloading(false);
    }
}, [routeBomId, fixtureDocNo]);
  
    /* ---------------- 12) TABLE EDIT HANDLERS ---------------- */
    const onRowAdd = useCallback(async (newData) => {
        setItems((prev) => [...prev, { ...newData }]);
    }, []);

    const onRowUpdate = useCallback(
        async (newData, oldData) => {
            let partChanged = false;
            let newPartId = newData.part_ref;
            let newDocNo = newData.document_number;

            if (newData.document_number && typeof newData.document_number === 'object') {
                const opt = newData.document_number;
                if (opt.__isNew__) {
                    const docNo = opt.value;
                    const partName = window.prompt(`Enter Part Name for new document "${docNo}":`);
                    if (!partName || !partName.trim()) {
                        ShowToast('Part Name is required to create a new part.', TYPE_FAIL, INTERVAL, props, '');
                        return;
                    }
                    ShowToast(`Creating new part: "${partName}"...`, 'info', 1000);
                    try {
                        const newPartPayload = {
                            part_name: partName.trim(),
                            document_number: docNo,
                            part_type: 'Standard',
                            od_mm: 0,
                            length_mm: 0,
                            stock_quantity: 0,
                        };
                        const response = await createParts({}, newPartPayload);
                        const createdPart = response?.data?.result;
                        if (!createdPart?._id) throw new Error('Failed to save new part');

                        setParts((prev) => [...prev, createdPart]);
                        newPartId = createdPart._id;
                        newDocNo = createdPart.document_number;
                        partChanged = true;
                    } catch (err) {
                        const msg = err?.response?.data?.error || 'An error occurred.';
                        if (msg.includes('duplicate key')) {
                            ShowToast('A part with this Document Number already exists.', TYPE_FAIL, INTERVAL, props, '');
                        } else {
                            ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
                        }
                        return;
                    }
                } else {
                    newPartId = opt.value;
                    newDocNo = opt.label;
                    partChanged = true;
                }
            } else if (newData.part_ref && typeof newData.part_ref === 'object' && newData.part_ref.__isNew__) {
                try {
                    const partName = newData.part_ref.value;
                    ShowToast(`Creating new part: "${partName}"...`, 'info', 1000);
                    const newPartPayload = {
                        part_name: partName,
                        part_type: 'Standard',
                        od_mm: 0,
                        length_mm: 0,
                        stock_quantity: 0,
                    };
                    const response = await createParts({}, newPartPayload);
                    const createdPart = response?.data?.result;
                    if (!createdPart?._id) {
                        ShowToast('Failed to save the new part.', TYPE_FAIL, INTERVAL, props, '');
                        return; 
                    }

                    setParts((prev) => [...prev, createdPart]);
                    newPartId = createdPart._id;
                    partChanged = true;
                } catch (err) {
                    const msg = err?.response?.data?.error || 'An error occurred while creating the part.';
                    ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
                    return;
                }
            }
            const updated = [...items];
            const idx = updated.indexOf(oldData);
            if (idx === -1) return;

            if (newData.procurement_source === PROCUREMENT_SOURCE.SUPPLIER) {
                newData.procurement_done = true;
                newData.procurement_details = [];
            } else if (
                oldData.procurement_source === PROCUREMENT_SOURCE.SUPPLIER &&
                newData.procurement_source !== PROCUREMENT_SOURCE.SUPPLIER
            ) {
                const perUnit = Number(newData.raw_material_length_mm) || 0;
                const totalReq = perUnit * (Number(newData.quantity) || 0);
                const totalAlloc = (newData.procurement_details || []).reduce(
                    (s, d) => s + (Number(d.length_allocated) || 0),
                    0
                );
                newData.procurement_done = perUnit > 0 && totalAlloc >= totalReq;
            }

            updated[idx] = { ...newData };
            if (partChanged) {
                updated[idx].part_ref = newPartId;
                updated[idx].document_number = newDocNo;
            }

            setItems(updated);
        },
        [items, parts, props]
    );

    const onRowDelete = useCallback(async (oldData) => {
        setItems((prev) => prev.filter((item) => item.tableData.id !== oldData.tableData.id));
    }, []);

    /* ---------------- 13) TABLE COLUMNS ---------------- */
const columns = useMemo(
    () => {
        const rawMaterialColumns = [
            {
                title: 'Raw Material OD (mm)',
                field: 'raw_material_od_mm',
                type: 'numeric',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700, backgroundColor: '#fff0f1', color: '#d32f2f' },
                cellStyle:{backgroundColor: '#ffbbbf', fontSize: '14px !important'},
                render: (row) => (Number(row.raw_material_od_mm) > 0 ? row.raw_material_od_mm : '—'),
                editComponent: (p) => (
                    <input
                        type="number"
                        min={0}
                        className="form-control-customer bom-input"
                        value={p.value ?? ''}
                        onChange={(e) => p.onChange(e.target.value)}
                        placeholder="e.g., 95"
                    />
                ),

            },
            {
                title: 'Raw Material Length (mm)',
                field: 'raw_material_length_mm',
                type: 'numeric',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700,  backgroundColor: '#ffbbbf' },
                cellStyle:{ backgroundColor: '#ffbbbf', fontSize: '14px !important'},
                render: (row) => (Number(row.raw_material_length_mm) > 0 ? row.raw_material_length_mm : '—'),
                editComponent: (p) => (
                    <input
                        type="number"
                        min={0}
                        className="form-control-customer bom-input"
                        value={p.value ?? ''}
                        onChange={(e) => p.onChange(e.target.value)}
                        placeholder="e.g., 6000"
                    />
                ),
            },
            {
                 title: 'Procured',
                 field: 'procurement_source',
                 headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700,backgroundColor: '#ffbbbf', },
                 cellStyle:{fontSize: '', backgroundColor: '#ffbbbf'},
                 lookup: { 'Supplier': 'Supplier', 'Klingelnberg': 'Klingelnberg' },
             }
        ];
        
        const baseColumns  = [
            {
                title: 'Part Name',
                field: 'part_ref',
                headerStyle: { fontWeight: 700 },
                render: (row) => partMap[row.part_ref] || '—',
                editable: 'never',
                validate: (rowData) => !!rowData.part_ref || 'Part required',
            },
            {
                title: 'Document Number',
                field: 'document_number',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
                render: (row) => row.document_number || '—',
                editComponent: (p) => {
                    let resolvedValue = null;
                    if (p.value && typeof p.value === 'object' && p.value.hasOwnProperty('value')) {

                        resolvedValue = p.value;
                    } else if (p.value) { 
                        resolvedValue = { value: p.rowData.part_ref, label: p.value };
                    }

                    return (
                        <CreatableSelect
                            placeholder="Select or create Doc No…"
                            options={defaultPartDocOptions} 
                            loadOptions={loadDocOptions} 
                            value={resolvedValue} 
                            onChange={(opt) => {
                                p.onChange(opt || null); 
                            }}
                            isClearable
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                            styles={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                        />
                    );
                },
                validate: (rowData) => !!rowData.document_number || 'Doc No required',
            },
            {
                title: 'Standard Process',
                field: 'process_type_id',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
                render: (row) => processMap[row.process_type_id] || '—',
                editComponent: (p) => (
                    <AsyncSelect
                        cacheOptions
                        defaultOptions={stdProcesses.map(mapProcessToOption)}
                        loadOptions={loadProcessOptions}
                        value={
                            p.value
                                ? {
                                      value: p.value,
                                      label:
                                          stdProcesses.find((x) => x._id === p.value)
                                              ?.process_title || 'Selected',
                                  }
                                : null
                        }
                        onChange={(opt) => p.onChange(opt?.value || null)}
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{ menuPortal: (b) => ({ ...b, zIndex: 9999 }) }}
                    />
                ),
                validate: (rowData) => !!rowData.process_type_id || 'Process required',
            },
            {
                title: 'Steel Material',
                field: 'steel_material_description',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
                render: (row) => row.steel_material_description || '—',
                editComponent: (p) => (
                    // <input
                    //     className="form-control-customer bom-input"
                    //     value={p.value || ''}
                    //     onChange={(e) => p.onChange(e.target.value)}
                    //     placeholder="e.g., 31CrMoV9"
                    // />
                    <CreatableSelect
                        placeholder="Select or type..."
                        options={steelMaterialOptions} // Uses the options you already defined
                        value={
                            p.value
                                ? { value: p.value, label: p.value }
                                : null
                        }
                        onChange={(opt) =>
                            // Updates the table state with the selected or created string value
                            p.onChange(opt?.value || '')
                        }
                        isClearable
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                    />
                ),
            },
            {
                title: 'Finished Material OD (mm)',
                field: 'finished_material_od_mm',
                type: 'numeric',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
                render: (row) => (Number(row.finished_material_od_mm) > 0 ? row.finished_material_od_mm : '—'),
                validate: (row) => (Number(row.finished_material_od_mm) >= 0 ? true : 'OD ≥ 0'),
                editComponent: (p) => (
                    <input
                        type="number"
                        min={0}
                        className="form-control-customer bom-input"
                        value={p.value ?? ''}
                        onChange={(e) => p.onChange(e.target.value)}
                        placeholder="e.g., 85"
                    />
                ),
            },
            {
                title: 'Finished Material Length (mm)',
                field: 'finished_material_length_mm',
                type: 'numeric',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
                render: (row) => (Number(row.finished_material_length_mm) > 0 ? row.finished_material_length_mm : '—'),
                validate: (row) => (Number(row.finished_material_length_mm) >= 0 ? true : 'Length ≥ 0'),
                editComponent: (p) => (
                    <input
                        type="number"
                        min={0}
                        className="form-control-customer bom-input"
                        value={p.value ?? ''}
                        onChange={(e) => p.onChange(e.target.value)}
                        placeholder="e.g., 100"
                    />
                ),
            },
            {
                title: 'Qty',
                field: 'quantity',
                type: 'numeric',
                headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },

                validate: (row) => (Number(row.quantity) >= 1 ? true : 'Qty ≥ 1'),
                editComponent: (p) => (
                    <input
                        type="number"
                        min={1}
                        className="form-control-customer bom-input"
                        value={p.value ?? ''}
                        onChange={(e) => p.onChange(e.target.value)}
                        placeholder="1"
                    />
                ),
            }
        ]
        
        const procurementColumn = [
            {
            title: 'Procured?',
            field: 'procurement_done',
            headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
            cellStyle:{textAlign: 'center'},
            sorting: false,
            render: (row) => {
                const done = !!row.procurement_done;

                return (
                    <Tooltip title={done ? 'Procured' : 'Not Procured'}>
                        <CheckCircleSharpIcon
                            sx={{ 
                                fontSize: 30, 
                                color: done ? 'green' : 'grey', 
                                opacity: done ? 1 : 0.3 
                            }}
                        />
                    </Tooltip>
                );
            },
            },
        ];
        // if(hasPermission("stages","procured")){
        //     baseColumns.push(procurementColumn[0]);
        // }
        const attachmentColumn = [
            {
                title: 'Attachment',
                field: 'attachments',
                headerStyle: { fontWeight: 700, width: 200 },
                cellStyle: { textAlign: 'left', padding: '6px 8px', width: 200 },
                sorting: false,

                render: (row) => {
                    const idx = row?.tableData?.id ?? 0;
                    const attachments = Array.isArray(row.attachments) ? row.attachments : [];
                    const isUploading = uploadingRow === idx;
                    const pct = uploadProgress[idx] ?? 0;

                    const canUploadItemFiles = hasPermission("bom", "upload_file") && !isGlobalReadOnly;

                    return (
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                            
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start', maxWidth: 300, gap: 0.5 }}>
                                {attachments.map((a, attachmentIndex) => (
                                    <Chip
                                        key={attachmentIndex}
                                        size="small"
                                        icon={<CloudUploadIcon />}
                                        label={a.file_name || 'attachment'}
                                        onClick={() => handleDownload(idx, a.file_url)}
                                        onDelete={canUploadItemFiles ? () => removeAttachmentForRow(idx, attachmentIndex) : undefined}
                                        deleteIcon={canUploadItemFiles ? <DeleteForeverIcon /> : undefined}
                                        variant="outlined"
                                        sx={{ '& .MuiChip-label': { maxWidth: 40, overflow: 'hidden', textOverflow: 'ellipsis' } }}
                                    />
                                ))}
                            </Box>

                            {isUploading ? (
                                <Box sx={{ width: '100%', mt: 0.5 }}>
                                    <LinearProgress variant="determinate" value={pct} />
                                    <Typography variant="caption" color="text.secondary">{pct}%</Typography>
                                </Box>
                            ) : (
                                canUploadItemFiles && (
                                <Tooltip title="Add Attachments">
                                    <IconButton size="small" component="label" sx={{ mt: 0.5 }}>
                                        <input
                                            type="file"
                                            hidden
                                            multiple
                                            onChange={(e) => {
                                                const files = Array.from(e.target.files || []);
                                                if (files.length > 0) uploadAttachmentForRow(idx, files);
                                                e.target.value = '';
                                            }}
                                        />
                                        <CloudUploadIcon sx={{ fontSize: 30 }} />
                                    </IconButton>
                                </Tooltip>
                                )
                            )}
                        </Box>
                    );
                },
                editComponent: (p) => {
                    const a = Array.isArray(p?.rowData?.attachments) && p.rowData.attachments[0];
                    return (
                        <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                            {a ? <Chip size="small" icon={<CloudUploadIcon />} label={a.file_name || 'attachment'} />
                                : <span style={{ color: '#888' }}>No attachment</span>}
                        </div>
                    );
                },
            }
        ];
        const expectedCompletionColumn = {
        title: 'Expected Completion',
        headerStyle: { fontSize: 'var(--bom-table-header-size)', fontWeight: 700 },
        cellStyle: { textAlign: 'center', fontSize: '12px !important' },
        sorting: false,
        render: (rowData) => {
            const steps = rowData?.manufacturing_steps;
            if (Array.isArray(steps) && steps.length > 0) {
                const lastStep = steps[steps.length - 1];
                if (lastStep?.defined_completion_date) {
                    return moment(lastStep.defined_completion_date).format('DD-MMM-YYYY');
                }
            }
            return '—'; 
        },
    };

        let finalColumns = [];
        switch (initialUser.user_role) {
            // case SUPER_ADMIN:
            case PROCUREMENT_ENGINEER:
                // Shows the most comprehensive view
                const qtyColumn = baseColumns.find(c => c.field === 'quantity');
                const baseWithoutQty = baseColumns.filter(c => c.field !== 'quantity');
                
                finalColumns = [
                    ...baseWithoutQty,
                    ...rawMaterialColumns,
                    qtyColumn,
                    ...procurementColumn,
                    ...attachmentColumn,
                ];
                break;

            case DESIGN_ENGINEER:
                finalColumns = [
                    ...baseColumns,
                    ...attachmentColumn
                ];
                break;

            case MANUFACTURING_ENGINEER:
            case SUPPLIER:
                const limitedColumns = baseColumns.filter(col =>
                    ['part_ref', 'document_number', 'process_type_id'].includes(col.field)
                );
                finalColumns = [
                    ...limitedColumns,
                    expectedCompletionColumn,
                    ...attachmentColumn
                ];
                break;
            case SUPER_ADMIN: {
                const qtyColumn = baseColumns.find(c => c.field === 'quantity');
                const baseWithoutQty = baseColumns.filter(c => c.field !== 'quantity');

                if (bomData.current_stage === BOM_STAGES.DESIGN) {
                    finalColumns = [
                        ...baseColumns,
                        ...attachmentColumn
                    ];
                } else if (bomData.current_stage === BOM_STAGES.PROCUREMENT) {
                    finalColumns = [
                        ...baseWithoutQty,
                        ...rawMaterialColumns,
                        qtyColumn,
                        ...procurementColumn,
                        ...attachmentColumn
                    ];
                } else {
                    finalColumns = [
                        ...baseWithoutQty,
                        ...rawMaterialColumns,
                        qtyColumn,
                        ...procurementColumn,
                        expectedCompletionColumn,
                        ...attachmentColumn
                    ];
                }
                break;
            }


            default:

                const defaultLimitedCols = baseColumns.filter(col =>
                    ['part_ref', 'document_number', 'process_type_id'].includes(col.field)
                );
                finalColumns = [
                    ...defaultLimitedCols,
                    ...attachmentColumn
                ];
                break;
        }

        //Change Procurement
        if (bomData.current_stage === BOM_STAGES.PROCUREMENT  && initialUser.user_role === PROCUREMENT_ENGINEER ) {
            return finalColumns.map(col => {
                if (col.field === 'procurement_source') {
                    return col; 
                }
                return { ...col, editable: 'never' };
            });
        }

        if (bomData.partial_procurement && bomData.current_stage !== BOM_STAGES.PROCUREMENT && initialUser.user_role === PROCUREMENT_ENGINEER) {
            return finalColumns.map(col => {
                if (col.field === 'procurement_source') {
                    return col; 
                }
                return { ...col, editable: 'never' };
            });
        }

        return finalColumns;
    },
    [
        parts,
        stdProcesses,
        partMap,
        processMap,
        mapPartToOption,
        mapProcessToOption,
        loadPartOptions,
        loadProcessOptions,
        uploadingRow,
        uploadProgress,
        downloadingRow,
        bomData.current_stage,
        defaultPartDocOptions,
        loadDocOptions,
    ]
);

const detailPanelME = useCallback(
    (rowData) => {
        const idx = rowData?.tableData?.id;
        const steps = rowData?.manufacturing_steps || [];
        const canViewInternalDetails = hasPermission("part_steps", "view_internal_details");
        const canMarkComplete = hasPermission("part_steps", "complete");
        const canManageAttachments = hasPermission("part_steps", "upload_file");
        const canEditBufferDays = hasPermission("part_steps", "buffer_days");
        const canEditActualCompletionDate = hasPermission("part_steps", "actual_completion_date");
        const canViewStatusCol = hasPermission("part_steps", "view_status_col");

        const hasStarted = Array.isArray(rowData.manufacturing_steps) && 
                           rowData.manufacturing_steps.some(step => step.status === 'Completed');
        
        const showRejectAction = initialUser.user_role === SUPER_ADMIN || initialUser.user_role === MANUFACTURING_ENGINEER;


        return (
            <div className="detail-panel-container">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8, paddingLeft: 16, paddingRight: 16, paddingTop: 8 }}>
                     <Typography variant="subtitle2" sx={{ fontWeight: 500, color: '#555' }}>
                        Manufacturing Steps :
                    </Typography>

                    {showRejectAction && (
                        <div>
                            <Tooltip title={hasStarted ? "Reject Item" : "Cannot reject: No steps started yet"}>
                                <span> 
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        startIcon={<CancelIcon />}
                                        disabled={!hasStarted} 
                                        onClick={(e) => {
                                            e.stopPropagation(); 
                                            if (window.confirm('Are you sure you want to reject this item? The schedule for this item will be reset from today.')) {
                                                handleRejectItem(rowData);
                                            }
                                        }}
                                        sx={{ textTransform: 'none', fontWeight: 600, borderColor: 'black' }}
                                    >
                                        Reject Item
                                    </Button>
                                </span>
                            </Tooltip>
                        </div>
                    )}
                </div>
                {!steps.length ? (
                        (bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING ||
                        bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) ? (
                            <h6>Procurement not done for this item</h6>
                        ) : (
                            <h6>Steps are not visible at this stage</h6>
                        )
                    ) : (
                    <TableContainer component={Paper} elevation={0}>
                        <Table size="small" aria-label="manufacturing steps" sx={{tableLayout: 'fixed',width: '100%'}}>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: '250px',textAlign: 'center'}} >Step</TableCell>
                                    {bomData.current_stage !== BOM_STAGES.MANUFACTURING_PLANNING && (<TableCell sx={{
                                        width: '90px',minWidth: '90px', maxWidth: '90px',whiteSpace: 'nowrap',textAlign: 'center'}} >Completed</TableCell>)
                                    }
                                    
                                    {canViewInternalDetails && (
                                        <>
                                            <TableCell sx={{ width: '110px', minWidth: '110px', maxWidth: '110px',textAlign: 'center' }}>Buffer Days</TableCell>
                                            <TableCell sx={{ width: '110px', minWidth: '110px', maxWidth: '110px',textAlign: 'center' }}>Predef. Days</TableCell>
                                        </>
                                    )}

                                    <TableCell sx={{ width: '140px', minWidth: '140px', maxWidth: '140px', textAlign: 'center'}}>Defined Completion</TableCell>

                                    {canViewInternalDetails && bomData.current_stage !== "Manufacturing-Planning" && (
                                        <>
                                            <TableCell sx={{ width: '150px', minWidth: '150px', maxWidth: '150px',textAlign: 'center' }}>Actual Completion</TableCell>
                                        </>
                                    )}

                                    {canViewStatusCol && bomData.current_stage !== "Manufacturing-Planning" && (
                                           <TableCell  sx={{ width: '140px', minWidth: '140px', maxWidth: '140px', textAlign: 'center' }}><Box sx={{width: '100%',textAlign: 'center'}}
                                           >Current Status</Box></TableCell>

                                    )

                                    }

                                    <TableCell sx={{width: '200px', minWidth: '200px', maxWidth: '200px',textAlign: 'center' }}>
                                    <Box sx={{width: '100%',textAlign: 'center'}}>Attachment</Box></TableCell>

                                     {bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING && (
                                    <TableCell sx={{ width: '120px', minWidth: '120px', maxWidth: '120px',textAlign: 'center' }}>Step Actions</TableCell>
                                     )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {steps.map((s, si) => {
                                    const stepKey = keyForStep(rowData, s);
                                    const attachment = s.attachments?.[0];
                                    const isUploading = !!s.is_uploading; 
                                    const pct = s.upload_progress ?? 0;
                                    const statusChip = {
                                        'On Time': { label: 'On Time', color: 'success', variant: 'outlined' },
                                        'Warning': { label: 'Warning', color: 'warning', variant: 'outlined' },
                                        'Delayed': { label: 'Delayed', color: 'error', variant: 'filled' },
                                    }[s.current_status] || { label: '-', color: 'default' };

                                    return (
                                        <TableRow key={s.step_ref || si} hover>
                                            <TableCell>
                                                {(s.is_custom || !s.step_ref) && bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING ? (
                                                    <EditableStepTitle
                                                        initialTitle={s.step_title_snapshot || ''}
                                                        itemIndex={idx}
                                                        stepIndex={si}
                                                        onSave={setStepField}
                                                    />
                                                ) : (
                                                <div className="step-title">{s.step_title_snapshot || '—'}</div>
                                                )}

                                                <div className="step-position">
                                                    Step: {typeof s.position === 'number' ? s.position + 1 : si + 1}
                                                </div>
                                            </TableCell>
                                            
                                            {bomData.current_stage !== "Manufacturing-Planning" && (
                                                <TableCell sx={{ textAlign: 'center' }}>
                                                    {(() => {
                                                        const isSuperAdmin = initialUser?.user_role === SUPER_ADMIN;
                                                        const isAnyPreviousStepPending = si > 0 && steps.slice(0, si).some(prevStep => prevStep.status !== 'Completed');
                                                        const isAnySubsequentStepCompleted = steps.slice(si + 1).some(nextStep => nextStep.status === 'Completed');

                                                        let finalDisabled = false;
                                                        let tooltipTitle = 'Mark as Completed';

                                                        if (s.status === 'Completed') {
                                                            if (isSuperAdmin) {
                                                                if (isAnySubsequentStepCompleted) {
                                                                    finalDisabled = true;
                                                                    tooltipTitle = 'Uncheck subsequent steps first';
                                                                } else {
                                                                    finalDisabled = false;
                                                                    tooltipTitle = 'Uncheck / Mark as Pending';
                                                                }
                                                            } else {
                                                                finalDisabled = true;
                                                                tooltipTitle = 'This step is already completed';
                                                            }
                                                        } else {
                                                            const isDisabled = isAnyPreviousStepPending || bomData?.is_paused;
                                                            finalDisabled = isDisabled || !canMarkComplete;

                                                            if (bomData?.is_paused) {
                                                                tooltipTitle = 'BOM is currently paused';
                                                            } else if (isAnyPreviousStepPending) {
                                                                tooltipTitle = 'Complete previous steps first';
                                                            } else if (!canMarkComplete) {
                                                                tooltipTitle = 'You do not have permission to change status';
                                                            }
                                                        }

                                                        return (
                                                            <Tooltip title={tooltipTitle}>
                                                                <span>
                                                                    <IconButton
                                                                        disabled={finalDisabled}
                                                                        onClick={() => {
                                                                            const nextStatus = s.status === 'Completed' ? 'Pending' : 'Completed';
                                                                            handleStepStatusChange(idx, si, nextStatus);
                                                                        }}
                                                                        color={s.status === 'Completed' ? 'success' : 'default'}
                                                                        size="small"
                                                                    >
                                                                        {s.status === 'Completed' 
                                                                            ? <CheckCircleSharpIcon sx={{ fontSize: 30, color: 'green' }} /> 
                                                                            : <CheckCircleSharpIcon sx={{ fontSize: 30, color: 'grey', opacity: finalDisabled ? 0.2 : 0.5 }} />
                                                                        }
                                                                    </IconButton>
                                                                </span>
                                                            </Tooltip>
                                                        );
                                                    })()}
                                                </TableCell>
                                            )}

                                            {canViewInternalDetails && (
                                                <>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <TextField 
                                                            type="number" size="small" variant="standard" value={s.buffer_days ?? 0}
                                                            onChange={(e) => setStepField(idx, si, 'buffer_days', Number(e.target.value))}
                                                            InputProps={{ readOnly: !canEditBufferDays, inputProps: { min: 0, style: { textAlign: 'center' } } }}
                                                            sx={{ maxWidth: 80 }}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ textAlign: 'center' }}>
                                                        <TextField 
                                                            type="number" 
                                                            size="small" 
                                                            variant="standard" 
                                                            value={s.predefined_duration_days ?? 0}
                                                            onChange={(e) => setStepField(idx, si, 'predefined_duration_days', Number(e.target.value))}
                                                            InputProps={{ 
                                                                readOnly: !(s.is_custom || !s.step_ref), 
                                                                inputProps: { min: 0, style: { textAlign: 'center' } } 
                                                            }} 
                                                            sx={{ maxWidth: 80 }}
                                                        />
                                                    </TableCell>
                                                </>
                                            )}
                                            
                                            <TableCell>
                                                 <TextField type="date" size="small" variant="standard" value={s.defined_completion_date ? moment(s.defined_completion_date).format('YYYY-MM-DD') : ''} InputProps={{ readOnly: true }} InputLabelProps={{ shrink: true }} fullWidth />
                                            </TableCell>

                                            {canViewInternalDetails && bomData.current_stage !== "Manufacturing-Planning" && (
                                                <>
                                                    <TableCell>
                                                        <TextField type="date" size="small" variant="standard" value={s.actual_completion_date ? moment(s.actual_completion_date).format('YYYY-MM-DD') : ''} 
                                                            InputProps={{ readOnly: !canEditActualCompletionDate }}
                                                            onChange={(e) => { const v = e.target.value ? new Date(e.target.value).toISOString() : null; setStepField(idx, si, 'actual_completion_date', v); }}
                                                            disabled={s.status !== 'Completed'} InputLabelProps={{ shrink: true }} fullWidth />
                                                    </TableCell>
                                                </>
                                            )}

                                            {canViewStatusCol && bomData.current_stage !== "Manufacturing-Planning" && (
                                                <>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                            <Chip size="small" label={statusChip.label} color={statusChip.color} variant={statusChip.variant} />
                                                        </Box>
                                                    </TableCell>
                                                </>

                                            )}


                                            <TableCell>
                                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, justifyContent: 'center' }}>
                                                        {s.attachments?.map((attachment, attachmentIndex) => (
                                                            <Chip
                                                                key={attachmentIndex}
                                                                size="small"
                                                                icon={<CloudUploadIcon />}
                                                                label={attachment.file_name || 'file'}
                                                                onClick={() => handleDownloadForStep(attachment.file_url)}
                                                                onDelete={canManageAttachments ? () => clearAttachmentForStep(idx, si, attachmentIndex) : undefined} // Uses stable function
                                                                deleteIcon={canManageAttachments ? <DeleteForeverIcon /> : undefined}
                                                                variant="outlined"
                                                                sx={{ maxWidth: '50px', '& .MuiChip-label': { display: 'block', overflow: 'hidden', textOverflow: 'ellipsis' } }}
                                                            />
                                                        ))}
                                                    </Box>

                                                    {s.is_uploading ? (
                                                        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', gap: 1 }}>
                                                            <LinearProgress variant="determinate" value={s.upload_progress ?? 0} sx={{ flex: 1 }} />
                                                            <Typography variant="caption" color="text.secondary">{`${s.upload_progress ?? 0}%`}</Typography>
                                                        </Box>
                                                    ) : (
                                                    canManageAttachments && (
                                                        <Tooltip title="Add Attachments">
                                                                <IconButton size="small" component="label" >
                                                                    <input
                                                                        type="file"
                                                                        hidden
                                                                        multiple
                                                                        onChange={(e) => {
                                                                            const files = Array.from(e.target.files || []);
                                                                            if (files.length > 0) uploadAttachmentForStep(idx, si, files);
                                                                            e.target.value = '';
                                                                        }}
                                                                    />
                                                                    <CloudUploadIcon />
                                                                </IconButton>
                                                        </Tooltip>
                                                        )
                                                    )}
                                                </Box>
                                            </TableCell>
                                            {bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING && (
                                            <TableCell>
                                                <Tooltip title="Add custom step after this">
                                                    <span>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleAddCustomStep(idx, si)}
                                                            disabled={!canEditBufferDays}
                                                        >
                                                            <AddBoxIcon />
                                                        </IconButton>
                                                    </span>
                                                </Tooltip>


                                                    <Tooltip title="Delete this custom step">
                                                        <span>
                                                            <IconButton
                                                                size="small"
                                                                onClick={() => {
                                                                    if (window.confirm('Are you sure you want to delete this step?')) {
                                                                        handleDeleteStep(idx, si);
                                                                    }
                                                                }}
                                                                disabled={!canEditBufferDays}
                                                                color="error"
                                                            >
                                                                <DeleteForeverIcon />
                                                            </IconButton>
                                                        </span>
                                                    </Tooltip>
                               
                                            </TableCell>
                                            )}
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </div>
        );
    },
    [
        bomData, 
        setStepField, 
        handleStepStatusChange, 
        handleDownloadForStep, 
        clearAttachmentForStep, 
        uploadAttachmentForStep,
        handleAddCustomStep,
        handleDeleteStep,
        keyForStep,
        initialUser,
        handleRejectItem
    ]
);

    const handleProcurementSelectionChange = useCallback((itemIndex, procurementDetails) => {
        setItems(prevItems => {
            const newItems = [...prevItems];
            if (newItems[itemIndex]) {
                const it = newItems[itemIndex];
                const perUnit = Number(it.raw_material_length_mm) || 0;
                const totalReq = perUnit * (Number(it.quantity) || 0);
                const totalAlloc = (procurementDetails || []).reduce((s, d) => s + (Number(d.length_allocated) || 0), 0);
                newItems[itemIndex] = {
                    ...it,
                    procurement_details: procurementDetails,
                    procurement_done: perUnit > 0 && totalAlloc >= totalReq,
                };
            }
            return newItems;
        });
    }, []);

        const inventorySpecKey = useMemo(() => {
            const keys = items
                .filter(i => i.raw_material_od_mm && i.steel_material_description)
                .map(i => `${i.raw_material_od_mm}::${i.steel_material_description}`);
            return Array.from(new Set(keys)).sort().join('|');
        }, [items]);

    useEffect(() => {
        // if (bomData.current_stage !== BOM_STAGES.PROCUREMENT || !inventorySpecKey) {
        //     setOriginalInventory([]); 
        //     return;
        // }

        const fetchAllInventory = async () => {
            const requiredSpecs = new Map();
            items.forEach(item => {
                if (item.raw_material_od_mm && item.steel_material_description) {
                    const key = `${item.raw_material_od_mm}-${item.steel_material_description}`;
                    if (!requiredSpecs.has(key)) {
                        requiredSpecs.set(key, {
                            od: item.raw_material_od_mm,
                            material: item.steel_material_description
                        });
                    }
                }
            });

            if (requiredSpecs.size === 0) return;

            try {
                setInventoryLoading(true);
                setInventoryError(null);

                const promises = Array.from(requiredSpecs.values()).map(spec =>
                    getRawmaterialByOdandMaterial({}, spec.od, spec.material)
                );
                
                const responses = await Promise.all(promises);
                
                const combinedInventory = new Map();
                responses.forEach(res => {
                    const inventoryItems = res?.data?.result || [];
                    inventoryItems.forEach(invItem => {
                        if (!combinedInventory.has(invItem._id)) {
                            combinedInventory.set(invItem._id, invItem);
                        }
                    });
                });
                
                setOriginalInventory(Array.from(combinedInventory.values()));

            } catch (err) {
                console.error("Failed to fetch shared inventory:", err);
                setInventoryError("Could not load inventory data.");
            } finally {
                setInventoryLoading(false);
            }
        };

        fetchAllInventory();
    }, [bomData.current_stage,inventorySpecKey]);



        const virtualInventory = useMemo(() => {
        const totalAllocationsMap = new Map();
        items.forEach(item => {
            (item.procurement_details || []).forEach(alloc => {
            totalAllocationsMap.set(alloc.raw_material_id,(totalAllocationsMap.get(alloc.raw_material_id) || 0) + alloc.length_allocated);
            });
        });

        return originalInventory.map(part => ({
            ...part,
            remaining_length_mm: Math.max(
            0,
            (part.remaining_length_mm ?? part.length_mm ?? 0) - (totalAllocationsMap.get(part._id) || 0)
            ),
        }));
    }, [originalInventory, items]);

    const isChecklistComplete = useMemo(() => {
        const docs = finalDispatchChecks.documents || {};
        const visuals = finalDispatchChecks.visual_checks || {};
        const docsOk = Object.keys(docs).length > 0 && Object.values(docs).every(Boolean);
        const visualsOk = Object.keys(visuals).length > 0 && Object.values(visuals).every(Boolean);
        return docsOk && visualsOk;
    }, [finalDispatchChecks]);

    const [addOpen, setAddOpen] = useState(false);
    const [newItem, setNewItem] = useState({
        part_ref: null,
        process_type_id: null,
        document_number: '', //added
        steel_material_description: '',
        finished_material_od_mm: '',
        finished_material_length_mm: '',
        quantity: 1,
        procurement_source: PROCUREMENT_SOURCE.SUPPLIER,
        procurement_done: false,
        attachments: [],
        selected_raw_material_ids: [],
        new_doc_no_value: '',
        new_part_name_value: '',
    });

         const approvalQuestions = [
        { key: 'q1', label: 'Component clamping diameters are as per approved DAP' },
        { key: 'q2', label: 'Grinding wheel / COC path do not have collision with fixture' },
        { key: 'q3', label: 'Nozzle collision is checked with tailstock and fixture' },
        {
            key: 'q4',
            label: {
                main: 'Fixture checked for:',
                sub: [
                    'a. Component is in working / grinding range',
                    'b. Spindle interface is correct',
                    'c. Oil ports and orientation holes are correct',
                    'd. Clamping bolts pcd and size are ok',
                    'e. Tailstock taper is correct as per machine specification'
                ]
            }
        },
        { key: 'q5', label: 'BOM and quantity are verified as per PO scope' },
        {
            key: 'q6',
            label: {
                main: 'Manufacturing drawings have correct:',
                sub: [
                    'a. Raw material selection',
                    'b. Heat treatment',
                    'c. Critical GD&T parameters are checked',
                    'd. Engraving details'
                ]
            }
        },
        {
            key: 'q7',
            label: {
                main: 'Assembly drawing mentions:',
                sub: [
                    'a. Runout values to achieve are mentioned',
                    'b. Fixture height is mentioned',
                    'c. Setting distances, if any are mentioned',
                    'd. Spring calculations, if any are mentioned'
                ]
            }
        },
        { key: 'q8', label: 'Standard procurement parts, if any, are mentioned in BOM' },
        {
            key: 'q9',
            type: 'dropdown',
            label: {
                text: 'Fixture is for Export:',
                sub: [
                    'a. Material numbers taken',
                    'b. Email sent to KLD for the ‘maintain’ of material numbers'
                ]
            }
        },
    ];
    const resetNewItem = useCallback(() => {
        setNewItem({
            part_ref: null,
            process_type_id: null,
            document_number: '', //added
            steel_material_description: '',
            finished_material_od_mm: '',
            finished_material_length_mm: '',
            quantity: 1,
            procurement_source: PROCUREMENT_SOURCE.SUPPLIER,
            procurement_done: false,
            selected_raw_material_ids: [],
            new_doc_no_value: '',
            new_part_name_value: '',
        });
    }, []);

    

    // const handleAddSave = useCallback(async () => {
    //     if (!newItem.part_ref) return ShowToast('Select Part', TYPE_FAIL, INTERVAL, props, '');
    //     if (!newItem.document_number.trim())
    //         return ShowToast('Enter Document Number', TYPE_FAIL, INTERVAL, props, '');
    //     if (!newItem.process_type_id)
    //         return ShowToast('Select Std Process', TYPE_FAIL, INTERVAL, props, '');
    //     if (!(Number(newItem.finished_material_od_mm) >= 0))
    //         return ShowToast('OD must be ≥ 0', TYPE_FAIL, INTERVAL, props, '');
    //     if (!(Number(newItem.finished_material_length_mm) >= 0))
    //         return ShowToast('Length must be ≥ 0', TYPE_FAIL, INTERVAL, props, '');
    //     if (!(Number(newItem.quantity) >= 1))
    //         return ShowToast('Qty must be ≥ 1', TYPE_FAIL, INTERVAL, props, '');

    //     await onRowAdd({
    //         ...newItem,
    //         document_number: newItem.document_number.trim(),
    //         finished_material_od_mm: Number(newItem.finished_material_od_mm),
    //         finished_material_length_mm: Number(newItem.finished_material_length_mm),
    //         quantity: Number(newItem.quantity),
    //     });
    //     setAddOpen(false);
    //     resetNewItem();
    // }, [newItem, onRowAdd, resetNewItem, props]);
    // src/views/BOM/CreateBomPage.js

        // New handler specifically for the Checklist Dialog (Dialog 2)
// src/views/BOM/CreateBomPage.js

const handleSaveChecklistDialog = useCallback(async () => {
    try {
        setIsSaving(true);

        let updatedAttachments = [...(finalDispatchChecks.dispatch_checklist_attachments || [])];

        if (bomDispatchFilesDraft.length > 0) {
            const uploaded = [];
            for (let i = 0; i < bomDispatchFilesDraft.length; i++) {
                const f = bomDispatchFilesDraft[i];
                const pres = await getS3PresignedUrl({}, {
                    fileName: f.name,
                    fileType: f.type || 'application/octet-stream',
                });
                const putUrl = pres?.data?.url;
                const publicUrl = pres?.data?.fileUrl;

                await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.open('PUT', putUrl, true);
                    xhr.setRequestHeader(HTTP_HEADER_KEYS.CONTENT_TYPE, f.type || HTTP_CONTENT_TYPES.OCTET_STREAM);
                    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject());
                    xhr.onerror = () => reject();
                    xhr.send(f);
                });

                let file_key = '';
                try {
                    const u = new URL(putUrl);
                    const path = decodeURIComponent(u.pathname.replace(/^\/+/, ''));
                    const at = path.indexOf('uploads/');
                    file_key = at >= 0 ? path.substring(at) : path;
                } catch {}

                uploaded.push({
                    file_name: f.name,
                    file_type: f.type || '',
                    file_url: publicUrl,
                    file_key,
                    uploaded_at: new Date()
                });
            }
            updatedAttachments = [...updatedAttachments, ...uploaded];
            setBomDispatchFilesDraft([]); 
        }

        const updatedChecklist = {
            ...finalDispatchChecks,
            dispatch_checklist_attachments: updatedAttachments
        };

        const payload = {
            dispatch_checklist: updatedChecklist,
            dispatch_remark: bomDispatchRemark || undefined, 
        };

        const response = await updateBOM({}, payload, routeBomId);

        if (response?.data?.result) {
            const updatedBom = response.data.result;
            setBomData(updatedBom);
            
            if (updatedBom.dispatch_checklist) {
                setFinalDispatchChecks({
                    documents: updatedBom.dispatch_checklist.documents || {},
                    visual_checks: updatedBom.dispatch_checklist.visual_checks || {},
                    dispatch_checklist_attachments: updatedBom.dispatch_checklist.dispatch_checklist_attachments || []
                });
            }
        }

        setIsDispatchChecklistOpen2(false);
        ShowToast('Checklist saved to database successfully', TYPE_SUCCESS, INTERVAL);

    } catch (error) {
        console.error("Failed to save checklist:", error);
        ShowToast('Failed to save checklist', TYPE_FAIL, INTERVAL);
    } finally {
        setIsSaving(false);
    }
}, [bomDispatchFilesDraft, finalDispatchChecks, bomDispatchRemark, routeBomId]);

    const handlePauseResumeClick = async () => {
        if (!window.confirm(`Are you sure you want to ${bomData.is_paused ? 'resume' : 'pause'} this BOM?`)) return;
        setIsSaving(true);
        try {
            if (bomData.is_paused) {
                await resumeBom({}, routeBomId);
                ShowToast('BOM resumed successfully', TYPE_SUCCESS, INTERVAL, props, '');
            } else {
                await pauseBom({}, routeBomId);
                ShowToast('BOM paused successfully', TYPE_SUCCESS, INTERVAL, props, '');
            }
            
            const refreshed = await getBomById({}, {}, routeBomId);
            const bom = refreshed?.data?.result || refreshed?.data;
            if (bom) {
                setBomData(bom);
                prefillFromBom(bom);
            }
        } catch (err) {
            ShowToast(err?.response?.data?.error || 'Action failed', TYPE_FAIL, INTERVAL);
        } finally {
            setIsSaving(false);
        }
    };

    const handleAddSave = useCallback(async () => {
    let itemToSave = { ...newItem };

        if (itemToSave.new_doc_no_value && !itemToSave.part_ref) {
            try {
                const docNo = itemToSave.new_doc_no_value.trim();
                const partName = itemToSave.new_part_name_value.trim();

                if (!partName) {
                    ShowToast('Please enter a Part Name for the new part.', TYPE_FAIL, INTERVAL, props, '');
                    return;
                }

                ShowToast(`Creating new part: "${partName}"...`, 'info', 1000);

                const newPartPayload = {
                    part_name: partName,
                    document_number: docNo, 
                    od_mm: 0,
                    length_mm: 0,
                    stock_quantity: 0,
                    part_type: 'Standard',
                };
                const response = await createParts({}, newPartPayload);
                const createdPart = response?.data?.result;

                if (!createdPart?._id) {
                    ShowToast('Failed to create the new part.', TYPE_FAIL, INTERVAL, props, '');
                    return;
                }

                setParts((prev) => [...prev, createdPart]);
                itemToSave.part_ref = createdPart._id;
                itemToSave.document_number = createdPart.document_number; 
            } catch (err) {
                const msg = err?.response?.data?.error || 'An error occurred.';
                if (msg.includes('duplicate key')) {
                    ShowToast('A part with this Document Number already exists.', TYPE_FAIL, INTERVAL, props, '');
                } else {
                    ShowToast(msg, TYPE_FAIL, INTERVAL, props, '');
                }
                return;
            }
        }

        if (!itemToSave.part_ref) return ShowToast('Select or create a Part', TYPE_FAIL, INTERVAL, props, '');
        if (!itemToSave.document_number.trim())
            return ShowToast('Enter Document Number', TYPE_FAIL, INTERVAL, props, '');
        if (!itemToSave.process_type_id)
            return ShowToast('Select Std Process', TYPE_FAIL, INTERVAL, props, '');
        if (!(Number(itemToSave.finished_material_od_mm) >= 0))
            return ShowToast('OD must be ≥ 0', TYPE_FAIL, INTERVAL, props, '');
        if (!(Number(itemToSave.finished_material_length_mm) >= 0))
            return ShowToast('Length must be ≥ 0', TYPE_FAIL, INTERVAL, props, '');
        if (!(Number(itemToSave.quantity) >= 1))
            return ShowToast('Qty must be ≥ 1', TYPE_FAIL, INTERVAL, props, '');

        await onRowAdd({
            ...itemToSave,
            document_number: itemToSave.document_number.trim(),
            finished_material_od_mm: Number(itemToSave.finished_material_od_mm),
            finished_material_length_mm: Number(itemToSave.finished_material_length_mm),
            quantity: Number(itemToSave.quantity),
        });
        setAddOpen(false);
        resetNewItem();
    }, [newItem, onRowAdd, resetNewItem, props]);

    const pageReady = listsLoaded && bomLoaded && labelsResolved;
    if (!pageReady || isSaving) return <Spinner />;

    const EditableStepTitle = ({ initialTitle, itemIndex, stepIndex, onSave }) => {
        const [title, setTitle] = useState(initialTitle || '');
        const isMounted = useRef(false);

        useEffect(() => {
            if (isMounted.current) {
                setTitle(initialTitle || '');
            } else {
                isMounted.current = true;
            }
        }, [initialTitle]);

        const handleChange = (e) => {
            setTitle(e.target.value);
        };

        const handleBlur = () => {

            if (title !== initialTitle) {
                onSave(itemIndex, stepIndex, 'step_title_snapshot', title);
            }
        };

        return (
            <TextField 
                variant="standard"
                value={title}
                onChange={handleChange}
                onBlur={handleBlur} 
                placeholder="Enter step title"
                fullWidth
                sx={{ 
                    '& .MuiInput-underline:before': { borderBottom: '1px dashed #999' },
                    '& .MuiInput-input': { padding: '4px 0 5px' } 
                }}
            />
        );
    };
    const handleOpenPoView = async () => {
        const poId = selectedPoId || selectedPoIdFromUrl || bomData?.po_id;

        if (!poId) {
            ShowToast('PO details not available', TYPE_FAIL);
            return;
        }

        try {
            const response = await getPODetailsForBom({}, {}, poId);
            const po =
                response?.data?.result ||
                response?.result ||
                response?.data?.data?.result;

            if (!po) {
                ShowToast('PO details not found', TYPE_FAIL);
                return;
            }
            setSelectedPoDetails(po);
            setPoViewOpen(true);
        } catch (error) {
            ShowToast('Failed to fetch PO details', TYPE_FAIL);
        }
    };
    return (
        <div className="main-content bom-page" >
            {/* Page title */}
            <div className="pagetitle row" style={{ color: 'black', marginTop: "-25px" }}>
            <div className="col-md-10 sm_device">
                 <FormatListNumberedIcon aria-hidden="true" />
                    <span style={{ marginLeft: '7px' }}>
                        {routeBomId ? (
                            <>
                                Update Project - 
                                <span style={{ fontSize: '0.85em', opacity: 0.6, marginLeft: '5px', fontWeight: 'lighter' }}>
                                    {fixtureDocNo || ''}
                                </span>
                            </>
                        ) : (
                            'Project Creation'
                        )}
                    </span>
                </div>
                <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}>
                    <DeliverySchedule />
                </div>
            </div>
            <div className="bom-divider" />
            <div className="bom-divider" />

            {/* Progress Bar */}
            {routeBomId && bomData.current_stage && initialUser?.user_role !== SUPPLIER && (
            <>
            <Box 
                sx={{ 
                    '& .MuiStepLabel-label': { 
                        fontWeight: '400 !important',
                        fontSize: '12px'              
                    },
                    '& .MuiStepLabel-label.Mui-active': { 
                        fontWeight: '600 !important'  
                    },
                }}
            >
                {/* Update this line */}
                <BomProgressBar 
                    currentStage={bomData.current_stage} 
                    stageTimelines={bomData.stage_timelines} 
                />
            </Box> 
            <div className="bom-divider" /> 
            </>
            )}
{/* START OF SPLIT LAYOUT */}
            <div className="row" style={{ position: 'relative' }}> 
                {/* LEFT COLUMN: Main Form */}
                <div 
                    className={routeBomId && (initialUser.user_role !== SUPPLIER) ? "col-md-9" : "col-md-12"}
                    style={{ display: 'flex', flexDirection: 'column' }}
                >
                    
                    {/* NEW CARD CONTAINER */}
                    <div className="bom-layout-card" style={{ flex: 1 }}>
                             <div className="bom-sidebar-header">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FormatListNumberedIcon sx={{ mr: 1, color: '#2d3d42', fontSize: 20 }} />
                                    <span className="bom-sidebar-title">Project Details</span>
                                </Box>
   
                            </div>
                        
                        {canViewFormHeader && (
                            <div className="row">
                                {renderFieldRow({
                                    label: (
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Customer
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'customer',
                                    children: (
                                        <Select
                                            inputId="customer"
                                            placeholder="Select customer…"
                                            options={customers.map((c) => ({
                                                value: c._id,
                                                label: c.customer_name || c.name || 'Unnamed',
                                            }))}
                                            value={customer}
                                            onChange={setCustomer}
                                            isClearable
                                            isDisabled={isReadOnly}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            menuPlacement="auto"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                            }}
                                        />
                                    ),
                                })}
                                {renderFieldRow({
                                    label: (
                            <span className={isReadOnly ? 'readonly-label' : ''}>
                                PO Reference
                            {(selectedPoId || selectedPoIdFromUrl || bomData?.po_id) && (
                                <Link
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        handleOpenPoView();
                                    }}
                                    style={{
                                        marginLeft: '8px',
                                        color: '#2d3d42',
                                        textDecoration: 'none',
                                        cursor: 'pointer',
                                    }}
                                    title="View PO"
                                >
                                    <VisibilityIcon
                                        sx={{
                                            fontSize: 20,
                                            color: '#2d3d42',
                                            verticalAlign: 'middle',
                                        }}
                                    />
                                </Link>
                                )}
                            </span>
                        ),
                    fieldId: 'poRef',
                        children: (
                            <input
                                id="poRef"
                                className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                placeholder="e.g., PO-12345"
                                value={poRef}
                                onChange={(e) => setPoRef(e.target.value)}
                                disabled={isReadOnly}
                            />
                        ),
                    })}

                            </div>
                        )}
                        {canViewFormHeader && (

                            <div className="row">
                                {renderFieldRow({
                                    label: (
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Component Drawing Number(s)
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'drawingNumbers',
                                    children: (
                                        <CreatableSelect
                                            id="drawingNumbers"
                                            isMulti
                                            placeholder="Type and press Enter to add numbers..."
                                            value={drawingNumbers}
                                            onChange={(newValue) => setDrawingNumbers(newValue || [])}
                                            noOptionsMessage={() => 'Type to create a drawing number'}
                                            isDisabled={isReadOnly}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                    minHeight: '38px',
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                            }}
                                        />
                                    ),
                                })}
                                {renderFieldRow({
                                    label:(
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Machine
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'machine',
                                    children: (
                                        <input
                                            id="machine"
                                            className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                            placeholder="e.g., CGWH / Hermle C42"
                                            value={machine}
                                            disabled={isReadOnly}
                                            onChange={(e) => setMachine(e.target.value)}
                                        />
                                    ),
                                })}
                            </div>
                        )}

                        {canViewFormHeader && (
                            <div className="row">
                                {renderFieldRow({
                                    label: (
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Business Vertical
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'businessVertical',
                                    children: (
                                        <Select
                                            inputId="businessVertical"
                                            placeholder="Select vertical…"
                                            options={businessVerticals.map((b) => ({
                                                value: b._id,
                                                label: b.name,
                                            }))}
                                            value={businessVertical}
                                            onChange={setBusinessVertical}
                                            isClearable
                                            menuPortalTarget={document.body}
                                            isDisabled={isReadOnly}
                                            menuPosition="fixed"
                                            menuPlacement="auto"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                            }}
                                        />
                                    ),
                                })}
                                {renderFieldRow({
                                    label: (
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Region
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'region',
                                    children: (
                                        <Select
                                            inputId="region"
                                            placeholder="Select region…"
                                            options={regions.map((r) => ({ value: r._id, label: r.name }))}
                                            value={region}
                                            onChange={(val) => {
                                                setRegion(val);
                                                setSelectedSalesUser(null); // <--- Add reset here manually
                                            }}
                                            isClearable
                                            isDisabled={isReadOnly}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            menuPlacement="auto"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                control: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                option: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    fontSize: 'var(--bom-input-font-size)',
                                                }),
                                            }}
                                        />
                                    ),
                                })}
                            </div>
                        )}
                            <div className="row">
                                    {renderFieldRow({
                                        label:(
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Fixture Document Number
                                            {bomCode && (
                                                <span style={{ fontSize: '12px', color: '#888', marginLeft: '10px', fontWeight: '400' }}>
                                                    ({bomCode})
                                                </span>
                                            )}
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'fixtureDocNo',
                                    children: (
                                    <input
                                        id="fixtureDocNo"
                                        type="text"
                                        className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                        placeholder="Enter Fixture Document Number..."
                                        value={fixtureDocNo}
                                        onChange={(e) => setFixtureDocNo(e.target.value)}
                                        disabled={isReadOnly}
                                    />
                                    ),
                                })}
                                {renderFieldRow({
                                    label: (
                                        <span className={'readonly-label'}>
                                            Design Engineer
                                        </span>
                                    ),
                                    fieldId: 'designEngineer',
                                    children: (
                                        <input
                                            id="designEngineer"
                                                className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                            value={designEngineerName}
                                            disabled
                                        />
                                    ),
                                })}
                            </div>

                            <div className="row">
                                {renderFieldRow({
                                    label: (
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Fixture Name
                                        </span>
                                    ),
                                    required: true,
                                    fieldId: 'fixtureName',
                                    children: (
                                        <input
                                            id="fixtureName"
                                            className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                            placeholder="Enter Fixture Name"
                                            value={fixtureName}
                                            disabled={isReadOnly}
                                            onChange={(e) => setFixtureName(e.target.value)}
                                        />
                                    ),
                                })}
                                {renderFieldRow({
                                    label: (
                                        <span className={isReadOnly ? 'readonly-label' : ''}>
                                            Surface Treatment Type
                                        </span>
                                        ),
                                    required: true,
                                    fieldId: 'surfaceTreatment',
                                    children: (
                                        <input
                                            id="surfaceTreatment"
                                            className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                            placeholder="e.g., Sandblasting"
                                            value={surfaceTreatmentType}
                                            onChange={(e) => setSurfaceTreatmentType(e.target.value)}
                                            disabled={isReadOnly}
                                        />
                                    ),
                                })}
                            </div>
                            {initialUser?.user_role != SUPPLIER && (
                                <div className="row">

                                 {(bomData.current_stage && bomData.current_stage !== BOM_STAGES.DESIGN && bomData.current_stage !== BOM_STAGES.PROCUREMENT) && renderFieldRow({                                        label: (
                                            <span className={isReadOnly ? 'readonly-label' : ''}>
                                                Sales Person
                                            </span>
                                        ),
                                        required: false,
                                        fieldId: 'salesPerson',
                                        children: (
                                            <Select
                                                inputId="salesPerson"
                                                placeholder={region ? "Select Sales Person..." : "Select Region first..."}
                                                options={filteredSalesOptions}
                                                value={selectedSalesUser}
                                                onChange={setSelectedSalesUser}
                                                isClearable
                                                isDisabled={isReadOnly || !region}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        fontSize: 'var(--bom-input-font-size)',
                                                    }),
                                                }}
                                            />
                                        ),
                                    })}

                                    {renderFieldRow({
                                        label: (
                                            <span className={isReadOnly ? 'readonly-label' : ''}>
                                                End Client
                                            </span>
                                        ),
                                        fieldId: 'endClient',
                                        children: (
                                            <input
                                                id="endClient"
                                                className={`form-control-customer bom-input ${isReadOnly ? 'readonly-input' : ''}`}
                                                placeholder="Enter End Client"
                                                value={endClient}
                                                onChange={(e) => setEndClient(e.target.value)}
                                                disabled={isReadOnly}
                                            />
                                        ),
                                    })}
                                </div>
                            )}

                            {(bomData.current_stage !== BOM_STAGES.DESIGN && bomData.current_stage !== BOM_STAGES.PROCUREMENT && initialUser?.user_role !== SUPPLIER) && (
                                <div className="row">
                                    {renderFieldRow({
                                        label: (
                                            <span className={
                                                !((initialUser.user_role === SUPER_ADMIN || initialUser.user_role === MANUFACTURING_ENGINEER))
                                                    ? 'readonly-label' : ''
                                            }>
                                                Assigned Supplier
                                            </span>
                                        ),
                                        required: false,
                                        fieldId: 'assignedSupplier',
                                        children: (
                                            <Select
                                                inputId="assignedSupplier"
                                                placeholder="Select Supplier..."
                                                options={supplierUsers.map((u) => ({
                                                    value: u._id,
                                                    label: `${u.first_name || ''} ${u.last_name || ''}`.trim() || u.company_name || u.username,
                                                }))}
                                                value={assignedSupplier}
                                                onChange={setAssignedSupplier}
                                                isClearable
                                                isDisabled={isGlobalReadOnly || !(initialUser.user_role === SUPER_ADMIN || (initialUser.user_role === MANUFACTURING_ENGINEER && bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION))}
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                    control: (base) => ({
                                                        ...base,
                                                        fontSize: 'var(--bom-input-font-size)',
                                                    }),
                                                }}
                                            />
                                        ),
                                    })}
                                </div>
                            )}
                            <div className="row">
                            {canViewFormHeader && (
                            <>
                                {renderFieldRow({
                                    label: (
                                        <span className={isDapReadOnly ? 'readonly-label' : ''}>
                                            DAP Date
                                        </span>
                                        ),
                                    required: false,
                                    fieldId: 'dapDate',
                                    children: (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                            <input
                                                id="dapDate"
                                                type="date"
                                                className={`form-control-customer bom-input ${isDapReadOnly ? 'readonly-input' : ''}`}
                                                value={dapDate}
                                                onChange={(e) => setDapDate(e.target.value)}
                                                disabled={isDapReadOnly}
                                            />
                                            <Box sx={{ pl: 0, pt: 1, width: '100%' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: dapAttachments.length > 0 ? 1 : 0 }}>
                                                    {dapAttachments.map((a, i) => (
                                                        <Chip
                                                            key={`dap-chip-${i}`}
                                                            size="small"
                                                            icon={<CloudUploadIcon />}
                                                            label={a.file_name || 'file'}
                                                            onClick={() => handleDapAttachmentDownload(a.file_url)}
                                                            onDelete={
                                                                bomData.current_stage && bomData.current_stage !== BOM_STAGES.DESIGN
                                                                    ? undefined 
                                                                    : () => removeDapAttachment(i)
                                                            }
                                                            deleteIcon={
                                                                bomData.current_stage && bomData.current_stage !== BOM_STAGES.DESIGN 
                                                                    ? undefined 
                                                                    : <DeleteForeverIcon />
                                                            }
                                                            variant="outlined"
                                                            sx={{ maxWidth: 200, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' } }}
                                                            title={a.file_name || 'file'}
                                                        />
                                                    ))}
                                                </Box>
                                                
                                                {dapUploading ? (
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                                        <LinearProgress variant="determinate" value={dapUploadPct} sx={{ flex: 1 }} />
                                                        <Typography variant="caption">{dapUploadPct}%</Typography>
                                                    </Box>
                                                ) : (
                                                    <Button
                                                        size="small"
                                                        component="label"
                                                        variant="outlined"
                                                        sx={{ fontSize: '14px !important', borderColor:'#2d4243', color: '#2d4243' }}
                                                        startIcon={<CloudUploadIcon />}
                                                        disabled={dapUploading || bomData.current_stage && bomData.current_stage !== BOM_STAGES.DESIGN}
                                                    >
                                                        Upload DAP
                                                        <input
                                                            type="file"
                                                            hidden
                                                            multiple
                                                            onChange={(e) => {
                                                                const files = Array.from(e.target.files || []);
                                                                if (files.length > 0) uploadDapFiles(files);
                                                                e.target.value = '';
                                                            }}
                                                        />
                                                    </Button>
                                                )}
                                            </Box>
                                        </Box>
                                    ),
                                })}

                                </>
                            )}

                                {
                                    bomData.current_stage !== BOM_STAGES.PROCUREMENT &&  bomData.current_stage !== BOM_STAGES.MANUFACTURING_PLANNING && 
                                    bomData.current_stage !== BOM_STAGES.MANUFACTURING_EXECUTION && bomData.current_stage !== BOM_STAGES.TESTING && 
                                    bomData.current_stage !== BOM_STAGES.DISPATCH && bomData.current_stage !== BOM_STAGES.HANDOVER_TO_DISPATCH  && bomData.current_stage !== BOM_STAGES.COMMERCIAL_CLEARANCE && (
                                        renderFieldRow({
                                            label: 'Manufacturing Release Date',
                                            required: true,
                                            fieldId: 'mfgReleaseDate',
                                            children: (
                                                <input
                                                    id="mfgReleaseDate"
                                                    type="date"
                                                    className="form-control-customer bom-input"
                                                    value={mfgReleaseDate}
                                                    min={moment().format('YYYY-MM-DD')}     
                                                    onChange={(e) => setMfgReleaseDate(e.target.value)}
                                                    disabled={isGlobalReadOnly||isReadOnly}
                                                />
                                            ),
                                        })
                                    )
                                }
                </div>
            </div>
        </div>

                {/* RIGHT COLUMN: PERMANENT HISTORY TIMELINE */}
                {routeBomId && (initialUser.user_role !== SUPPLIER) && (
                    <div 
                        className="col-md-3"
                        style={{
                            position: 'absolute', 
                            top: 0, 
                            bottom: 0, 
                            right: 0, 
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            // Add padding to match the Left Card's margins exactly
                            paddingTop: '1.5rem', 
                            paddingBottom: '30px' 
                        }}
                    >
                            <div 
                            className="bom-layout-card" 
                            style={{ 
                                padding: '20px 15px', 
                                height: '100%',          // Fill the space defined by the column padding
                                marginTop: 0,            // Remove default margin (handled by col padding)
                                marginBottom: 0,         // Remove default margin (handled by col padding)
                                display: 'flex', 
                                flexDirection: 'column' 
                            }}
                        >
                        
                            {/* Header (Fixed) */}
                            <div className="bom-sidebar-header" style={{ flexShrink: 0 }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <HistoryIcon sx={{ mr: 1, color: '#2d3d42', fontSize: 20 }} />
                                    <span className="bom-sidebar-title">History Logs</span>
                                </Box>
                                <Chip 
                                    label={historyLogs.length} 
                                    size="small" 
                                    sx={{ 
                                        height: 20, 
                                        fontSize: '10px', 
                                        fontWeight: 'bold',
                                        bgcolor: '#f0f0f0',
                                        color: '#2d3d42'
                                    }} 
                                />
                            </div>

                            {/* Timeline Content */}
                            {historyLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                                    <Spinner />
                                </Box>
                            ) : historyLogs.length === 0 ? (
                                <Typography variant="body2" color="text.secondary" align="center" sx={{ mt: 2 }}>
                                    No history found.
                                </Typography>
                            ) : (
                                <div 
                                    style={{
                                        flex: 1,               
                                        overflowY: 'auto',     
                                        minHeight: 0,
                                        marginTop: '10px',
                                        paddingRight: '5px',
                                        scrollbarWidth: 'thin'
                                    }}
                                >
                                    <Box sx={{ position: 'relative', pl: 1 }}>
                                        {/* Vertical Timeline Line */}
                                        <Box 
                                            sx={{
                                                position: 'absolute',
                                                top: 10,
                                                bottom: 10,
                                                left: 5,
                                                width: '2px',
                                                backgroundColor: '#e0e0e0',
                                                zIndex: 0
                                            }} 
                                        />

                                        {historyLogs.map((log, index) => {
                                            const separator = "Comment:";
                                            const isComment = log.action && log.action.includes(separator);

                                            return (
                                                <Box key={index} sx={{ display: 'flex', mb: 2, position: 'relative', zIndex: 1 }}>
                                                {/* Dot */}
                                                <CircleIcon 
                                                    sx={{ 
                                                        fontSize: 12, 
                                                        color: index === 0 ? '#2d3d42' : '#bdbdbd',
                                                        backgroundColor: '#fafafa',
                                                        border: '3px solid #fafafa',
                                                        mr: 1.5,
                                                        mt: 0.5
                                                    }} 
                                                />

                                                <Box sx={{ flex: 1 }}>
                                                    <Typography variant="caption" display="block" sx={{ mb: 0.5, color: '#666', fontSize: '0.75rem', fontWeight: 500 }}>
                                                        {log.timestamp ? moment(log.timestamp).format('DD MMM, HH:mm') : '-'}
                                                    </Typography>

                                                    <Paper 
                                                        elevation={0} 
                                                        sx={{ 
                                                            p: 1.5, 
                                                            borderRadius: 2,
                                                            bgcolor: isComment ? '#e3f2fd' : '#f8f9fa', // Light Blue for comments, Gray for others
                                                            border: isComment ? '1px solid #90caf9' : '1px solid #f0f0f0', 
                                                            '&:hover': {
                                                                boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                                                                borderColor: isComment ? '#42a5f5' : '#d0d0d0'
                                                            }
                                                        }}
                                                    >
                                                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#333', fontSize: '11px', lineHeight: 1.3 }}>
                                                            {(() => {
                                                                if (isComment) {
                                                                    const parts = log.action.split(separator);
                                                                    const mainAction = parts[0];
                                                                    const commentText = parts.slice(1).join(separator);
                                                                        
                                                                        return (
                                                                            <span>
                                                                                {mainAction}
                                                                                <br/>
                                                                                <span style={{ color: '#0277bd', fontStyle: 'italic', display:'block', marginTop:'4px' }}>
                                                                                    <strong>Comment:</strong> {commentText}
                                                                                </span>
                                                                            </span>
                                                                        );
                                                                    }
                                                                    return log.action;
                                                                })()}
                                                        </Typography>                                                        
                                                        {log.performed_by && (
                                                            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                                                                By <strong>{log.performed_by}</strong>
                                                            </Typography>
                                                        )}
                                                    </Paper>
                                                </Box>
                                            </Box>
                                        );
                                        })}
                                    </Box>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
  {/* <div className="clearfix"></div>
            <div style={{ height: '30px', width: '100%' }}></div> */}

{/* STATUS SUMMARY PANEL */}
            <div className="row mt-4"> {/* Added Margin Top & Bottom */}
                <div className="col-md-12">
                    {(bomData.partial_procurement ||
                        bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING ||
                        bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) && (
                        
                        <div className="bom-status-card">
                            
                            {bomData?.partial_procurement && initialUser?.user_role !== SUPPLIER && (
                                <>
                                    <div className="bom-status-item">
                                        <WarningAmberIcon className="bom-status-icon warning" />
                                        <div>
                                            <span className="bom-status-label" style={{ color: '#ed6c02' }}>
                                                Procurement Attention
                                            </span>
                                            <Chip
                                                size="small"
                                                color="warning"
                                                variant="outlined"
                                                label={
                                                    bomData.partial_item_count > 0
                                                        ? `Pending: ${bomData.partial_item_count} Item(s)`
                                                        : 'Partial Pending'
                                                }
                                                sx={{ fontSize: '10px',fontWeight: 600, borderRadius: '4px' }}
                                            />
                                        </div>
                                    </div>
                                    {initialUser?.user_role !== SUPPLIER && (bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING || 
                                      bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) && (
                                         <div className="bom-status-divider"></div>
                                    )}
                                </>
                            )}


                            {/* --- Item 2: Targeted Completion Date --- */}
                            {(bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING ||
                                bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) && (
                                <>
                                    <div className="bom-status-item">
                                        <CalendarMonthIcon className="bom-status-icon" />
                                        <div>
                                            <span className="bom-status-label">Target Completion</span>
                                            <span className="bom-status-value">
                                                {bomData.planned_completion_date && !isNaN(new Date(bomData.planned_completion_date))
                                                    ? defaultFormatDate(bomData.planned_completion_date)
                                                    : 'Not Set'}
                                            </span>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Divider only if we are in Execution stage (showing 3rd item) */}
                            {bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION && initialUser?.user_role !== SUPPLIER && (
                                <div className="bom-status-divider"></div>
                            )}

                            {/* --- Item 3: Projected Completion Date --- */}
                            {bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION && initialUser?.user_role !== SUPPLIER && (
                                <div className="bom-status-item">
                                    <AdsClickRoundedIcon className="bom-status-icon" />
                                    <div>
                                        <span className="bom-status-label">Projected Completion</span>
                                        <span className="bom-status-value">
                                            {projectedCompletionDate && !isNaN(new Date(projectedCompletionDate))
                                                ? defaultFormatDate(projectedCompletionDate)
                                                : 'Calculating...'}
                                        </span>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <div style={{ height: '1px', background: '#ccc', width: '100%' }}></div>

{/* ---- APPROVAL HISTORY TABLE ---- */}
{bomData.stage_history && bomData.stage_history.length > 0 && (
    <div className="row mt-8">
        <div className="col-md-12">
            <div className="list-wrapper">
                <div className="bom-table-header" style={{backgroundColor: '#f5f5f5'}}>
                    <span className="bom-table-title">Approval Instructions & Comments</span>
                </div>
                
                <TableContainer component={Paper} elevation={0} className="approval-history-table-container">
                    
                    <Table size="medium" className="approval-history-table">
                        <TableHead>
                            <TableRow>
                                {/* 3. Added specific column classes */}
                                <TableCell className="col-stage">Stage</TableCell>
                                <TableCell className="col-comment">Instructions / Comment</TableCell>
                                <TableCell className="col-action-by">Action By</TableCell>
                                <TableCell className="col-date">Date</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {bomData.stage_history.slice().reverse().map((log, index) => (
                                <TableRow key={index} hover>
                                    <TableCell>
                                        <Chip 
                                            label={log.stage} 
                                            size="small" 
                                            color="primary" 
                                        />
                                    </TableCell>
                                    <TableCell>
                                        {log.comment || <em style={{color: '#999'}}>-</em>}
                                    </TableCell>
                                    <TableCell>
                                        {log.action_by?.first_name 
                                            ? `${log.action_by.first_name} ${log.action_by.last_name}` 
                                            : (log.action_by_name || 'Unknown')}
                                    </TableCell>
                                    <TableCell>
                                        {moment(log.timestamp).format('DD-MMM-YYYY HH:mm')}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    </div>
)}
            {/* ---- TABLE HEADER (CENTERED) ---- */}
    {bomData.current_stage !== BOM_STAGES.VALIDATION && (
        <div className='row mt-12'>
            <div className="col-md-12">
                <div className="bom-table-header" style={{backgroundColor: '#f5f5f5'}}>

                <span className="bom-table-title">Project Components</span>
                {
                    hasPermission("bom", "add_component") && (!routeBomId || bomData.current_stage === BOM_STAGES.DESIGN) && (                       
                        <Button
                            className="bom-add-btn"
                            variant="contained"
                            startIcon={<AddBoxIcon className="bom-add-icon" />}
                            onClick={() => setAddOpen(true)}
                            sx={{
                                backgroundColor: '#2d3d42',
                                '&:hover': {
                                    backgroundColor: '#008BCF'
                                }
                            }}
                        >
                            Add Item
                        </Button>
                    )
                }
            </div>
            {/* ---- ITEMS GRID ---- */}
            <div className="row mt-3">
            <div className="col-md-12">
                <div id="bomTable" className="bom-table">
                <ThemeProvider theme={theme}>
                <MaterialTable
                    title={null}
                    columns={columns}
                    data={items}
                        // icons={tableIcons} // Make sure you are passing the forwarded icons here
                    components={{
                        Container: (props) => (
                            <Paper {...props} elevation={0} variant="outlined">
                                {props.children}
                                <Box className="bom-table-footer">
                                    
                                <Box>
                                    {(bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING ||
                                        bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION) && (initialUser.user_role === SUPER_ADMIN || initialUser.user_role === MANUFACTURING_ENGINEER) && (
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <FactCheckIcon color="action" sx={{ fontSize: 24 }} />
                                                <Typography variant="body2" sx={{ fontWeight: 700, fontSize: '12px', color: '#555' }}>
                                                    Testing Days:
                                                </Typography>
                                            </Box>
                                                
                                            <input
                                                type="number"
                                                min="0"
                                                className="form-control-customer bom-input"
                                                value={bomTestingBufferDays}
                                                onChange={(e) =>
                                                    setBomTestingBufferDays(Number(e.target.value) >= 0 ? Number(e.target.value) : 0)
                                                }
                                                disabled={bomData.current_stage !== BOM_STAGES.MANUFACTURING_PLANNING}
                                                style={{ 
                                                    width: '80px', 
                                                    textAlign: 'center',
                                                    padding: '4px 8px',
                                                    height: '32px'
                                                }}
                                            />
                                        </Box>
                                    )}
                                </Box>

                                <Box sx={{ flex: 1 }} />

                                    <Box>
                                    {routeBomId && (
                                    <button
                                    type="button"
                                    className="cancel_button m-3"
                                    onClick={handleZipDownload}
                                    disabled={isZipDownloading}
                                    style={{
                                        padding: '6px 14px',
                                        fontSize: '12px',
                                        display: 'inline-flex',   
                                        alignItems: 'center',
                                        width: 'fit-content',     
                                        minWidth: 'unset',        
                                        whiteSpace: 'nowrap',
                                        lineHeight: '1',
                                        backgroundColor: '#fff', 
                                        border: '1px solid #ccc'
                                    }}
                                            >
                                        {isZipDownloading ? (
                                            <>
                                            <Spinner size={14} color="#3d4d42" style={{ marginRight: 8 }} />
                                            Zipping...
                                            </>
                                        ) : (
                                            <>
                                            <DownloadIcon sx={{ mr: 0.5, fontSize: 30 }} />
                                            Download All Drawings
                                            </>
                                        )}
                                        </button>
                                    )}
                                    </Box>
                                </Box>
                            </Paper>
                        ),
                    }}
                    detailPanel={
                        (rowData) => {

                            if (hasPermission('stages', 'procurement_detailpanel') &&
                                (
                                    (
                                        initialUser.user_role === 'procurement engineer' &&
                                        [
                                            BOM_STAGES.PROCUREMENT,
                                            BOM_STAGES.MANUFACTURING_PLANNING,
                                            BOM_STAGES.MANUFACTURING_EXECUTION,
                                            BOM_STAGES.TESTING,
                                            BOM_STAGES.DISPATCH,
                                            BOM_STAGES.HANDOVER_TO_DISPATCH
                                        ].includes(bomData.current_stage)
                                    )
                                    ||
                                    (
                                        initialUser.user_role === SUPER_ADMIN &&
                                        bomData.current_stage === BOM_STAGES.PROCUREMENT
                                    )
                                )) {
                                if (rowData.procurement_source === PROCUREMENT_SOURCE.SUPPLIER) {
                                    return (
                                        <Box sx={{ p: 3, backgroundColor: '#eef2f6', textAlign: 'center' }}>
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                This item is sourced directly from a supplier.
                                            </Typography>
                                            <Typography variant="body2" color="text.secondary">
                                                No internal inventory allocation is required.
                                            </Typography>
                                        </Box>
                                    );
                                } else{
                                const itemIndex = rowData.tableData.id;
                                const virtualInventoryForPanel = originalInventory.map(part => {
                                    let allocatedByOthers = 0;
                                    items.forEach((item, index) => {
                                        if (index === itemIndex || item.procurement_done) return;

                                        (item.procurement_details || []).forEach(alloc => {
                                            if (alloc.raw_material_id === part._id) {
                                                allocatedByOthers += alloc.length_allocated;
                                            }
                                        });
                                    });

                                    return {
                                        ...part,
                                        remaining_length_mm: Math.max(
                                            0,
                                            (part.remaining_length_mm ?? part.length_mm ?? 0) - allocatedByOthers
                                        ),
                                    };
                                });
                                const relevantVirtualInventory = virtualInventoryForPanel.filter(inv =>
                                     inv.od_mm >= rowData.raw_material_od_mm &&
                                     inv.steel_material_description === rowData.steel_material_description
                                );
                                const relevantOriginalInventory = originalInventory.filter(inv =>
                                     inv.od_mm >= rowData.raw_material_od_mm &&
                                     inv.steel_material_description === rowData.steel_material_description
                                );
                                
                                return <ProcurementDetailPanel
                                    rowData={rowData}
                                    quantity={rowData.quantity}
                                    currentStage={bomData.current_stage}
                                    virtualInventory={relevantVirtualInventory}
                                    originalInventory={relevantOriginalInventory}
                                    procurementDetails={rowData.procurement_details || []}
                                    onSelectionChange={(details) => handleProcurementSelectionChange(itemIndex, details)}
                                    isLoading={inventoryLoading}
                                    error={inventoryError}
                                    selectedOd={rowData.ui_selected_od || rowData.raw_material_od_mm}
                                    onSelectedOdChange={(newOd) => handleSelectedOdChange(itemIndex, newOd)}
                                    onRevertAll={() => handleRevertAllProcurement(itemIndex)}
                                    onRevertItem={(partId) => handleRevertItemProcurement(itemIndex, partId)}
                                    itemStage={rowData?.stage || BOM_STAGES.PROCUREMENT}
                                />; 
                            }
                            }
                            if ((bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING || bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION || bomData.current_stage == BOM_STAGES.TESTING ) && hasPermission("stages","detailpanel") ) {
                                return detailPanelME(rowData);
                            }
                            return (
                                <div style={{ padding: '20px', backgroundColor: '#f5f5f5' }}>
                                    <Typography variant="body1">
                                        Detailed view is not available for the current stage '{bomData.current_stage}'.
                                    </Typography>
                                </div>
                            );
                        }
                    }
                    // onRowClick={(evt, rowData, togglePanel) => togglePanel && togglePanel()}
                    onRowClick={(event, rowData, togglePanel) => {
                        if (openPanelRef.current.id !== null && openPanelRef.current.id !== rowData.tableData.id) {
                            openPanelRef.current.toggle();
                        }

                        if (togglePanel) togglePanel();

                        if (openPanelRef.current.id === rowData.tableData.id) {
                            openPanelRef.current = { id: null, toggle: null };
                        } else {
                            openPanelRef.current = { id: rowData.tableData.id, toggle: togglePanel };
                        }
                    }}
                    editable={{
                        ...(hasPermission("bom", "add_component") &&  (bomData.current_stage === BOM_STAGES.DESIGN) &&(
                            {
                                onRowAdd: async (newData) => { await onRowAdd(newData); },
                            }
                        )
                        ),
                        ...(hasPermission("bom", "edit_component") && (!routeBomId || bomData.current_stage === BOM_STAGES.DESIGN || bomData.current_stage === BOM_STAGES.PROCUREMENT || (bomData.partial_procurement && initialUser.user_role === PROCUREMENT_ENGINEER)) && (
                            {
                                onRowUpdate: async (newData, oldData) => { await onRowUpdate(newData, oldData); },
                            }
                        )
                        ),
                        
                        ...(hasPermission("bom", "delete_component") && (!routeBomId || bomData.current_stage === BOM_STAGES.DESIGN) && (
                            {
                                onRowDelete: (oldData) =>
                                    new Promise((resolve, reject) => {
                                        if (window.confirm('Are you sure you want to delete this item?')) {
                                            onRowDelete(oldData);
                                            resolve();
                                        } else {
                                            reject();
                                        }
                                    }),
                            }
                        )
                        ),
                    }}

                    options={{
                         sorting: false, 
                        toolbar: false,
                        paging: false,
                        actionsColumnIndex: -1,
                        search: false,
                        addRowPosition: 'first',
                        cellStyle: { 
                            textAlign: 'center',
                            fontSize: '14px !important' 
                        },
                        headerStyle: { 
                            textAlign: 'center',
                            fontWeight: 700
                        },
                        rowStyle: { },
                    }}
                    />
                </ThemeProvider>
                </div>
            </div>
            </div>
           </div> 
           </div>
   )}

{/* ==== BOM-level Testing & Dispatch Table ==== */}
            
{/* ==== BOM-level Testing & Dispatch Table ==== */}
            
{/* ==== BOM-level Testing & Dispatch Table ==== */}
            
            {
                hasPermission("stages","testing") && (bomData.current_stage === BOM_STAGES.TESTING || bomData.current_stage === BOM_STAGES.DISPATCH || bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH || bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE || bomData.current_stage === BOM_STAGES.COMPLETED ) && (
            <div className="row mt-6">
                <div className="col-12">
            <div className="bom-table-header">
                        <span className="bom-table-title">
                            {bomData.current_stage === BOM_STAGES.TESTING ? 'Testing' : 'Testing & Dispatch'}
                        </span>                    </div>

                <Paper >
                    <Typography variant="h6" gutterBottom>{bomData.current_stage === BOM_STAGES.TESTING ? 'Testing Details' : 'Testing & Dispatch Readiness'}</Typography>

                    <TableContainer>
                    <Table className='testing-dispatch-table'>
                        <TableHead>
                        <TableRow>
                            <TableCell
                            width="25%"
                            align="left"
                            sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                            >
                            Action
                            </TableCell>
                            <TableCell
                            width="30%"
                            align="left"
                            sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                            >
                            Remark
                            </TableCell>
                            <TableCell
                            width="20%"
                            align="left"
                            sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                            >
                            Attachments
                            </TableCell>

                            <TableCell
                                width="15%"
                                align="left"
                                sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                            >
                                Testing Completion Date
                            </TableCell>
                            <TableCell
                            width="10%"
                            align="left"
                            sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                            >
                            Report
                            </TableCell>
                            <TableCell
                            width="10%"
                            align="left"
                            sx={{ fontWeight: 'bold', verticalAlign: 'middle' }}
                            >
                            Status
                            </TableCell>
                        </TableRow>
                        </TableHead>

                        <TableBody>
                        {/* Row: Testing */}
                        <TableRow hover>
                            {/* Action */}
                            <TableCell align="left">
                            <Button
                                className="test-procurement-btn"
                                size="small"
                                variant={bomTestingDone ? 'contained' : 'outlined'}
                                color={bomTestingDone ? 'success' : 'primary'}
                                startIcon={<FactCheckIcon />}
                                onClick={openBomTesting}
                                disabled={!canEditTestingAndDispatch}
                                sx={{
                                    '&.MuiButton-contained': {
                                    color: bomTestingDone ? '#fff !important' : 'inherit',
                                    },
                                    '& .MuiButton-startIcon': {
                                    color: bomTestingDone ? '#fff !important' : 'inherit',
                                    },
                                    '& .MuiSvgIcon-root': {
                                    color: bomTestingDone ? '#fff !important' : 'inherit',
                                    },

                                    '&.MuiButton-outlined': {
                                    borderColor: '#2d3d42 !important',
                                    color: '#2d3d42 !important',
                                    '& .MuiSvgIcon-root': {
                                    color: '#2d3d42 !important',
                                    }
                                    },

                                    '&.Mui-disabled': {
                                        opacity: 0.5,
                                        backgroundColor: bomTestingDone ? 'success.main' : 'transparent',
                                        color: bomTestingDone ? '#fff !important' : '#2d3d42 !important',
                                        borderColor: bomTestingDone ? 'transparent' : '#2d3d42 !important',
                                        '& .MuiSvgIcon-root': {
                                            color: bomTestingDone ? '#fff !important' : '#2d3d42 !important',
                                        }
                                    }
                                }}
                            >
                                {bomTestingDone ? 'Edit Testing' : 'Mark Testing Done'}
                            </Button>

                            </TableCell>



                            {/* Remark (Left aligned) */}
                            <TableCell align="left">
                            <Typography
                                variant="body2"

                                sx={{
                                fontSize: '10px !important',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                maxWidth: 360,
                                textAlign: 'left',
                                }}
                                title={testReport.remarks || 'No remark'}
                            >
                                {testReport.remarks?.length ? (
                                testReport.remarks
                                ) : (
                                <em style={{ color: '#888' }}>No remark</em>
                                )}
                            </Typography>
                            </TableCell>

                            {/* Attachments (Left aligned) */}
                            <TableCell
                            align="left"
                            sx={{ verticalAlign: 'middle' }}
                            >
                            <Box
                                sx={{
                                display: 'flex',
                                gap: 1,
                                flexWrap: 'wrap',
                                justifyContent: 'flex-start',
                                maxWidth: 520,        // column content constraint
                                }}
                            >
                                {testReport.attachments?.length ? (
                                testReport.attachments.map((a, i) => (
                                    <Chip
                                    key={i}
                                    size="small"
                                    icon={<CloudUploadIcon />}
                                    label={a.file_name || 'file'}
                                    onClick={() => handleBomAttachmentDownload(a.file_url)}
                                    onDelete={canEditTestingAndDispatch ? () => removeBomTestingAttachment(i) : undefined}
                                    deleteIcon={canEditTestingAndDispatch ? <DeleteForeverIcon /> : undefined}
                                    variant="outlined"
                                    sx={{
                                        maxWidth: 200,
                                        '& .MuiChip-label': {
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        },
                                    }}
                                    title={a.file_name || 'file'}
                                    />
                                ))
                                ) : (
                                <Typography variant="caption" color="text.secondary">
                                    No attachments
                                </Typography>
                                )}
                            </Box>
                            </TableCell>

                            <TableCell align="left">
                                <Typography variant="body2" sx={{ fontWeight: 500 , fontSize: '12px !important' }}>
                                    {bomData.mfg_delivery_date ? new Date(bomData.mfg_delivery_date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : 'N/A'}
                                </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Tooltip title={bomTestingDone ? "Download Approved Report" : "Testing not completed"}>
                                <span>
                                    <IconButton
                                        onClick={() => {
                                            handleDownloadTestReport(false);
                                        }}
                                        disabled={!bomTestingDone}
                                        color="primary"
                                        size="small"
                                    >
                                        <DownloadIcon sx={{ fontSize: '30px' }} /> {/* Optional Icon */}
                                    </IconButton>
                                </span>
                            </Tooltip>
                            {/* {testReport?.generated_report?.file_url && (
                                <Typography variant="caption" display="block" color="green" sx={{fontSize:'9px'}}>
                                    (Saved)
                                </Typography>
                            )} */}
                        </TableCell>

                            {/* Status */}
                            <TableCell align="left">
                            <Chip
                                size="small"
                                sx={{ fontSize: '10px !important' }}
                                color={bomTestingDone ? 'success' : 'default'}
                                label={bomTestingDone ? 'Done' : 'Pending'}
                                variant={bomTestingDone ? 'filled' : 'outlined'}
                            />
                            </TableCell>
                        </TableRow>

                        {/* Row: Fixture Ready for Dispatch */}
                        {(bomData.current_stage === BOM_STAGES.DISPATCH || bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH || bomData.current_stage === BOM_STAGES.COMPLETED || bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE) && (
                        <TableRow hover>
                            {/* 1. Action */}
                            <TableCell align="left">
                                 <Button
                                    className="test-procurement-btn"
                                    size="small"
                                    variant={bomDispatchReady ? 'contained' : 'outlined'}
                                    color={bomDispatchReady ? 'success' : 'primary'}
                                    startIcon={<SendIcon />}
                                    onClick={() => {
                                        setIsDispatchChecklistOpen(true); 
                                    }}
                                    disabled={!canEditTestingAndDispatch}
                                    sx={{
                                    '&.MuiButton-contained': {
                                    color: bomDispatchReady ? '#fff !important' : 'inherit',
                                    },
                                    '& .MuiButton-startIcon': {
                                    color: bomDispatchReady ? '#fff !important' : 'inherit',
                                    },
                                    '& .MuiSvgIcon-root': {
                                    color: bomDispatchReady ? '#fff !important' : 'inherit',
                                    },

                                    '&.MuiButton-outlined': {
                                    borderColor: '#2d3d42 !important',
                                    color: '#2d3d42 !important',
                                    '& .MuiSvgIcon-root': {
                                    color: '#2d3d42 !important',
                                    }
                                    },

                                    '&.Mui-disabled': {
                                        opacity: 0.5,
                                        backgroundColor: bomDispatchReady ? 'success.main' : 'transparent',
                                        color: bomDispatchReady ? '#fff !important' : '#2d3d42 !important',
                                        borderColor: bomDispatchReady ? 'transparent' : '#2d3d42 !important',
                                        '& .MuiSvgIcon-root': {
                                            color: bomDispatchReady ? '#fff !important' : '#2d3d42 !important',
                                        }
                                    }
                                }}
                                >
                                    {bomDispatchReady ? 'Edit Dispatch' : 'Mark as Ready'}
                                </Button>
                            </TableCell>



                            {/* 3. Remark (ALIGNED) */}
                            <TableCell align="left">
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '10px !important',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                        overflow: 'hidden',
                                        maxWidth: 360,
                                        textAlign: 'left',
                                    }}
                                    title={bomDispatchRemark || 'No remark'}
                                >
                                    {bomDispatchRemark?.length ? (
                                    bomDispatchRemark
                                    ) : (
                                    <em style={{ color: '#888' }}>No remark</em>
                                    )}
                                </Typography>
                            </TableCell>

                            {/* 4. Attachments (ALIGNED) */}
                            <TableCell
                                align="left"
                                sx={{ verticalAlign: 'middle' }}
                            >
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        flexWrap: 'wrap',
                                        justifyContent: 'flex-start',
                                        maxWidth: 520,
                                    }}
                                >
                                    {bomDispatchAttachments?.length ? (
                                    bomDispatchAttachments.map((a, i) => (
                                        <Chip
                                        key={`dispatch-attach-${i}`}
                                        size="small"
                                        icon={<CloudUploadIcon />}
                                        label={a.file_name || 'file'}
                                        onClick={() => handleDispatchAttachmentDownload(a.file_url)}
                                        onDelete={canEditTestingAndDispatch ? () => removeBomDispatchAttachment(i) : undefined}
                                        deleteIcon={canEditTestingAndDispatch ? <DeleteForeverIcon /> : undefined}
                                        variant="outlined"
                                        sx={{
                                            maxWidth: 200,
                                            '& .MuiChip-label': {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            },
                                        }}
                                        title={a.file_name || 'file'}
                                        />
                                    ))
                                    ) : (
                                    <Typography variant="caption" color="text.secondary">
                                        No attachments
                                    </Typography>
                                    )}
                                </Box>
                            </TableCell>
                            
                            {/* 5. Testing Completion Date (BLANK) */}
                            <TableCell align="left"></TableCell>
                            {/* 6. Report (BLANK) */}
                            <TableCell align="left"></TableCell>

                            {/* 7. Status (ALIGNED) */}
                            <TableCell align="left">

                            <Chip
                                size="small"
                                sx={{ fontSize: '10px !important' }}
                                color={bomDispatchReady ? 'success' : 'default'}
                                label={bomDispatchReady ? 'Done' : 'Pending'}
                                variant={bomDispatchReady ? 'filled' : 'outlined'}
                            />
                            
                                
                            </TableCell>
                        </TableRow>
                        )}
                        </TableBody>
                    </Table>
                    </TableContainer>
                </Paper>




                {/* ==== BOM-level Testing Dialog ==== */}
                <Dialog open={bomTestingDlgOpen} onClose={closeBomTesting} maxWidth="md" fullWidth className="custom_modal">
                    <DialogTitle sx={{ display: 'block' }}>
                        <Box className="bom-dialog-title-bar">
                            <FactCheckIcon color="primary" sx={{ fontSize: 24 }} />
                            <Typography
                                variant="h6"
                                component="div"
                                className="bom-dialog-title-text"
                                sx={{ display: 'block' }} 
                            >
                                Testing — Fixture
                            </Typography>
                        </Box>
                        <Typography variant="body2" className="bom-dialog-subtitle">
                            Select the test case, fill parameters, and add supporting documents.
                        </Typography>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Grid container spacing={2}>
                        
                            {/* --- ROW 1: Case Selection (Full Width) --- */}
                            <Grid item xs={12}>
                                <label variant="subtitle1" className="bom-dialog-section-header no-border">Test Report Case:</label>
                                <Select
                                    options={testReportCaseOptions}
                                    value={testReportCaseOptions.find(
                                        (opt) => opt.value === testReport.selected_case
                                    ) || null}
                                    onChange={(opt) => handleTestReportChange('selected_case', opt.value)}
                                    styles={{
                                        control: (base, state) => ({
                                        ...base,
                                        backgroundColor: '#f9f9f9',
                                        borderColor: state.isFocused ? '#888' : '#ccc',
                                        boxShadow: state.isFocused ? '0 0 0 2px rgba(136,136,136,0.2)' : 'none',
                                        '&:hover': { borderColor: '#888' },
                                        borderRadius: 6,
                                        minHeight: 38,
                                        }),
                                        singleValue: (base) => ({
                                        ...base,
                                        color: '#333',
                                        }),
                                        placeholder: (base) => ({
                                        ...base,
                                        color: '#777',
                                        }),
                                        menu: (base) => ({
                                        ...base,
                                        backgroundColor: '#f5f5f5',
                                        border: '1px solid #ccc',
                                        zIndex: 9999,
                                        }),
                                        option: (base, { isFocused, isSelected }) => ({
                                        ...base,
                                        backgroundColor: isSelected
                                            ? '#555'
                                            : isFocused
                                            ? '#e0e0e0'
                                            : '#f5f5f5',
                                        color: isSelected ? '#fff' : '#333',
                                        cursor: 'pointer',
                                        }),
                                    }}
                                />
                            </Grid>

                            {/* --- ROW 2: Main Content (Side-by-Side) --- */}
                            
                            {/* === LEFT SIDE: All Input Fields === */}
                            <Grid item xs={12} md={8}>
                                <Grid container spacing={2}>
                                    
                                    {testReport.selected_case && testReport.selected_case !== 'Special Case' && (
                                        <>
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                    Input Conditions
                                                </Typography>
                                            </Grid>

                                            {/* --- Common Inputs (Cases 1-5) --- */}
                                            <Grid item xs={12} sm={6}>
                                                <label className="dialog-input-label">Table radial runout (µm) </label>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    className="form-control-customer bom-input"
                                                    value={testReport.table_radial_runout || ''}
                                                    onChange={(e) => handleTestReportChange('table_radial_runout', e.target.value)}
                                                />
                                                {testReportErrors.table_radial_runout && (
                                                    <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                        {testReportErrors.table_radial_runout}
                                                    </span>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <label className="dialog-input-label">Table axial runout (µm)</label>
                                                <input
                                                    type="number"
                                                    step="any"
                                                    className="form-control-customer bom-input"
                                                    value={testReport.table_axial_runout || ''}
                                                    onChange={(e) => handleTestReportChange('table_axial_runout', e.target.value)}
                                                />
                                                {testReportErrors.table_axial_runout && (
                                                    <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                        {testReportErrors.table_axial_runout}
                                                    </span>
                                                )}
                                            </Grid>

                                            {/* --- Adapter/Height Piece (Cases 3, 4, 5) --- */}
                                            {['Case 3', 'Case 4', 'Case 5'].some((c) => testReport.selected_case.startsWith(c)) && (
                                                <>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label"> Adapter / Height Piece radial runout (µm)</label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.adapter_height_piece_radial_runout || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange('adapter_height_piece_radial_runout', e.target.value)
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Adapter / Height Piece axial runout (µm)</label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.adapter_height_piece_axial_runout || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange('adapter_height_piece_axial_runout', e.target.value)
                                                            }
                                                        />
                                                    </Grid>
                                                </>
                                            )}

                                            {/* --- Tailstock (Cases 3, 4, 5) --- */}
                                            {['Case 3', 'Case 4', 'Case 5'].some((c) => testReport.selected_case.startsWith(c)) && (
                                                <>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Tailstock runout (µm) </label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.tailstock_runout || ''}
                                                            onChange={(e) => handleTestReportChange('tailstock_runout', e.target.value)}
                                                        />
                                                        {testReportErrors.tailstock_runout && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.tailstock_runout}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Tailstock alignment (µm) </label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.tailstock_alignment || ''}
                                                            onChange={(e) => handleTestReportChange('tailstock_alignment', e.target.value)}
                                                        />
                                                        {testReportErrors.tailstock_alignment && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.tailstock_alignment}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}

                                            {/* --- Clamping (Cases 1-5) --- */}
                                            {['Case 1', 'Case 2', 'Case 3', 'Case 4'].some((c) =>
                                                testReport.selected_case.startsWith(c)
                                            ) && (
                                                <Grid item xs={12}> 
                                                    <label className="bom-dialog-section-header no-border">Clamping Pressure </label>
                                                    <input
                                                        className="form-control-customer bom-input"
                                                        value={testReport.clamping_pressure || ''}
                                                        onChange={(e) => handleTestReportChange('clamping_pressure', e.target.value)}
                                                    />
                                                    {testReportErrors.clamping_pressure && (
                                                        <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                            {testReportErrors.clamping_pressure}
                                                        </span>
                                                    )}
                                                </Grid>
                                            )}
                                            {['Case 3', 'Case 4', 'Case 5'].some((c) =>
                                                testReport.selected_case.startsWith(c)
                                            ) && (
                                                <Grid item xs={12}> {/* Use full width for this section header */}
                                                    <label className="bom-dialog-section-header no-border">Tailstock Clamping Force </label>
                                                    <input
                                                        className="form-control-customer bom-input"
                                                        value={testReport.tailstock_clamping_force || ''}
                                                        onChange={(e) => handleTestReportChange('tailstock_clamping_force', e.target.value)}
                                                    />
                                                    {testReportErrors.tailstock_clamping_force && (
                                                        <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                            {testReportErrors.tailstock_clamping_force}
                                                        </span>
                                                    )}
                                                </Grid>
                                            )}

                                            {/* --- Case 1: Runout on Control Arbor --- */}
                                            {testReport.selected_case.startsWith('Case 1') && (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Control Arbor
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.runout_control_arbor?.radial || ''}
                                                            onChange={(e) => handleTestReportChange('runout_control_arbor.radial', e.target.value)}
                                                        />
                                                        {testReportErrors.runout_control_arbor?.radial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.runout_control_arbor.radial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Axial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.runout_control_arbor?.axial || ''}
                                                            onChange={(e) => handleTestReportChange('runout_control_arbor.axial', e.target.value)}
                                                        />
                                                        {testReportErrors.runout_control_arbor?.axial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.runout_control_arbor.axial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}

                                            {/* --- Case 2: Runout on Control Ring --- */}
                                            {testReport.selected_case.startsWith('Case 2') && (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Control Ring
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.runout_control_ring?.radial || ''}
                                                            onChange={(e) => handleTestReportChange('runout_control_ring.radial', e.target.value)}
                                                        />
                                                        {testReportErrors.runout_control_ring?.radial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.runout_control_ring.radial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Axial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.runout_control_ring?.axial || ''}
                                                            onChange={(e) => handleTestReportChange('runout_control_ring.axial', e.target.value)}
                                                        />
                                                        {testReportErrors.runout_control_ring?.axial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.runout_control_ring.axial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}

                                            {/* --- Case 3: Collet Fixture – Ring Type --- */}
                                            {testReport.selected_case.startsWith('Case 3') && (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Fixture
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className="dialog-input-label">Radial Runout on Collet Location Taper (µm) </label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.radial_collet_location_taper || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'radial_collet_location_taper',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.radial_collet_location_taper && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.radial_collet_location_taper}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Control Ring/KL Master
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.control_ring_kl_master_radial || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'control_ring_kl_master_radial',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.control_ring_kl_master_radial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.control_ring_kl_master_radial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Axial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.control_ring_kl_master_axial || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'control_ring_kl_master_axial',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.control_ring_kl_master_axial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.control_ring_kl_master_axial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}

                                            {/* --- Case 4: Collet Fixture – Shaft Type --- */}
                                            {testReport.selected_case.startsWith('Case 4') && (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Fixture
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout on Collet Location Taper (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.radial_collet_location_taper || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'radial_collet_location_taper',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.radial_collet_location_taper && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.radial_collet_location_taper}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout on Bottom Center (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.radial_bottom_center || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'radial_bottom_center',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.radial_bottom_center && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.radial_bottom_center}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Control Arbor/KL Master
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.control_arbor_kl_master_radial || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'control_arbor_kl_master_radial',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.control_arbor_kl_master_radial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.control_arbor_kl_master_radial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Axial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.control_arbor_kl_master_axial || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'control_arbor_kl_master_axial',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.control_arbor_kl_master_axial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.control_arbor_kl_master_axial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}

                                            {/* --- Case 5: Friction cone Fixture – Shaft Type --- */}
                                            {testReport.selected_case.startsWith('Case 5') && (
                                                <>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Fixture
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <label className="dialog-input-label">Radial Runout on Friction Cone (µm) </label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={testReport.radial_friction_cone || ''}
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'radial_friction_cone',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.radial_friction_cone && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.radial_friction_cone}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="subtitle1" className="bom-dialog-section-header">
                                                            Runout on Control Arbor/KL Master
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Radial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={
                                                                testReport.control_arbor_kl_master_radial || ''
                                                            }
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'control_arbor_kl_master_radial',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.control_arbor_kl_master_radial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.control_arbor_kl_master_radial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <label className="dialog-input-label">Axial Runout (µm) <span className="text-danger">*</span></label>
                                                        <input
                                                            type="number"
                                                            step="any"
                                                            className="form-control-customer bom-input"
                                                            value={
                                                                testReport.control_arbor_kl_master_axial || ''
                                                            }
                                                            onChange={(e) =>
                                                                handleTestReportChange(
                                                                    'control_arbor_kl_master_axial',
                                                                    e.target.value
                                                                )
                                                            }
                                                        />
                                                        {testReportErrors.control_arbor_kl_master_axial && (
                                                            <span className="text-danger" style={{ fontSize: '12px', display: 'block' }}>
                                                                {testReportErrors.control_arbor_kl_master_axial}
                                                            </span>
                                                        )}
                                                    </Grid>
                                                </>
                                            )}
                                        </>
                                    )}

                                    {!testReport.selected_case && (
                                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1rem' }}>
                                                Select a test report case to see the required fields.
                                            </Typography>
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>

                            {/* === RIGHT SIDE: Image === */}
                            <Grid item xs={12} md={4}>
                                {testReport.selected_case && testReport.selected_case !== 'Special Case' && (
                                    (() => {
                                        const imageSrc = caseImageMap[testReport.selected_case];
                                        console.log("Image Source:", imageSrc);
                                        if (imageSrc) {
                                            return (
                                                <Box 
                                                    sx={{
                                                        position: 'sticky', 
                                                        top: 8,
                                                    }}
                                                >
                                                    <Box sx={{
                                                        position: 'absolute', 
                                                        top: 8,    
                                                        right: 8,   
                                                        zIndex: 10,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 0.1,
                                                        backgroundColor: 'white',
                                                        borderRadius: 1,
                                                        p: 0.5
                                                    }}>
                                                        <IconButton onClick={handleZoomIn} size="small" title="Zoom In (Scroll Up)">
                                                            <ZoomInIcon />
                                                        </IconButton>
                                                        <IconButton onClick={handleZoomReset} size="small" title="Reset Zoom">
                                                            <RestartAltIcon />
                                                        </IconButton>
                                                        <IconButton onClick={handleZoomOut} size="small" title="Zoom Out (Scroll Down)">
                                                            <ZoomOutIcon />
                                                        </IconButton>
                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            p: 1.5,
                                                            border: '1px dashed #ccc',
                                                            borderRadius: 2,
                                                            backgroundColor: '#fff',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'flex-start',
                                                            overflow: 'auto',    
                                                            maxHeight: 450,    

                                                            
                                                            scrollbarWidth: 'thin',
                                                            scrollbarColor: '#aaa #f1f1f1',

                                                            '&::-webkit-scrollbar': {
                                                                width: '4px', 
                                                                height: '4px',
                                                            },
                                                            '&::-webkit-scrollbar-track': {
                                                                backgroundColor: '#f1f1f1', 
                                                                borderRadius: '3px',
                                                            },
                                                            '&::-webkit-scrollbar-thumb': {
                                                                backgroundColor: '#aaa', 
                                                                borderRadius: '3px',
                                                                '&:hover': {
                                                                    backgroundColor: '#888',
                                                                },
                                                            },
                                                        }}
                                                        onWheel={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            if (e.deltaY < 0) {
                                                                handleZoomIn();
                                                            } else {
                                                                handleZoomOut();
                                                            }
                                                        }}
                                                    >
                                                        
                                                        <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500, color: '#444' }}>
                                                            Sample Image
                                                        </Typography>
                                                        
                                                        <img
                                                            src={imageSrc}
                                                            alt={`Sample for ${testReport.selected_case}`}
                                                            style={{
                                                                width: '100%',
                                                                height: 'auto',
                                                                borderRadius: '4px',
                                                                transform: `scale(${imageZoom})`,
                                                                transformOrigin: 'center',
                                                                transition: 'transform 0.1s ease-out',
                                                            }}
                                                        />
                                                    </Box>
                                                </Box> 
                                            );
                                        }
                                        return null;
                                    })()
                                )}
                            </Grid>

                            {/* --- ROW 3: Remarks (Full Width) --- */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" className="bom-dialog-section-header" sx={{borderTop: 'none', mb: 1}}>
                                    Remarks / Comments
                                </Typography>
                                <textarea
                                    className="form-control-customer bom-input"
                                    placeholder="Write a brief testing note or summary…"
                                    rows={6}
                                    style={{ height: '100px' }}
                                    value={testReport.remarks || ''}
                                    onChange={(e) => handleTestReportChange('remarks', e.target.value)}
                                />
                            </Grid>

                            {/* --- ROW 4: Attachments (Full Width) --- */}
                            <Grid item xs={12}>
                                <Typography variant="subtitle1" className="bom-dialog-section-header">
                                    Uploaded Documents
                                </Typography>
                                {Array.isArray(testReport.attachments) && testReport.attachments.length > 0 ? (
                                    <Box className="dialog-chip-container">
                                        {testReport.attachments.map((a, i) => (
                                            <Chip
                                                key={`upl-${i}`}
                                                size="small"
                                                icon={<CloudUploadIcon />}
                                                label={a.file_name || 'file'}
                                                onClick={() => handleBomAttachmentDownload(a.file_url)}
                                                onDelete={canEditTestingAndDispatch ? () => removeBomTestingAttachment(i) : undefined}
                                                deleteIcon={canEditTestingAndDispatch ? <DeleteForeverIcon /> : undefined}
                                                variant="outlined"
                                                sx={{
                                                    maxWidth: 240,
                                                    '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
                                                }}
                                                title={a.file_name || 'file'}
                                            />
                                        ))}
                                    </Box>
                                ) : (
                                    <Typography variant="body2" color="text.secondary">
                                        No documents uploaded yet.
                                    </Typography>
                                )}
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="subtitle1" className="bom-dialog-section-header">
                                    Add New Attachments
                                </Typography>

                                {/* Dropzone */}
                                <Box
                                    className="bom-dropzone"
                                    sx = {{mt : 1.2}}
                                    onDragOver={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                    onDragEnter={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                    }}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        const files = Array.from(e.dataTransfer?.files || []);
                                        if (files.length) setBomTestingFilesDraft((prev) => [...prev, ...files]);
                                    }}
                                >
                                    <Typography variant="body2" className="bom-dropzone-text">
                                        Drag & drop files here, or
                                    </Typography>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        component="label"
                                        startIcon={<CloudUploadIcon />}
                                        disabled={bomUploading}
                                        sx={{ mt: 1 }}
                                    >
                                        Browse Files
                                        <input
                                            type="file"
                                            hidden
                                            multiple
                                            onChange={(e) =>
                                                setBomTestingFilesDraft((prev) => [
                                                    ...prev,
                                                    ...Array.from(e.target.files || []),
                                                ])
                                            }
                                        />
                                    </Button>
                                    <Typography variant="caption" display="block" sx={{ mt: 1 }} color="text.secondary">
                                        Tip: You can select multiple files. Large files may take longer to upload.
                                    </Typography>
                                </Box>

                                {/* Selected (draft) files list */}
                                {bomTestingFilesDraft.length > 0 && (
                                    <Box className="bom-file-list-container">
                                        <List dense>
                                            {bomTestingFilesDraft.map((f, i) => (
                                                <ListItem
                                                    key={`draft-${i}`}
                                                    secondaryAction={
                                                        <Tooltip title="Remove from selection">
                                                            <IconButton
                                                                edge="end"
                                                                onClick={() =>
                                                                    setBomTestingFilesDraft((prev) => prev.filter((_, idx) => idx !== i))
                                                                }
                                                            >
                                                                <DeleteForeverIcon />
                                                            </IconButton>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <ListItemIcon>
                                                        <CloudUploadIcon />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primaryTypographyProps={{ noWrap: true }}
                                                        primary={f.name}
                                                        secondary={formatBytes(f.size)}
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>

                                        {bomUploading && (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                                <LinearProgress
                                                    variant="determinate"
                                                    value={bomUploadPct}
                                                    sx={{ flex: 1, height: 6, borderRadius: 999 }}
                                                />
                                                <Typography variant="caption">{bomUploadPct}%</Typography>
                                                    <Box sx={{ width: '100%', mt: 2 }}>
                                                        <LinearProgress variant="determinate" value={bomUploadPct} />
                                                        <Typography variant="caption" align="center" display="block">
                                                            Uploading Attachments & Generating Report... {bomUploadPct}%
                                                        </Typography>
                                                    </Box>

                                            </Box>
                                        )}
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className="bom-dialog-actions">
                        <Button className="bom-dialog-btn" onClick={closeBomTesting} color="inherit">
                            Cancel
                        </Button>
                        <Box sx={{ flex: 1 }} />
                        
                        <Button
                            className="bom-dialog-btn"
                            variant="outlined"
                            color="error"
                            disabled={bomUploading}
                            onClick={() => handleSaveTestingApproval(false)}
                        >
                            Not Approved
                        </Button>
                        <Button
                            className="bom-dialog-btn"
                            variant="contained"
                            color="success"
                            disabled={bomUploading} // Disable while uploading/saving
                            onClick={() => handleSaveTestingApproval(true)}
                            startIcon={bomUploading ? <CircularProgress size={20} color="inherit" /> : <CheckCircleSharpIcon />}
                        >
                            {bomUploading ? 'Processing...' : 'Approve'}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            </div>
                )
            }

            {/* ================================================================================= */}
            {/* SECTION: COMMERCIAL & LOGISTICS                      */}
            {/* ================================================================================= */}
            
            {hasPermission("bom","commercial_logistics_component") && (showSupplierInvoicePanel || showCommercialPanel || bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH || bomData.current_stage === BOM_STAGES.COMPLETED || bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE) && (
                <div className="row mt-4">
                    <div className="col-12">
                        {/* Section Header */}
                        <div className="bom-table-header">
                            <span className="bom-table-title">Commercials & Logistics</span>
                        </div>

                        {/* ACCORDION 1: INVOICES & COMMERCIALS */}
                        {(showSupplierInvoicePanel || showCommercialPanel) && (
                            <Accordion 
                                defaultExpanded={
                                    // (bomData.current_stage !== BOM_STAGES.TESTING && 
                                    // bomData.current_stage !== BOM_STAGES.DISPATCH && initialUser.user_role !== SUPER_ADMIN) 
                                    false
                                }
                                sx={{ 
                                    mb: 2, 
                                    border: '1px solid #e0e0e0', 
                                    boxShadow: 'none', 
                                    borderRadius: '8px !important',
                                    '&:before': {display: 'none'},
                                    overflow: 'hidden'
                                }}
                            >
                                <AccordionSummary 
                                    expandIcon={<ExpandMoreIcon sx={{ color: '#2d3d42', fontSize: 22 }} />} 
                                    sx={{ 
                                        bgcolor: '#f8f9fa', 
                                        borderBottom: '1px solid #e0e0e0',
                                        minHeight: '48px',
                                        '& .MuiAccordionSummary-content': { margin: '10px 0' }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <DescriptionIcon sx={{ mr: 1.5, fontSize: 20, color: '#2d3d42' }} /> 
                                        <Typography sx={{ 
                                            fontWeight: 600, 
                                            fontSize: '14px', 
                                            color: '#2d3d42', 
                                            fontFamily: '"Source Sans Pro", sans-serif' 
                                        }}>
                                            Invoices & Commercial Details
                                        </Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 3 }}>
                                    
                                    {/* Supplier Panel */}
                                    {showSupplierInvoicePanel && (
                                        <SupplierInvoicePanel 
                                            invoiceData={supplierInvoiceDetails} 
                                            onUpdate={handleSupplierUpdate} 
                                            bomData={bomData}
                                            isReadOnly={supplierPanelReadOnly}
                                        />
                                    )}

                                    {/* Divider if both exist */}
                                    {/* {showSupplierInvoicePanel && showCommercialPanel && (
                                        <div className="bom-divider" style={{ margin: '20px 0' }}></div>
                                    )} */}

                                    {/* Commercial Panel */}
                                    {showCommercialPanel && (
                                        <CommercialInvoicePanel
                                            invoiceData={commercialDetails}
                                            onUpdate={handleCommercialUpdate}
                                            isReadOnly={commercialPanelReadOnly}
                                        />
                                    )}
                                </AccordionDetails>
                            </Accordion>
                        )}

                        {/* ACCORDION 2: FIXTURE LOGISTICS */}
                        {(bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH || bomData.current_stage === BOM_STAGES.COMPLETED) && (
                            <Accordion 
                                defaultExpanded={
                                    false
                                }
                                sx={{ 
                                    mb: 2, 
                                    border: '1px solid #e0e0e0', 
                                    boxShadow: 'none', 
                                    borderRadius: '8px !important',
                                    '&:before': {display: 'none'},
                                    overflow: 'hidden'
                                }}
                            >
                                <AccordionSummary 
                                    expandIcon={<ExpandMoreIcon sx={{ color: '#2d3d42', fontSize: 22 }} />} 
                                    sx={{ 
                                        bgcolor: '#f8f9fa', 
                                        borderBottom: '1px solid #e0e0e0',
                                        minHeight: '48px',
                                        '& .MuiAccordionSummary-content': { margin: '10px 0' }
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <LocalShippingIcon sx={{ mr: 1.5, fontSize: 20, color: '#2d3d42' }} /> 
                                        <Typography sx={{ 
                                            fontWeight: 600, 
                                            fontSize: '14px', 
                                            color: '#2d3d42', 
                                            fontFamily: '"Source Sans Pro", sans-serif' 
                                        }}>
                                            Fixture Logistics & Handover
                                        </Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails sx={{ p: 3 }}>
                                    <div className="row">
                                        
                                        {/* A. Location & Comment Inputs */}
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label d-block bom-label">Fixture Location</label>
                                            <input
                                                className="form-control-customer bom-input"
                                                value={fixtureLocation}
                                                onChange={(e) => setFixtureLocation(e.target.value)}
                                                placeholder="e.g. Rack A-12"
                                                disabled={(initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== MANUFACTURING_ENGINEER) || isGlobalReadOnly}
                                                style={{
                                                backgroundColor:
                                                    ((initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== MANUFACTURING_ENGINEER) || isGlobalReadOnly) ? '#f9f9f9' : '#fff',

                                                color: ((initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== MANUFACTURING_ENGINEER) || isGlobalReadOnly) ? '#666' : '#000'
                                                }}
                                                
                                            />
                                        </div>
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label d-block bom-label">Handover Comment</label>
                                            <input
                                                className="form-control-customer bom-input"
                                                value={(() => {
                                                    if (!bomData.stage_history || bomData.stage_history.length === 0) return '';
                                                    const log = [...bomData.stage_history].reverse().find(l => l.stage === BOM_STAGES.DISPATCH);
                                                    return log?.comment || '';
                                                })()}
                                                disabled={ (initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== MANUFACTURING_ENGINEER) || isGlobalReadOnly}
                                                placeholder="No comments provided"
                                                style={{
                                                    backgroundColor: ((initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== MANUFACTURING_ENGINEER) || isGlobalReadOnly) ? '#f9f9f9' : '#fff',
                                                    color: ((initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== MANUFACTURING_ENGINEER) || isGlobalReadOnly) ? '#666' : '#000'
                                                }}
                                            />
                                        </div>

                                        {/* B. Pre-Dispatch Checklist Table */}
                                        <div className="col-12 mt-2">
                                            <div className="bom-divider"></div>
                                            <Typography variant="subtitle2" sx={{ color: '#2d3d42', fontWeight: 600, mb: 2, fontSize: '15px !important' }}>
                                                Pre-Dispatch Inspection Checklist
                                            </Typography>
                                            
                                            <div>
                                                <Table size="small">
                                                    <TableHead className='approval-history-table'>
                                                        <TableRow>
                                                            <TableCell width="20%">Action</TableCell>
                                                            <TableCell width="60%">Attachments Included</TableCell>
                                                            <TableCell width="20%">Status</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow hover>
                                                            {/* Action Column */}
                                                            <TableCell>
                                                                <Button 
                                                                    className="test-procurement-btn"
                                                                    size="small"
                                                                    variant={isChecklistComplete ? 'contained' : 'outlined'}
                                                                    color={isChecklistComplete ? 'success' : 'primary'}
                                                                    startIcon={<FactCheckIcon />}
                                                                    onClick={() => setIsDispatchChecklistOpen2(true)}
                                                                    disabled={!canEditLogisticsChecklist}
                                                                    sx={{
                                                                        '&.MuiButton-contained': {
                                                                        color: isChecklistComplete ? '#fff !important' : 'inherit',
                                                                        },
                                                                        '& .MuiButton-startIcon': {
                                                                        color: isChecklistComplete ? '#fff !important' : 'inherit',
                                                                        },
                                                                        '& .MuiSvgIcon-root': {
                                                                        color: isChecklistComplete ? '#fff !important' : 'inherit',
                                                                        },

                                                                        '&.MuiButton-outlined': {
                                                                        borderColor: '#2d3d42 !important',
                                                                        color: '#2d3d42 !important',
                                                                        '& .MuiSvgIcon-root': {
                                                                        color: '#2d3d42 !important',
                                                                        }
                                                                        },

                                                                        '&.Mui-disabled': {
                                                                            opacity: 0.5,
                                                                            backgroundColor: isChecklistComplete ? 'success.main' : 'transparent',
                                                                            color: isChecklistComplete ? '#fff !important' : '#2d3d42 !important',
                                                                            borderColor: isChecklistComplete ? 'transparent' : '#2d3d42 !important',
                                                                            '& .MuiSvgIcon-root': {
                                                                                color: isChecklistComplete ? '#fff !important' : '#2d3d42 !important',
                                                                            }
                                                                        }
                                                                    }}
                                                                >
                                                                    {isChecklistComplete ? 'Edit Checklist' : 'Update Checklist'}
                                                                </Button>
                                                            </TableCell>

                                                            {/* Attachments Column */}
                                                            <TableCell>
                                                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                                                                    {finalDispatchChecks.dispatch_checklist_attachments && finalDispatchChecks.dispatch_checklist_attachments.length > 0 ? (
                                                                        finalDispatchChecks.dispatch_checklist_attachments.map((a, i) => (
                                                                            <Chip
                                                                                key={`checklist-file-${i}`}
                                                                                size="small"
                                                                                icon={<CloudUploadIcon />}
                                                                                label={a.file_name || 'file'}
                                                                                onClick={() => handleDispatchAttachmentDownload(a.file_url)}
                                                                                variant="outlined"
                                                                                sx={{ maxWidth: 200 }}
                                                                            />
                                                                        ))
                                                                    ) : (
                                                                        <Typography variant="caption" color="text.secondary">No attachments</Typography>
                                                                    )}
                                                                </Box>
                                                            </TableCell>

                                                            {/* Status Column */}
                                                            <TableCell>
                                                                <Chip
                                                                    size="small"
                                                                    sx={{ fontSize: '10px !important' }}
                                                                    color={isChecklistComplete ? 'success' : 'default'}
                                                                    label={isChecklistComplete ? 'Done' : 'Pending'}
                                                                    variant={isChecklistComplete ? 'filled' : 'outlined'}
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </div>

                                            {/* Disclaimer for Handover Phase */}
                                            {(bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH) && (
                                                <Box sx={{ mt: 2, p: 1.5, bgcolor: '#fff8e1', borderRadius: 1, display: 'flex', alignItems: 'center', border: '1px solid #ffecb3' }}>
                                                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#663c00' }}>
                                                        <strong>Note:</strong> Final Dispatch Details (AWB, Mode of Dispatch, etc.) will be entered when clicking the <strong>"Complete Dispatch"</strong> button at the bottom of the page.
                                                    </Typography>
                                                </Box>
                                            )}
                                        </div>

                                        {/* C. FINAL DISPATCH DETAILS (Visible Only When COMPLETED) */}
                                        {bomData.current_stage === BOM_STAGES.COMPLETED && (
                                            <div className="col-12 mt-4">
                                                <div className="bom-divider"></div>
                                                <Typography sx={{ color: '#2d3d42', fontWeight: 600, mb: 1 , fontSize: '15px !important'}}>
                                                    Final Dispatch Details
                                                    <Chip label="Completed" color="success" size="small" variant="filled" sx={{ml:1, height: 20, fontSize: '10px'}}/>
                                                </Typography>
                                                
                                                <div className="row" style={{ margin: '0' }}>
                                                    {/* 1. Dispatch Date */}
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label d-block bom-label">Dispatch Date</label>
                                                        <input
                                                            type="date"
                                                            className={`form-control-customer bom-input ${initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly ? 'readonly-input' : ''}`}
                                                            value={commercialDetails.dispatch_date ? moment(commercialDetails.dispatch_date).format('YYYY-MM-DD') : ''}
                                                            disabled={initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly}
                                                            onChange={(e) => setCommercialDetails(prev => ({ ...prev, dispatch_date: e.target.value }))}
                                                        />
                                                    </div>

                                                    {/* 2. Dispatch Via */}
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label d-block bom-label">Dispatch Via</label>
                                                        <input
                                                            className={`form-control-customer bom-input ${initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly ? 'readonly-input' : ''}`}
                                                            value={commercialDetails.dispatch_via || ''}
                                                            disabled={initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly}
                                                            onChange={(e) => setCommercialDetails(prev => ({ ...prev, dispatch_via: e.target.value }))}
                                                            placeholder="e.g. Fedex"
                                                        />
                                                    </div>

                                                    {/* 3. AWB Number */}
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label d-block bom-label">AWB Number</label>
                                                        <input
                                                            className={`form-control-customer bom-input ${initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly ? 'readonly-input' : ''}`}
                                                            value={commercialDetails.awb_number || ''}
                                                            disabled={initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly}
                                                            onChange={(e) => setCommercialDetails(prev => ({ ...prev, awb_number: e.target.value }))}
                                                            placeholder="e.g. 123456789"
                                                        />
                                                    </div>

                                                    {/* 4. Mode of Dispatch */}
                                                    <div className="col-md-3 mb-3">
                                                        <label className="form-label d-block bom-label">Mode of Dispatch</label>
                                                        <select
                                                            className={`form-control-customer bom-input ${initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly ? 'readonly-input' : ''}`}
                                                            value={commercialDetails.mode_of_dispatch || ''}
                                                            disabled={initialUser.user_role !== SUPER_ADMIN || isGlobalReadOnly}
                                                            onChange={(e) => setCommercialDetails(prev => ({ ...prev, mode_of_dispatch: e.target.value }))}
                                                        >
                                                            <option value="" disabled>Select Mode</option>
                                                            <option value="Air">Air</option>
                                                            <option value="Road">Road</option>
                                                            <option value="Sea">Sea</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                    </div>
                                </AccordionDetails>
                            </Accordion>
                        )}

                    </div>
                </div>
            )}

             {routeBomId && (bomData.current_stage === BOM_STAGES.VALIDATION) && (
                <div className="row mt-4">
                    <div className="col-12">
                         <div className="bom-table-header">
                            <span className="bom-table-title">Validation & Quality Checks</span>
                        </div>

                        <Accordion 
                            defaultExpanded={
                                //bomData.current_stage === BOM_STAGES.VALIDATION}
                                false
                            }
                            sx={{ 
                                mb: 2, 
                                border: '1px solid #e0e0e0', 
                                boxShadow: 'none', 
                                borderRadius: '8px !important',
                                '&:before': { display: 'none' },
                                overflow: 'hidden'
                            }}
                        >
                            <AccordionSummary 
                                expandIcon={<ExpandMoreIcon sx={{ color: '#2d3d42', fontSize: 22 }} />} 
                                sx={{ 
                                    bgcolor: '#f8f9fa', 
                                    borderBottom: '1px solid #e0e0e0',
                                    minHeight: '48px',
                                    '& .MuiAccordionSummary-content': { margin: '10px 0' }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <FactCheckIcon sx={{ mr: 1.5, fontSize: 20, color: '#2d3d42' }} /> 
                                    <Typography sx={{ 
                                        fontWeight: 600, 
                                        fontSize: '14px', 
                                        color: '#2d3d42', 
                                        fontFamily: '"Source Sans Pro", sans-serif' 
                                    }}>
                                        Fixture Validation Checklist
                                    </Typography>
                                    
                                    {bomData.validation_details?.validation_status === 'DONE' && (
                                        <Chip 
                                            label="Completed" 
                                            color="success" 
                                            size="small" 
                                            sx={{ ml: 2, height: 20, fontSize: '10px' }} 
                                        />
                                    )}
                                    {bomData.validation_details?.validation_status === 'Customer Complaint' && (
                                        <Chip 
                                            label="Issues Reported" 
                                            color="error" 
                                            size="small" 
                                            sx={{ ml: 2, height: 20, fontSize: '10px' }} 
                                        />
                                    )}
                                </Box>
                            </AccordionSummary>
                            <Box
                                sx={{
                                    px: 3,
                                    py: 2,
                                    borderBottom: '1px solid #e0e0e0',
                                    backgroundColor: '#fafafa'
                                }}
                                >
                                <Typography
                                    variant="caption"
                                    sx={{
                                    fontWeight: 600,
                                    color: '#555',
                                    display: 'block',
                                    mb: 1
                                    }}
                                >
                                    Download Documents for Validation
                                </Typography>

                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    {validationDocs.map((doc) => {
                                    const isAvailable = !!doc.file?.file_url;

                                    return (
                                        <Chip
                                        key={doc.key}
                                        size="small"
                                        icon={<DownloadIcon />}
                                        label={doc.label}
                                        clickable={isAvailable}
                                        variant={isAvailable ? 'outlined' : 'filled'}
                                        onClick={
                                            isAvailable
                                            ? () => handleDispatchAttachmentDownload(doc.file.file_url)
                                            : undefined
                                        }
                                        sx={{
                                            maxWidth: 260,
                                            fontSize: '11px',
                                            opacity: isAvailable ? 1 : 0.55,
                                            cursor: isAvailable ? 'pointer' : 'not-allowed',
                                            '& .MuiChip-icon': { mr: 0.5 }
                                        }}
                                        />
                                    );
                                    })}
                                </Box>
                            </Box>
                            <AccordionDetails sx={{ p: 3 }}>
                                <ValidationPanel 
                                    data={bomData.validation_details || {}}
                                    onUpdate={handleValidationUpdate}
                                    commercialDetails={commercialDetails}
                                    onCommercialUpdate={handleCommercialUpdate}
                                    isReadOnly={initialUser.user_role !== SUPER_ADMIN && initialUser.user_role !== SALES}
                                    currentUser={initialUser} 
                                    onComplete={handleCompleteValidationSave}
                                    onReopen={handleReopenValidation}
                                />
                            </AccordionDetails>
                        </Accordion>
                    </div>
                </div>
            )}

            {/* ---- ADD ROW MODAL ---- */}
            <Dialog open={addOpen} onClose={() => setAddOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle className="bom-dialog-title">Add BOM Item</DialogTitle>
                <DialogContent dividers>
                    <div className="row g-3">

                        {/* <div className="col-md-6">
                            
                            <label className="bom-label">
                                Part Name <span className="text-danger">*</span>
                            </label>
                            <input
                                className="form-control-customer bom-input"
                                // value={}
                                // onChange={(e) =>
                                //     setNewItem((s) => ({
                                //         ...s,
                                //         document_number: e.target.value,
                                //     }))
                                // }
                                placeholder="Enter Part Name.."
                            />
                        </div> */}
                        <div className="col-md-6">
                            <label className="bom-label">
                                Document Number <span className="text-danger">*</span>
                            </label>
                            <CreatableSelect
                                placeholder="Select or type a Document No…"
                                options={defaultPartDocOptions} // Use new default list
                                loadOptions={loadDocOptions} // Use new async loader
                                value={(() => {
                                    if (newItem.part_ref) {
                                        const part = parts.find((p) => p._id === newItem.part_ref);
                                        return {
                                            value: newItem.part_ref,
                                            label: part?.document_number || 'N/A',
                                            part_name: part?.part_name || 'Selected',
                                        };
                                    }
                                    if (newItem.new_doc_no_value) {
                                        return {
                                            value: newItem.new_doc_no_value,
                                            label: newItem.new_doc_no_value,
                                        };
                                    }
                                    return null;
                                })()}
                                onChange={(opt) => {
                                    if (opt) {
                                        if (opt.__isNew__) {
                                            setNewItem((s) => ({
                                                ...s,
                                                part_ref: null,
                                                document_number: opt.value,
                                                new_doc_no_value: opt.value,
                                                new_part_name_value: '',
                                            }));
                                        } else {

                                            const autoProcessId = opt.required_standerd_processes || newItem.process_type_id;

                                            const autoMaterial = opt.required_steel_material || newItem.steel_material_description;
                                            const autoODmm = opt.od_mm || newItem.od_mm;
                                            const autoLengthmm = opt.length_mm || newItem.length_mm;

                                            setNewItem((s) => ({
                                                ...s,
                                                part_ref: opt.value,
                                                document_number: opt.label,
                                                new_doc_no_value: '',
                                                new_part_name_value: '',
                                                process_type_id: autoProcessId,
                                                steel_material_description: autoMaterial,
                                                od_mm: autoODmm,
                                                length_mm:autoLengthmm,
                                                finished_material_od_mm : autoODmm,
                                                finished_material_length_mm: autoLengthmm
                                            }));
                                        }
                                    } else {
                                        setNewItem((s) => ({
                                            ...s,
                                            part_ref: null,
                                            document_number: '',
                                            new_doc_no_value: '',
                                            new_part_name_value: '',
                                            process_type_id: null, 
                                            steel_material_description: '',
                                            od_mm: '',
                                            length_mm:''
                                        }));
                                    }
                                }}
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    option: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                }}
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="bom-label">Part Name</label>
                            <input
                                className="form-control-customer bom-input"
                                readOnly={!!newItem.part_ref} 
                                disabled={!!newItem.part_ref} 
                                value={
                                    newItem.part_ref
                                        ? partMap[newItem.part_ref] || 'Loading...'
                                        : newItem.new_doc_no_value 
                                        ? newItem.new_part_name_value 
                                        : '...' 
                                }
                                onChange={(e) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        new_part_name_value: e.target.value,
                                    }))
                                }
                                placeholder={
                                    newItem.new_doc_no_value
                                        ? 'Enter Part Name...'
                                        : 'Will auto-fill from Document No.'
                                }
                            />
                        </div>

                        <div className="col-md-6">
                            <label className="bom-label">
                                Standard Process <span className="text-danger">*</span>
                            </label>
                            <AsyncSelect
                                placeholder="Select process…"
                                cacheOptions
                                defaultOptions={stdProcesses.map(mapProcessToOption)}
                                loadOptions={loadProcessOptions}
                                value={
                                    newItem.process_type_id
                                        ? {
                                              value: newItem.process_type_id,
                                              label:
                                                  stdProcesses.find(
                                                      (p) => p._id === newItem.process_type_id
                                                  )?.process_title || 'Selected',
                                          }
                                        : null
                                }
                                onChange={(opt) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        process_type_id: opt?.value || null,
                                    }))
                                }
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    control: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    option: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                }}
                            />
                        </div>

                        {/* <div className="col-md-3">
                            <label className="bom-label">Steel Material (opt)</label>
                            <input
                                className="form-control-customer bom-input"
                                value={newItem.steel_material_description}
                                onChange={(e) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        steel_material_description: e.target.value,
                                    }))
                                }
                                placeholder="e.g., 31CrMoV9"
                            />
                        </div> */}
                        <div className="col-md-6">
                            <label className="bom-label">Steel Material</label>
                            <Select
                                placeholder="Select..."
                                options={steelMaterialOptions}
                                value={
                                    newItem.steel_material_description
                                        ? {
                                            value: newItem.steel_material_description,
                                            label: newItem.steel_material_description,
                                        }
                                        : null
                                }
                                onChange={(opt) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        steel_material_description: opt?.value || '',
                                    }))
                                }
                                isClearable
                                menuPortalTarget={document.body}
                                menuPosition="fixed"
                                styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 10000 }),
                                    control: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    option: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: 'var(--bom-input-font-size)',
                                    }),
                                }}
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="bom-label">
                                OD (mm) <span className="text-danger">*</span>
                            </label>
                            <input
                                type="number"
                                min={0}
                                className="form-control-customer bom-input"
                                value={newItem?.finished_material_od_mm || newItem.od_mm }
                                onChange={(e) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        finished_material_od_mm: e.target.value,
                                    }))
                                }
                                placeholder="e.g., 85"
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="bom-label">
                                Length (mm) <span className="text-danger">*</span>
                            </label>
                            <input
                                type="number"
                                min={0}
                                className="form-control-customer bom-input"
                                value={newItem?.finished_material_length_mm || newItem.length_mm}
                                onChange={(e) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        finished_material_length_mm: e?.target?.value || newItem.length_mm,
                                    }))
                                }
                                placeholder="e.g., 100"
                            />
                        </div>
                        <div className="col-md-4">
                            <label className="bom-label">
                                Qty <span className="text-danger">*</span>
                            </label>
                            <input
                                type="number"
                                min={1}
                                className="form-control-customer bom-input"
                                value={newItem.quantity}
                                onChange={(e) =>
                                    setNewItem((s) => ({ ...s, quantity: e.target.value }))
                                }
                                placeholder="1"
                            />
                        </div>
                        {/* <div className="col-md-3">
                            <label className="bom-label">Procured?</label>
                            <select
                                className="form-control-customer bom-input"
                                value={newItem.procurement_done ? 'true' : 'false'}
                                onChange={(e) =>
                                    setNewItem((s) => ({
                                        ...s,
                                        procurement_done: e.target.value === 'true',
                                    }))
                                }
                            >
                                <option value="false">No</option>
                                <option value="true">Yes</option>
                            </select>
                        </div> */}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="bom-dialog-btn"
                        onClick={() => setAddOpen(false)}
                        variant="text"
                    >
                        Cancel
                    </Button>
                    <Button onClick={handleAddSave} className="bom-btn-save" variant="contained">
                        Save Item
                    </Button>
                </DialogActions>
            </Dialog>

        {/* <Dialog open={isApprovalDialogOpen} onClose={handleCloseApprovalDialog}>
            <DialogTitle>Design Approval Checklist</DialogTitle>
            <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Please confirm the following items before moving the project to Procurement.
                </Typography>
                {approvalQuestions.map((q) => (
                    <FormControlLabel
                        key={q.key}
                        control={
                            <Checkbox
                                checked={approvalChecks[q.key]}
                                onChange={(e) =>
                                    setApprovalChecks((prev) => ({ ...prev, [q.key]: e.target.checked }))
                                }
                                name={q.key}
                            />
                        }
                        label={q.label}
                    />
                ))}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseApprovalDialog}>Cancel</Button>
                <Button
                    onClick={handleDialogApprove}
                    variant="contained"
                    disabled={!Object.values(approvalChecks).every(Boolean)}
                >
                    Submit & Approve
                </Button>
            </DialogActions>
        </Dialog> */}

        {/* ---- APPROVAL CHECKLIST DIALOG (IMPROVED UI) ---- */}
<Dialog
    className="custom_modal"
    open={isApprovalDialogOpen}
    onClose={handleCloseApprovalDialog}
    maxWidth="md"
    fullWidth
>


    <DialogTitle sx={{ display: 'block' }}>
        <Box className="bom-dialog-title-bar">
            <FactCheckIcon color="primary" sx={{ fontSize: 24 }} />
        <Typography
            variant="h6"
            component="div"
            className="bom-dialog-title-text"
            sx={{ display: 'block' }} 
        >
                Design Approval Checklist
</Typography>
        </Box>
        <Typography variant="body2" className="bom-dialog-subtitle">
            Please confirm the following items are finalized before moving this project to the next stage.
        </Typography>
    </DialogTitle>
    <DialogContent dividers> {/* ==== UPDATED: Removed sx prop ==== */}

        <Paper variant="outlined" sx={{ mt: 1.5, bgcolor: 'background.default' }}>
            <List sx={{ p: 0, '& .MuiListItem-root': { '&:hover': { bgcolor: 'action.hover' } } }}>
                {approvalQuestions.map((q, index) => (
                    <React.Fragment key={q.key}>
                        {typeof q.label === 'string' && (
                            <ListItem
                                button
                                onClick={() =>
                                    setApprovalChecks((prev) => ({ ...prev, [q.key]: !prev[q.key] }))
                                }
                                sx={{ py: 0.5 }}
                            >
                                <ListItemIcon sx={{ minWidth: 40 }}>
                                    <Checkbox
                                        className="checkbox-icon"
                                        edge="start"
                                        checked={approvalChecks[q.key]}
                                        tabIndex={-1}
                                        disableRipple
                                    />
                                </ListItemIcon>
                                <ListItemText primary={q.label} />
                            </ListItem>
                        )}
                        {typeof q.label === 'object' && !q.type && (
                            <Box sx={{ py: 0.5 }}>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemIcon sx={{ minWidth: 40 }} />
                                    <ListItemText
                                        primary={
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                {q.label.main}
                                            </Typography>
                                        }
                                    />
                                </ListItem>
                                <List sx={{ pl: 3, pt: 0, pb: 0, '& .MuiListItem-root': { '&:hover': { bgcolor: 'action.hover' } } }}>
                                    {q.label.sub.map((subPoint, subIndex) => (
                                        <ListItem
                                            key={subIndex}
                                            button
                                            onClick={() =>
                                                setApprovalChecks((prev) => {
                                                    const newSubs = [...prev[q.key].sub];
                                                    newSubs[subIndex] = !newSubs[subIndex];
                                                    return {
                                                        ...prev,
                                                        [q.key]: { sub: newSubs },
                                                    };
                                                })
                                            }
                                            sx={{ py: 0.25 }}
                                        >
                                            <ListItemIcon sx={{ minWidth: 40 }}>
                                                <Checkbox
                                                    className="checkbox-icon"
                                                    edge="start"
                                                    checked={approvalChecks[q.key].sub[subIndex]}
                                                    tabIndex={-1}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText primary={subPoint} />
                                        </ListItem>
                                    ))}
                                </List>
                            </Box>
                        )}
                        
                        {q.type === 'dropdown' && (
                            <Box sx={{ py: 0.5 }}>
                                <ListItem sx={{ py: 0.5 }}>
                                    <ListItemText
                                        primary={
                                            <Typography variant="body1" sx={{ fontWeight: 500 }}>
                                                {q.label.text}
                                            </Typography>
                                        }
                                    />
                                    <Switch
                                        edge="end"
                                        checked={approvalChecks[q.key].isExport}
                                        onChange={(e) =>
                                            setApprovalChecks((prev) => ({
                                                ...prev,
                                                [q.key]: {
                                                    ...prev[q.key],
                                                    isExport: e.target.checked,
                                                },
                                            }))
                                        }
                                    />
                                </ListItem>
                                
                                {approvalChecks[q.key].isExport === true && (
                                    <List sx={{ pl: 3, pt: 0, pb: 0, '& .MuiListItem-root': { '&:hover': { bgcolor: 'action.hover' } } }}>
                                        {q.label.sub.map((subPoint, subIndex) => (
                                            <ListItem
                                                key={subIndex}
                                                button
                                                onClick={() =>
                                                    setApprovalChecks((prev) => {
                                                        const newSubs = [...prev[q.key].sub];
                                                        newSubs[subIndex] = !newSubs[subIndex];
                                                        return {
                                                            ...prev,
                                                            [q.key]: { ...prev[q.key], sub: newSubs },
                                                        };
                                                    })
                                                }
                                                sx={{ py: 0.25 }}
                                            >
                                                <ListItemIcon sx={{ minWidth: 40 }}>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={approvalChecks[q.key].sub[subIndex]}
                                                        tabIndex={-1}
                                                        disableRipple
                                                    />
                                                </ListItemIcon>
                                                <ListItemText primary={subPoint} />
                                            </ListItem>
                                        ))}
                                    </List>
                                )}
                            </Box>
                        )}

                        {index < approvalQuestions.length - 1 && <Divider component="li" />}
                    </React.Fragment>
                ))}
            </List>
        </Paper>
    </DialogContent>
    <DialogActions className="bom-dialog-actions">
        <Button className="bom-dialog-btn" onClick={handleCloseApprovalDialog} color="inherit">
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button
            className="bom-dialog-btn"
            onClick={handleDialogApprove}
            variant="contained"
            color={!areAllChecksComplete() ? 'primary' : 'success'}
            disabled={!areAllChecksComplete()}
            startIcon={<SendIcon />}
            sx={{ minWidth: 180 }}
        >
            Submit & Approve
        </Button>
    </DialogActions>
</Dialog>
<Dialog
    open={isSupplierDialogOpen}
    onClose={() => setSupplierDialogOpen(false)}
    maxWidth="sm"
    fullWidth
>
    <DialogTitle>Select Supplier & Approve</DialogTitle>
    <DialogContent dividers>
        <Typography gutterBottom color="text.secondary" sx={{ mb: 2 }}>
            Select a supplier from the list. This will approve the BOM and move it to the Manufacturing-Execution stage.
        </Typography>
        <Select
            placeholder="Select a supplier..."
            options={supplierUsers.map((user) => {
                const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim();
                const label = fullName || user.username || user.email_id || 'Unknown Supplier';
                
                return {
                    value: user._id,
                    label: label,
                };
            })}
            value={selectedSupplier}
            onChange={setSelectedSupplier}
            isClearable
            menuPortalTarget={document.body}
            styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
        />
    </DialogContent>
    <DialogActions sx={{ p: 2 }}>
        <Button className="bom-dialog-btn" onClick={() => setSupplierDialogOpen(false)} color="inherit">
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button
            className="bom-dialog-btn"
            onClick={handleApproveWithSupplier}
            variant="contained"
            color="success"
            disabled={!selectedSupplier}
            startIcon={<SendIcon />}
        >
            Approve with Supplier
        </Button>
    </DialogActions>
</Dialog>


<Dialog
    open={isDispatchChecklistOpen}
    onClose={() => setIsDispatchChecklistOpen(false)}
    maxWidth="md"
    fullWidth
    className="custom_modal"
>
<DialogTitle sx={{ display: 'block' }}>
        <Box className="bom-dialog-title-bar">
            <FactCheckIcon color="primary" sx={{ fontSize: 24 }} />
        <Typography
            variant="h6"
            component="div"
            className="bom-dialog-title-text"
            sx={{ display: 'block' }} 
        >
    Pre-Dispatch Inspection Checklist  
</Typography>
        </Box>
        <Typography variant="body2" className="bom-dialog-subtitle">
            Please confirm all items are checked before approving for dispatch.
        </Typography>
    </DialogTitle>
    <DialogContent dividers>
        <Grid container spacing={3}>
            {/* Section 1: Documents */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header" sx={{ borderTop: 'none !important' }}> 
                    1. Documents included in packaging box
                </Typography>
                <List sx={{ p: 0, m: 0, pt: 0, '& .MuiListItemText-primary': {fontSize: '12px'}, }} 
                dense>
                    {[
                        'a. Test Report',
                        'b. Packing list',
                        'c. Approved DAP layout',
                    ].map((label, index) => (
                        <ListItem
                            key={`doc-${index}`}
                            button
                            onClick={() =>
                                setDispatchChecks(prev => ({
                                    ...prev,
                                    documents: prev.documents.map((c, i) =>
                                        i === index ? !c : c
                                    ),
                                }))
                            }
                            sx={{ pl: 0, py: 0 }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Checkbox
                                    className="checkbox-icon"
                                    edge="start"
                                    checked={dispatchChecks.documents[index]}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={label} />
                        </ListItem>
                    ))}
                </List>
            </Grid>

            {/* Section 2: Visual Checks */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header">
                    2. Visual Checks
                </Typography>
                <List sx={{ p: 0, m: 0, pt: 0, '& .MuiListItemText-primary': {fontSize: '12px'},}} dense>
                    {[
                        'a. Dent free',
                        'b. No leakages',
                        'c. Rust preventive protection',
                        'd. Parts are packed as per packing list',
                        'e. Packets are kept in designated boxes',
                    ].map((label, index) => (
                        <ListItem
                            key={`vis-${index}`}
                            button
                            onClick={() =>
                                setDispatchChecks(prev => ({
                                    ...prev,
                                    visuals: prev.visuals.map((c, i) =>
                                        i === index ? !c : c
                                    ),
                                }))
                            }
                            sx={{ pl: 0, py: 0 }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Checkbox
                                    className="checkbox-icon"
                                    edge="start"
                                    checked={dispatchChecks.visuals[index]}
                                    tabIndex={-1}
                                    disableRipple
                                />
                            </ListItemIcon>
                            <ListItemText primary={label} />
                        </ListItem>
                    ))}
                </List>
            </Grid>

            {/* Section 3: Remarks */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header">
                    3. Remarks/Comments
                </Typography>
                <TextField
                    label="Remarks/Comments"
                    placeholder="Add any final comments here..."
                    fullWidth
                    multiline
                    minRows={3}
                    value={bomDispatchRemark}
                    onChange={(e) => setBomDispatchRemark(e.target.value)}
                />
            </Grid>

            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header">
                    Uploaded Documents
                </Typography>
                {Array.isArray(bomDispatchAttachments) && bomDispatchAttachments.length > 0 ? (
                    <Box className="dialog-chip-container"> 
                        {bomDispatchAttachments.map((a, i) => (
                            <Chip
                                key={`upl-dispatch-${i}`}
                                size="small"
                                icon={<CloudUploadIcon />}
                                label={a.file_name || 'file'}
                                onClick={() => handleDispatchAttachmentDownload(a.file_url)}
                                onDelete={canEditTestingAndDispatch ? () => removeBomDispatchAttachment(i) : undefined}
                                deleteIcon={canEditTestingAndDispatch ? <DeleteForeverIcon /> : undefined}
                                variant="outlined"
                                sx={{
                                    maxWidth: 240,
                                    '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' },
                                }}
                                title={a.file_name || 'file'}
                            />
                        ))}
                    </Box>
                ) : (
                    <Typography variant="body2" color="text.secondary">
                        No documents uploaded yet.
                    </Typography>
                )}
            </Grid>

            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header">
                    Add New Attachments
                </Typography>

                {/* Selected (draft) files list */}
                {bomDispatchFilesDraft.length > 0 && (
                    <Box className="bom-file-list-container">
                        <List dense>
                            {bomDispatchFilesDraft.map((f, i) => (
                                <ListItem
                                    key={`draft-dispatch-${i}`}
                                    secondaryAction={
                                        <Tooltip title="Remove from selection">
                                            <IconButton
                                                edge="end"
                                                onClick={() =>
                                                    setBomDispatchFilesDraft((prev) => prev.filter((_, idx) => idx !== i))
                                                }
                                            >
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                >
                                    <ListItemIcon><CloudUploadIcon /></ListItemIcon>
                                    <ListItemText
                                        primaryTypographyProps={{ noWrap: true }}
                                        primary={f.name}
                                        secondary={formatBytes(f.size)}
                                    />
                                </ListItem>
                            ))}
                        </List>

                        {/* Upload progress */}
                        {bomDispatchUploading && (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                                <LinearProgress
                                    variant="determinate"
                                    value={bomDispatchUploadPct}
                                    sx={{ flex: 1, height: 6, borderRadius: 999 }}
                                />
                                <Typography variant="caption">{bomDispatchUploadPct}%</Typography>
                            </Box>
                        )}
                    </Box>
                )}

                {/* Dropzone */}
                <Box
                    className="bom-dropzone" 
                    onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onDragEnter={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onDrop={(e) => {
                        e.preventDefault();
                        const files = Array.from(e.dataTransfer?.files || []);
                        if (files.length) setBomDispatchFilesDraft((prev) => [...prev, ...files]);
                    }}
                >
                    <Typography variant="body2" className="bom-dropzone-text">
                        Drag & drop files here, or
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        component="label"
                        startIcon={<CloudUploadIcon />}
                        disabled={bomDispatchUploading}
                        sx={{ mt: 1 }}
                    >
                        Browse Files
                        <input
                            type="file"
                            hidden
                            multiple
                            onChange={(e) =>
                                setBomDispatchFilesDraft((prev) => [
                                    ...prev,
                                    ...Array.from(e.target.files || []),
                                ])
                            }
                        />
                    </Button>
                    <Typography variant="caption" display="block" sx={{ mt: 1 }} color="text.secondary">
                        Tip: You can select multiple files.
                    </Typography>
                </Box>


            </Grid>
        </Grid>
    </DialogContent>
    
    <DialogActions className="bom-dialog-actions">
        <Button
        className="bom-dialog-btn"
            onClick={() => {
                setIsDispatchChecklistOpen(false);
                // setDispatchChecks({
                //     documents: [false, false, false],
                //     visuals: [false, false, false, false, false],
                // });
                setBomDispatchFilesDraft([]); 
            }}
            color="inherit"
        >
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button
            className="bom-dialog-btn"
            variant="outlined"
            color="error"
            disabled={bomDispatchUploading}
            onClick={() => handleSaveDispatchChecklist(false)}
        >
            Not Approved
        </Button>
        <Button
        className="bom-dialog-btn"
            onClick={() => handleSaveDispatchChecklist(true)}
            variant="contained"
            color="success"
            disabled={
                !dispatchChecks.documents.every(Boolean) ||
                !dispatchChecks.visuals.every(Boolean) ||
                bomDispatchUploading
            }
            startIcon={<SendIcon />}
        >
            Approve Dispatch
        </Button>
    </DialogActions>
</Dialog>


{/* ---- STAGE APPROVAL COMMENT DIALOG ---- */}
<Dialog open={isCommentDialogOpen} onClose={() => setIsCommentDialogOpen(false)} maxWidth="sm" fullWidth>
    <DialogTitle>Stage Approval Instructions</DialogTitle>
    <DialogContent dividers>
        <Typography variant="body1" color="text.secondary" gutterBottom>
            You are moving this project to <strong>{pendingNextStage}</strong>. 
            Please add any specific instructions or comments for this stage (Optional).
        </Typography>
        <TextField
            autoFocus
            label="Comments"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={approvalComment}
            onChange={(e) => setApprovalComment(e.target.value)}
            placeholder="e.g., Verified DAP, proceed with procurement..."
            InputLabelProps={{
                shrink: true,
                sx: { 
                    bgcolor: 'background.paper', 
                    padding: '0 8px',           
                }
            }}
        />
    </DialogContent>
    <DialogActions>
        <Button className="bom-dialog-btn" onClick={() => setIsCommentDialogOpen(false)} color="inherit">
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        
        {/* NEW: Skip Button - passes empty string so nothing shows in table */}
        <Button 
            className="bom-dialog-btn"
            onClick={() => {
                setIsCommentDialogOpen(false);
                handleFinalApproval(""); 
            }} 
            color="primary"
        >
            Skip
        </Button>

        <Button 
            className="bom-dialog-btn"
            onClick={() => {
                setIsCommentDialogOpen(false);
                handleFinalApproval(approvalComment); 
            }} 
            variant="contained" 
            color="primary"
            // REMOVED: disabled={!approvalComment.trim()} 
        >
            Confirm & Approve
        </Button>
    </DialogActions>
</Dialog>

{/* [ADD THIS] Fixture Location Dialog */}
<Dialog 
    open={isLocationDialogOpen} 
    onClose={() => setIsLocationDialogOpen(false)} 
    maxWidth="sm" 
    fullWidth
>
    <DialogTitle>
        <Box className="bom-dialog-title-bar">
            <FactCheckIcon color="primary" sx={{ fontSize: 24, mr: 1 }} />
            <Typography variant="h6">Handover to Dispatch</Typography>
        </Box>
    </DialogTitle>
    <DialogContent dividers>
        <Typography variant="body1" color="text.secondary" gutterBottom>
            Please enter the final storage location for the fixture before completing the project.
        </Typography>
        
        <Box sx={{ mt: 2 }}>
            <label className="bom-label">
                Fixture Location <span className="text-danger">*</span>
            </label>
            <TextField
                autoFocus
                fullWidth
                variant="outlined"
                placeholder="e.g., Rack A-12, Warehouse B..."
                value={fixtureLocation}
                onChange={(e) => setFixtureLocation(e.target.value)}
                size="small"
            />
        </Box>

        <Box sx={{ mt: 3 }}>
            <label className="bom-label">Optional Comments</label>
            <TextField
                fullWidth
                multiline
                rows={2}
                variant="outlined"
                placeholder="Any final remarks..."
                value={approvalComment}
                onChange={(e) => setApprovalComment(e.target.value)}
                size="small"
            />
        </Box>
    </DialogContent>
    <DialogActions>
        <Button 
            className="bom-dialog-btn" 
            onClick={() => setIsLocationDialogOpen(false)} 
            color="inherit"
        >
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button 
            className="bom-dialog-btn"
            onClick={() => {
                if (!fixtureLocation.trim()) {
                    ShowToast('Fixture Location is required.', TYPE_FAIL, 2000);
                    return;
                }
                setIsLocationDialogOpen(false);
                // Pass the location and comment to final approval
                handleFinalApproval(approvalComment, fixtureLocation); 
            }} 
            variant="contained" 
            color="primary"
        >
            Confirm & Complete
        </Button>
    </DialogActions>
</Dialog>

{/* finaldispatch checklist dialog */}
<Dialog
    open={isDispatchChecklistOpen2}
    onClose={() => setIsDispatchChecklistOpen2(false)}
    maxWidth="md"
    fullWidth
    className="custom_modal"
>
    <DialogTitle sx={{ display: 'block' }}>
        <Box className="bom-dialog-title-bar">
            <FactCheckIcon color="primary" sx={{ fontSize: 24 }} />
        <Typography
            variant="h6"
            component="div"
            className="bom-dialog-title-text"
            sx={{ display: 'block' }} 
        >
                Final Dispatch Inspection Checksheet
            </Typography>
        </Box>
        <Typography variant="body2" className="bom-dialog-subtitle">
             Please confirm all items are checked before dispatch
        </Typography>
    </DialogTitle>

    <DialogContent dividers>
        <Grid container spacing={3}>
            
            {/* --- 1. DOCUMENTS --- */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header" sx={{ borderTop: 'none !important', fontWeight: 'bold' }}>
                    1. Documents included in the packaging box
                </Typography>
                <List dense>
                    {[
                        { key: 'test_report', label: 'a. Test report' },
                        { key: 'packing_list', label: 'b. Packing list' },
                        { key: 'approved_dap_layout', label: 'c. Approved DAP layout' },
                        { key: 'invoice', label: 'd. Invoice' },
                        { key: 'delivery_challan', label: 'e. Delivery challan' }
                    ].map((item) => (
                        <ListItem 
                            key={item.key} 
                            button 
                            onClick={() => setFinalDispatchChecks(prev => ({
                                ...prev,
                                documents: {
                                    ...prev.documents,
                                    [item.key]: !prev.documents[item.key]
                                }
                            }))}
                            sx={{ py: 0 }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Checkbox
                                    edge="start"
                                    checked={finalDispatchChecks.documents[item.key]}
                                    tabIndex={-1}
                                    disableRipple
                                    className="checkbox-icon"
                                />
                            </ListItemIcon>
                            <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '14px' }} />
                        </ListItem>
                    ))}
                </List>
            </Grid>

            {/* --- 2. VISUAL CHECKS --- */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header" sx={{ fontWeight: 'bold' }}>
                    2. Visual checks for packing
                </Typography>
                <List dense>
                    {[
                        { key: 'correct_box_selection', label: 'a. Correct box selection as per PO' },
                        { key: 'bubble_wrap', label: 'b. Bubble wrap' },
                        { key: 'no_material_contact', label: 'c. No material to material contact' },
                        { key: 'no_loose_movement', label: 'd. No loose movement inside box' },
                        { key: 'packing_strip', label: 'e. Packing strip' }
                    ].map((item) => (
                        <ListItem 
                            key={item.key} 
                            button 
                            onClick={() => setFinalDispatchChecks(prev => ({
                                ...prev,
                                visual_checks: {
                                    ...prev.visual_checks,
                                    [item.key]: !prev.visual_checks[item.key]
                                }
                            }))}
                            sx={{ py: 0 }}
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Checkbox
                                    edge="start"
                                    checked={finalDispatchChecks.visual_checks[item.key]}
                                    tabIndex={-1}
                                    disableRipple
                                    className="checkbox-icon"
                                />
                            </ListItemIcon>
                            <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: '14px' }} />
                        </ListItem>
                    ))}
                </List>
            </Grid>

            {/* --- 3. ATTACHMENTS --- */}
            <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header" sx={{ fontWeight: 'bold' }}>
                    3. Add attachments
                </Typography>
                
                <List dense sx={{ pl: 2, mb: 1 }}>
                    <ListItem sx={{ py: 0 }}><ListItemText primary="a. Snaps - Internal" primaryTypographyProps={{ fontSize: '14px' }} /></ListItem>
                    <ListItem sx={{ py: 0 }}><ListItemText primary="b. Snaps - External" primaryTypographyProps={{ fontSize: '14px' }} /></ListItem>
                </List>

                {/* --- Display Existing Uploaded Files --- */}
                {finalDispatchChecks.dispatch_checklist_attachments && finalDispatchChecks.dispatch_checklist_attachments.length > 0 && (
                    <Box className="dialog-chip-container" sx={{ mt: 1, mb: 2 }}>
                        {finalDispatchChecks.dispatch_checklist_attachments.map((a, i) => (
                            <Chip
                                key={`disp-att-${i}`}
                                label={a.file_name}
                                icon={<CloudUploadIcon />}
                                onClick={() => handleDispatchAttachmentDownload(a.file_url)}
                                onDelete={canEditTestingAndDispatch ? () => removeDispatchChecklistAttachment(i) : undefined}
                                deleteIcon={canEditTestingAndDispatch ? <DeleteForeverIcon /> : undefined}
                                variant="outlined"
                                sx={{ maxWidth: 240 }}
                            />
                        ))}
                    </Box>
                )}

                {/* --- Upload Area --- */}
                <Box
                    className="bom-dropzone"
                    onDragOver={(e) => { e.preventDefault(); e.stopPropagation(); }}
                    onDrop={(e) => {
                        e.preventDefault();
                        const files = Array.from(e.dataTransfer?.files || []);
                        if (files.length) setBomDispatchFilesDraft((prev) => [...prev, ...files]);
                    }}
                    sx={{ mt: 2 }}
                >
                    <Typography variant="body2" className="bom-dropzone-text">
                        Drag & drop files here to add snaps
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        component="label"
                        startIcon={<CloudUploadIcon />}
                        disabled={bomDispatchUploading}
                        sx={{ mt: 1 }}
                    >
                        Browse Files
                        <input
                            type="file"
                            hidden
                            multiple
                            onChange={(e) =>
                                setBomDispatchFilesDraft((prev) => [
                                    ...prev,
                                    ...Array.from(e.target.files || []),
                                ])
                            }
                        />
                    </Button>
                </Box>

                {/* --- Draft Files List --- */}
                {bomDispatchFilesDraft.length > 0 && (
                    <Box className="bom-file-list-container" sx={{ mt: 2 }}>
                        <Typography variant="subtitle2" sx={{ px: 2, pt: 1 }}>Selected Files:</Typography>
                        <List dense>
                            {bomDispatchFilesDraft.map((f, i) => (
                                <ListItem
                                    key={`draft-dispatch-${i}`}
                                    secondaryAction={
                                        <Tooltip title="Remove">
                                            <IconButton edge="end" onClick={() => setBomDispatchFilesDraft(prev => prev.filter((_, idx) => idx !== i))}>
                                                <DeleteForeverIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                >
                                    <ListItemIcon><CloudUploadIcon /></ListItemIcon>
                                    <ListItemText primary={f.name} secondary={formatBytes(f.size)} />
                                </ListItem>
                            ))}
                        </List>

                        {/* --- Progress Bar --- */}
                        {bomDispatchUploading && (
                             <Box sx={{ px: 2, pb: 2 }}>
                                <LinearProgress variant="determinate" value={bomDispatchUploadPct} />
                                <Typography variant="caption" align="center" display="block">{bomDispatchUploadPct}% Uploaded</Typography>
                             </Box>
                        )}
                        
                        {/* --- Trigger Upload Button --- */}
                        {!bomDispatchUploading && (
                            <Box sx={{ px: 2, pb: 2, textAlign: 'right' }}>
                                <Button 
                                    variant="contained" 
                                    size="small" 
                                    onClick={() => uploadDispatchChecklistFiles(bomDispatchFilesDraft)}
                                    startIcon={<CloudUploadIcon />}
                                >
                                    Upload Now
                                </Button>
                            </Box>
                        )}
                    </Box>
                )}
            </Grid>

            {/* --- REMARKS --- */}
            {/* <Grid item xs={12}>
                <Typography variant="subtitle1" className="bom-dialog-section-header">
                    Remarks
                </Typography>
                <TextField
                    placeholder="Any comments regarding dispatch..."
                    fullWidth
                    multiline
                    minRows={2}
                    value={bomDispatchRemark}
                    onChange={(e) => setBomDispatchRemark(e.target.value)}
                />
            </Grid> */}
        </Grid>
    </DialogContent>

    <DialogActions className="bom-dialog-actions">
        <Button className='bom-dialog-btn' onClick={() => setIsDispatchChecklistOpen2(false)} color="inherit">
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        <Button
            className='bom-dialog-btn'
            onClick={handleSaveChecklistDialog}
            variant="contained"
            color="success"
            startIcon={<SendIcon />}
            disabled={bomDispatchUploading || bomDispatchFilesDraft.length > 0} 
        >
            Confirm & Save
        </Button>
    </DialogActions>
</Dialog>



{/* ---- COMPLETE DISPATCH DIALOG ---- */}
<Dialog 
    open={isCompleteDispatchDialogOpen} 
    onClose={() => setIsCompleteDispatchDialogOpen(false)} 
    maxWidth="sm" 
    fullWidth
>
    <DialogTitle>
        <Box className="bom-dialog-title-bar">
            <SendIcon color="primary" sx={{ fontSize: 24, mr: 1 }} />
            <Typography variant="h6">Complete Dispatch</Typography>
        </Box>
    </DialogTitle>
    <DialogContent dividers>
        <Typography variant="body1" color="text.secondary" gutterBottom sx={{mb: 2}}>
            Please enter the final dispatch details to complete this project.
        </Typography>
        
        <Grid container spacing={2}>
            {/* Dispatch Via */}
            <Grid item xs={12} md={6}>
                <label className="bom-label">Dispatch via <span className="text-danger">*</span></label>
                <input
                    className="form-control-customer bom-input"
                    value={commercialDetails.dispatch_via || ''}
                    placeholder="e.g. Fedex / BlueDart"
                    onChange={(e) => setCommercialDetails(prev => ({ ...prev, dispatch_via: e.target.value }))}
                />
            </Grid>

            {/* AWB Number */}
            <Grid item xs={12} md={6}>
                <label className="bom-label">AWB No <span className="text-danger">*</span></label>
                <input
                    className="form-control-customer bom-input"
                    value={commercialDetails.awb_number || ''}
                    placeholder="e.g. 123456789"
                    onChange={(e) => setCommercialDetails(prev => ({ ...prev, awb_number: e.target.value }))}
                />
            </Grid>

            {/* Mode of Dispatch */}
            <Grid item xs={12} md={6}>
                <label className="bom-label">Mode of dispatch <span className="text-danger">*</span></label>
                <FormControl component="fieldset" fullWidth>
                    <RadioGroup
                        row
                        name="mode_of_dispatch"
                        value={commercialDetails.mode_of_dispatch || ''}
                        onChange={(e) => setCommercialDetails(prev => ({ ...prev, mode_of_dispatch: e.target.value }))}
                        sx={{ gap: 3, paddingLeft: 1 }}
                    >
                        {['Air', 'Road', 'Sea'].map((mode) => (
                            <FormControlLabel 
                                key={mode}
                                value={mode} 
                                control={
                                    <Radio 
                                        size="medium" 
                                        sx={{
                                            color: '#2d3d42', 
                                            padding: '5px',
                                            '&.Mui-checked': {color: '#2d3d42'}
                                        }}
                                    />
                                } 
                                label={<span style={{fontSize: '14px', color: '#444'}}>{mode}</span>} 
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
                <label className="bom-label">
                    Dispatch Date <span className="text-danger">*</span>
                </label>
                <input
                    type="date"
                    className="form-control-customer bom-input"
                    // Allow previous dates (no min attribute)
                    value={commercialDetails.dispatch_date}
                    onChange={(e) => setCommercialDetails(prev => ({ 
                        ...prev, 
                        dispatch_date: e.target.value 
                    }))}
                />
            </Grid>
        </Grid>
    </DialogContent>
    <DialogActions>
        {/* 1. Cancel Button */}
        <Button 
            className="bom-dialog-btn" 
            onClick={() => setIsCompleteDispatchDialogOpen(false)} 
            color="inherit"
        >
            Cancel
        </Button>
        <Box sx={{ flex: 1 }} />
        
        {/* 2. Save Button (Updates data, keeps stage) */}
        <Button 
            className="bom-dialog-btn"
            onClick={async (e) => {
                await onUpdate(e);
                setIsCompleteDispatchDialogOpen(false);
            }} 
            variant="outlined" 
            color="primary"
            startIcon={<CloudUploadIcon />}
        >
            Save
        </Button>

        {/* 3. Finish & Complete Button */}
        <Button 
            className="bom-dialog-btn"
            onClick={async (e) => {
                await onUpdate(e);
                setIsCompleteDispatchDialogOpen(false);
                handleFinalApproval("Dispatch Completed"); 
            }} 
            variant="contained" 
            color="success"
            disabled={
                !commercialDetails.dispatch_via || 
                !commercialDetails.awb_number || 
                !commercialDetails.mode_of_dispatch
            }
        >
            Finish & Complete Dispatch
        </Button>
    </DialogActions>
</Dialog>

            {bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH && (
            <div className="row mt-3">
                <div className="col-md-12 d-flex justify-content-end">
                <button
                    type="button"
                    className="cancel_button"
                    onClick={handleZipDocDownload}
                    disabled={isZipDownloading}
                    style={{
                    padding: '6px 14px',
                    fontSize: '12px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    whiteSpace: 'nowrap',
                    backgroundColor: '#fff',
                    border: '1px solid #ccc',
                    width: 'fit-content',
                    }}
                >
                    <DownloadIcon sx={{ mr: 0.5, fontSize: 30 }} />
                    Download All Dispatch Documents
                   
                </button>
                </div>
            </div>
            )}
            <div className="row mt-4 mb-3">
                <div className="col-md-8">
                    <button
                        type="button"
                        className={`brand-button ${isGlobalReadOnly && bomData.current_stage !== BOM_STAGES.VALIDATION ? 'disabled-button' : ''}`}
                        onClick={(e) => (routeBomId ? onUpdate(e) : onSubmit(e))}
                        disabled={isSaving || (isGlobalReadOnly && bomData.current_stage !== BOM_STAGES.VALIDATION)}
                    >
                        {isSaving ? 'Saving...' : (routeBomId ? 'Update' : 'Submit')}
                    </button>
                    {routeBomId && bomData.current_stage === BOM_STAGES.VALIDATION && (initialUser.user_role === SUPER_ADMIN || initialUser.user_role === SALES) && (
                        <>
                            {!bomData.validation_completed ? (
                                <button
                                    type="button"
                                    className="release-to-manufacturing-button m-3"
                                    onClick={handleCompleteValidationClick}
                                    style={{ backgroundColor: '#2e7d32', width: 'auto', minWidth: '180px' }}
                                    disabled={isSaving}
                                >
                                    Complete Validation
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="release-to-manufacturing-button m-3"
                                    onClick={handleReopenValidation}
                                    style={{ backgroundColor: '#d32f2f', width: 'auto', minWidth: '180px' }}
                                    disabled={isSaving}
                                >
                                    Reopen Validation
                                </button>
                            )}
                        </>
                    )}
                    {hasPermission('bom','export_button') && bomData.current_stage === BOM_STAGES.MANUFACTURING_EXECUTION && (
                        <button
                            type="button"
                            className="brand-button-inverse m-3"
                            onClick={handleExportToExcel}
                        >
                            <DownloadIcon sx={{ mr: 0.5, fontSize: '26px !important' }} /> {/* Optional Icon */}
                            Export
                        </button>
                    )}
                    {bomData.current_stage === BOM_STAGES.MANUFACTURING_PLANNING && hasPermission("bom","select_supplier_approve_button") && (
                        <button
                            type="button"
                            className="brand-button-inverse m-3"
                            onClick={() => setSupplierDialogOpen(true)}
                            style={{
                                whiteSpace: 'nowrap',
                                // padding: '0.5rem 1rem',
                                minWidth: 'fit-content',
                            }}
                        >
                            Select Supplier & Approve
                        </button>
                    )}
                    {/* {
                        hasPermission("bom","approve_button") && (initialUser.user_role === MANUFACTURING_ENGINEER ? true : bomData.current_stage !== BOM_STAGES.MANUFACTURING_PLANNING && bomData.current_stage !== BOM_STAGES.MANUFACTURING_EXECUTION) && !(initialUser.user_role === DESIGN_ENGINEER && bomData.current_stage === BOM_STAGES.PROCUREMENT ) &&(
                            <button
                                type="button"
                                className="brand-button-inverse ml-3"
                                onClick={onApproveClick}
                                // disabled={isSaving}
                            >
                                Approve
                            </button>
                        )
                    } */}
                    {
                        hasPermission("bom", "approve_button") && (
                            (
                                (initialUser.user_role === DESIGN_ENGINEER || initialUser.user_role === SUPER_ADMIN) &&
                                bomData.current_stage === BOM_STAGES.DESIGN
                            ) ||
                            (
                                (initialUser.user_role === PROCUREMENT_ENGINEER || initialUser.user_role === SUPER_ADMIN) &&
                                bomData.current_stage === BOM_STAGES.PROCUREMENT
                            ) ||
                            (
                                (initialUser.user_role === MANUFACTURING_ENGINEER || initialUser.user_role === SUPER_ADMIN) &&
                                [
                                    BOM_STAGES.MANUFACTURING_EXECUTION,
                                    BOM_STAGES.TESTING,
                                    BOM_STAGES.DISPATCH
                                ].includes(bomData.current_stage)
                            ) ||
                            (
                                (initialUser.user_role === PROCUREMENT_ENGINEER || initialUser.user_role === SUPER_ADMIN) &&
                                bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE
                            ) ||
                            (
                                (initialUser.user_role === LOGISTIC || initialUser.user_role === SUPER_ADMIN) &&
                                bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH
                            ) ||
                            (
                                (initialUser.user_role === SALES || initialUser.user_role === SUPER_ADMIN) &&
                                bomData.current_stage === BOM_STAGES.COMPLETED
                            )
                        ) && (
                            // <button
                            //     type="button"
                            //     className={`ml-3 ${
                            //         bomData.current_stage === 'Design' 
                            //             ? 'release-to-manufacturing-button' 
                            //             : 'brand-button-inverse'
                            //     }`}
                            //     onClick={onApproveClick}
                            // >
                            //     {bomData.current_stage === 'Design' ? "Release for Manufacturing" : "Approve"}
                            // </button>
                        // <button
                        //     type="button"
                        //     className={`m-3 ${
                        //         bomData.current_stage === 'Design'
                        //             ? 'release-to-manufacturing-button'
                        //             : bomData.current_stage === 'Testing'
                        //             ? 'release-to-manufacturing-button'
                        //             : bomData.current_stage === BOM_STAGES.DISPATCH
                        //             ? 'release-to-manufacturing-button'
                        //             : 'brand-button-inverse'
                        //     }`}
                        //     onClick={onApproveClick}
                        // >
                        //     {bomData.current_stage === 'Design'
                        //         ? "Release for Manufacturing"
                        //         : bomData.current_stage === 'Testing'
                        //         ? "Testing Completed"
                        //         : bomData.current_stage === BOM_STAGES.DISPATCH
                        //         ? "Handover to Dispatch"
                        //         : "Approve"
                        //     }
                        // </button>

                        <button
                            type="button"
                            className={`m-3 ${
                                bomData.current_stage === 'Design'
                                    ? 'release-to-manufacturing-button'
                                    : bomData.current_stage === 'Testing'
                                    ? 'release-to-manufacturing-button'
                                    : bomData.current_stage === BOM_STAGES.DISPATCH
                                    ? 'release-to-manufacturing-button'
                                    : bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE
                                    ? 'release-to-manufacturing-button'
                                    : bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH
                                    ? 'release-to-manufacturing-button'
                                    : bomData.current_stage === BOM_STAGES.COMPLETED
                                    ? 'release-to-manufacturing-button'
                                    : 'brand-button-inverse'
                            }`}
                            onClick={onApproveClick}
                        >
                            {bomData.current_stage === 'Design'
                                ? "Release for Manufacturing"
                                : bomData.current_stage === 'Testing'
                                ? "Testing Completed"
                                : bomData.current_stage === BOM_STAGES.DISPATCH
                                ? "Process Commercials"
                                : bomData.current_stage === BOM_STAGES.COMMERCIAL_CLEARANCE
                                ? "Handover to Dispatch"
                                : bomData.current_stage === BOM_STAGES.HANDOVER_TO_DISPATCH
                                ? "Complete Dispatch"
                                : bomData.current_stage === BOM_STAGES.COMPLETED
                                ? "Move to Validation"
                                : "Approve"
                            }
                        </button>

                        )
                    }
                    <button
                        className="cancel_button m-3"
                        
                        onClick={onCancel}
                        // disabled={isSaving}
                    >
                        Cancel
                    </button>

 
                </div>
            </div>
            <Dialog
                open={poViewOpen}
                onClose={() => setPoViewOpen(false)}
                maxWidth={false}
                fullWidth={false}
                scroll="paper"
                sx={{
                    '& .MuiDialog-container': {
                        alignItems: 'flex-start !important',
                        justifyContent: 'center',
                    },
                    '& .MuiPaper-root': {
                        marginTop: '135px !important',
                    },
                }}
                PaperProps={{
                    sx: {
                        width: '950px',
                        maxWidth: 'calc(100vw - 32px)',
                        borderRadius: '4px',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.35)',
                    },
                }}
            >
                <DialogContent sx={{ p: 0 }}>
                    <div
                        style={{
                            padding: '14px 18px',
                            borderBottom: '1px solid #ddd',
                            position: 'relative',
                            fontSize: '18px',
                            fontWeight: 400,
                            color: '#2d3d42',
                        }}
                    >
                        PO Details

                        <button
                            type="button"
                            onClick={() => setPoViewOpen(false)}
                            style={{
                                position: 'absolute',
                                right: '14px',
                                top: '10px',
                                border: 'none',
                                background: 'transparent',
                                fontSize: '25px',
                                lineHeight: 1,
                                color: '#888',
                                cursor: 'pointer',
                            }}
                        >
                            &times;
                        </button>
                    </div>

                    <div style={{ padding: '14px 32px 36px' }}>
                        {selectedPoDetails && (
                            <div
                                style={{
                                    background: '#f8f9fa',
                                    padding: '10px',
                                    borderRadius: '4px',
                                    border: '1px solid #dee2e6',
                                    minHeight: '170px',
                                }}
                            >
                                <p style={{ marginBottom: '16px' }}>
                                    <b>PO Number:</b> {selectedPoDetails.po_number || '-'}
                                </p>
                                <p style={{ marginBottom: '16px' }}>
                                    <b>Enquiry Number:</b>{' '}
                                    {selectedPoDetails.enquiry_id?.enquiryNumber ||
                                        selectedPoDetails.enquiry_id?.enquiry_number ||
                                        '-'}
                                </p>

                                <p style={{ marginBottom: '16px' }}>
                                    <b>PO Date:</b>{' '}
                                    {selectedPoDetails.po_date
                                        ? moment(selectedPoDetails.po_date).format('DD MMM YYYY')
                                        : '-'}
                                </p>

                                <p style={{ marginBottom: '16px' }}>
                                    <b>PO Value:</b> {selectedPoDetails.po_value || '-'}
                                </p>

                                <p style={{ marginBottom: '16px' }}>
                                    <b>Payment Terms:</b> {selectedPoDetails.payment_terms || '-'}
                                </p>

                                <p style={{ marginBottom: 0 }}>
                                    <b>Delivery Terms:</b> {selectedPoDetails.delivery_terms || '-'}
                                </p>
                            </div>
                        )}
                    </div>
                </DialogContent>
        </Dialog>
        </div>
    );
};

const renderFieldRow = ({ label, required = false, children, error, fieldId }) => (
    <div className="col-md-6 mb-3">
        <label className="form-label d-block bom-label" htmlFor={fieldId}>
            {label} {required && <span className="text-danger">*</span>}
        </label>
        {children}
        {error && <div className="text-danger error-msg mt-1">{error}</div>}
    </div>
);

export default CreateBomPage;
